// // import React, { useState, useEffect, useRef } from 'react';
// // import { useParams } from 'react-router-dom';
// // import axios from 'axios';
// // import html2canvas from 'html2canvas';
// // import jsPDF from 'jspdf';
// // import './InvoiceDisplay.css';

// // const InvoiceDisplay = () => {
// //   const [invoiceData, setInvoiceData] = useState(null);
// //   const [error, setError] = useState(null);
// //   const { id } = useParams();
// //   const invoiceRef = useRef(null);

// //   useEffect(() => {
// //     const fetchInvoice = async () => {
// //       try {
// //         const response = await axios.get(`/invoices/${id}`);
// //         setInvoiceData(response.data);
// //       } catch (error) {
// //         setError(error.response?.data?.message || 'An error occurred while fetching the invoice');
// //       }
// //     };

// //     fetchInvoice();
// //   }, [id]);

// //   const handleDownload = () => {
// //     const input = invoiceRef.current;
// //     html2canvas(input, {
// //       backgroundColor: null,
// //       useCORS: true,
// //       windowHeight: input.scrollHeight
// //     }).then((canvas) => {
// //       const imgData = canvas.toDataURL('image/png');
// //       const pdf = new jsPDF('p', 'mm', 'a4');
// //       const pdfWidth = pdf.internal.pageSize.getWidth();
// //       const pdfHeight = pdf.internal.pageSize.getHeight();
// //       const imgWidth = canvas.width;
// //       const imgHeight = canvas.height;
// //       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
// //       const imgX = (pdfWidth - imgWidth * ratio) / 2;
// //       const imgY = 0;

// //       pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
// //       pdf.save('invoice.pdf');
// //     });
// //   };

// //   if (error) return <div>Error: {error}</div>;
// //   if (!invoiceData) return <div>Loading...</div>;

// //   return (
// //     <div className="invoice-wrapper">
// //       <div className="invoice-form" ref={invoiceRef}>
// //         <div className="header">
// //           <div className="logo">
// //           <img src="/Image/excerpt.png" alt="Excerpt Logo" style={{height:"100px",width:"170px",marginTop:"50px"}} />
// //           </div>
// //           <div className="company-info">
// //             <h3>Excerpt Technologies Pvt Ltd</h3>
// //             <p>B133/1, 2nd Fl, KSSDC ITI Estate, Whitefield Rd,</p>
// //             <p>Mahadevpura Post, Bangalore - 560048</p>
// //             <p>Phone: +91(636) 465 7660, +91 (990) 050 2404</p>
// //             <p>GSTIN: 29AAGCE2327K1ZH</p>
// //             <p>LUT No.: AD291021005439D</p>
// //           </div>
// //       <h2 style={{color:"white", marginTop:"80px"}}>INVOICE</h2>
// //         </div>
// //         {/* <div className="invoice-details">
// //           <div className="left-details">
// //             <p><strong>Invoice:</strong> {invoiceData.invoiceNumber}</p>
// //             <p><strong>Date:</strong> {invoiceData.date}</p>
// //             <p><strong>Terms:</strong> {invoiceData.terms}</p>
// //             <p><strong>Due Date:</strong> {invoiceData.dueDate}</p>
// //           </div>
// //           <div className="right-details">
// //             <div className="bill-to">
// //               <p><strong>Bill To:</strong></p>
// //               <p>{invoiceData.billTo}</p>
// //             </div>
// //             <div className="ship-to">
// //               <p><strong>Ship To:</strong></p>
// //               <p>{invoiceData.shipTo}</p>
// //             </div>
// //           </div>
// //         </div> */}
// //         <div className="invoice-details">
// //   <p><strong>Invoice:</strong> {invoiceData.invoiceNumber}</p>
// //   <p><strong>Date:</strong> {invoiceData.date}</p>
// //   <p><strong>Terms:</strong> {invoiceData.terms}</p>
// //   <p><strong>Due Date:</strong> {invoiceData.dueDate}</p>
// // </div>
// // <div className="address-details">
// //   <div className="bill-to">
// //     <p><strong>Bill To:</strong></p>
// //     <p>{invoiceData.billTo}</p>
// //   </div>
// //   <div className="ship-to">
// //     <p><strong>Ship To:</strong></p>
// //     <p>{invoiceData.shipTo}</p>
// //   </div>
// // </div>
// //         <table>
// //           <thead>
// //             <tr>
// //               <th>Item & Description</th>
// //               <th>Amount</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             <tr className="section-header">
// //               <td colSpan="2">Part A - Website Design and Development</td>
// //             </tr>
// //             {invoiceData.webDesign && (
// //               <tr>
// //                 <td>1. Web design and development</td>
// //                 <td>₹ {invoiceData.webDesign}</td>
// //               </tr>
// //             )}
// //             {invoiceData.sslCertificate && (
// //               <tr>
// //                 <td>2. SSL Certificate</td>
// //                 <td>₹ {invoiceData.sslCertificate}</td>
// //               </tr>
// //             )}
// //             {(invoiceData.webDomain || invoiceData.webHosting) && (
// //               <tr className="section-header">
// //                 <td colSpan="2">Part B - Yearly Maintenance</td>
// //               </tr>
// //             )}
// //             {invoiceData.webDomain && (
// //               <tr>
// //                 <td>3. Web domain charge (Yearly)</td>
// //                 <td>₹ {invoiceData.webDomain}</td>
// //               </tr>
// //             )}
// //             {invoiceData.webHosting && (
// //               <tr>
// //                 <td>4. Web hosting charge (Yearly)</td>
// //                 <td>₹ {invoiceData.webHosting}</td>
// //               </tr>
// //             )}
// //           </tbody>
// //         </table>
// //         <div className="invoice-summary">
// //           <div className="total-in-words">
// //             <p><strong>Total In Words:</strong> {invoiceData.totalInWords}</p>
// //           </div>
// //           <div className="totals">
// //             <p><strong>Sub Total:</strong> ₹ {invoiceData.subTotal}</p>
// //             <p><strong>CGST (9%):</strong> ₹ {invoiceData.cgst}</p>
// //             <p><strong>SGST (9%):</strong> ₹ {invoiceData.sgst}</p>
// //             <p><strong>Total:</strong> ₹ {invoiceData.total}</p>
// //             <p><strong>Balance Due:</strong> ₹ {invoiceData.balanceDue}</p>
// //           </div>
// //         </div>
// //         <div className="thank-you-message">
// //           <p>Thank you for the valuable business! We will always be at your desk to support you.</p>
// //         </div>
// //         <div className="terms-conditions">
// //           <h4>Terms & Conditions</h4>
// //           <p>Full payment is due upon receipt of this invoice. Late payments may incur additional charges or interest as per the applicable laws.</p>
// //         </div>
// //         <div className="authorized-signature">
// //           <p>Authorized Signature</p>
// //         </div>
// //         <div className="bank-details">
// //           <h4>Our Bank Details</h4>
// //           <p>Name: Excerpt Technologies Private Limited</p>
// //           <p>Account Number: 10063739760</p>
// //           <p>Name of Bank: IDFC First Bank</p>
// //           <p>IFSC Code: IDFB0080151</p>
// //           <p>PAN No: AAGCE2327K</p>
// //         </div>
// //         <div className="footer">
// //           <p><a href="https://excerpttech.com">https://excerpttech.com</a> | E-mail: info@excerpttech.com</p>
// //         </div>
// //       </div>
// //       <div className="download-button-container">
// //         <button onClick={handleDownload}>Download Invoice</button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default InvoiceDisplay;





// // import React, { useState, useEffect, useRef } from 'react';
// // import { useParams } from 'react-router-dom';
// // import axios from 'axios';
// // import html2canvas from 'html2canvas';
// // import jsPDF from 'jspdf';
// // import './InvoiceDisplay.css';

// // const InvoiceDisplay = () => {
// //   const [invoiceData, setInvoiceData] = useState(null);
// //   const [error, setError] = useState(null);
// //   const { id } = useParams();
// //   const invoiceRef = useRef(null);

// //   useEffect(() => {
// //     const fetchInvoice = async () => {
// //       try {
// //         const response = await axios.get(`/invoices/${id}`);
// //         setInvoiceData(response.data);
// //       } catch (error) {
// //         setError(error.response?.data?.message || 'An error occurred while fetching the invoice');
// //       }
// //     };

// //     fetchInvoice();
// //   }, [id]);

// //   const handleDownload = () => {
// //     const input = invoiceRef.current;
// //     html2canvas(input, {
// //       backgroundColor: null,
// //       useCORS: true,
// //       windowHeight: input.scrollHeight
// //     }).then((canvas) => {
// //       const imgData = canvas.toDataURL('image/png');
// //       const pdf = new jsPDF('p', 'mm', 'a4');
// //       const pdfWidth = pdf.internal.pageSize.getWidth();
// //       const pdfHeight = pdf.internal.pageSize.getHeight();
// //       const imgWidth = canvas.width;
// //       const imgHeight = canvas.height;
// //       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
// //       const imgX = (pdfWidth - imgWidth * ratio) / 2;
// //       const imgY = 0;

// //       pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
// //       pdf.save('invoice.pdf');
// //     });
// //   };

// //   if (error) return <div>Error: {error}</div>;
// //   if (!invoiceData) return <div>Loading...</div>;

// //   return (
// //     <div className="invoice-display-wrapper" ref={invoiceRef}>
// //       <div className="invoice-display-header">
// //         <div className="invoice-display-logo">
// //           {/* <img src="/Image/excerpt.png" alt="Excerpt Logo" /> */}
// //           <img src="/Image/excerpt.png" alt="Excerpt Logo" style={{height:"80px",width:"170px",marginTop:"50px"}} />
// //         </div>
// //         <div className="invoice-display-company-info">
// //           <h3>Excerpt Technologies Pvt Ltd</h3>
// //           <p>B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,</p>
// //           <p>Mahadevpura Post, Bangalore – 560048</p>
// //           <p>Phone:+91(636) 465 7660, +91 (990) 050 2404</p>
// //           <p>GSTIN: 29AAGCE2327K1ZH</p>
// //           <p>LUT No.: AD291021005439D</p>
// //         </div>
// //         <div className="invoice-display-title">
// //         <h2>INVOICE</h2>
// //         </div>
// //       </div>
// //       <div className="invoice-display-content">
// //         <div className="invoice-display-details">
// //           <p><strong>Invoice:</strong> <span className="field-value">{invoiceData.invoiceNumber}</span></p>
// //           <p><strong>Date:</strong> <span className="field-value">{invoiceData.date}</span></p>
// //           <p><strong>Terms:</strong> <span className="field-value">{invoiceData.terms}</span></p>
// //           <p><strong>Due Date:</strong> <span className="field-value">{invoiceData.dueDate}</span></p>
// //         </div>
// //         <div className="invoice-display-address-details">
// //           <div className="invoice-display-bill-to">
// //             <p><strong>Bill To:</strong></p>
// //             <p>{invoiceData.billTo}</p>
// //           </div>
// //           <div className="invoice-display-ship-to">
// //             <p><strong>Ship To:</strong></p>
// //             <p>{invoiceData.shipTo}</p>
// //           </div>
// //         </div>
// //         <table className="invoice-display-table">
// //           <thead>
// //             <tr>
// //               <th>#</th>
// //               <th style={{ fontSize: "15px", fontWeight: "bold" }}>Item & Description</th>


// //               <th style={{fontSize:"15px"}}>Amount</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {invoiceData.webDesign && (
// //               <tr>
// //                 <td>1</td>
// //                 <td><h6>Web design and development</h6></td>
// //                 <td><h6>₹ {invoiceData.webDesign}</h6></td>
// //               </tr>
// //             )}
// //             {invoiceData.sslCertificate && (
// //               <tr>
// //                 <td>2</td>
// //                 <td><h6> SSL Certificate Installation</h6></td>
// //                 <td><h6>₹ {invoiceData.sslCertificate}</h6></td>
// //               </tr>
// //             )}
// //             {invoiceData.webDomain && (
// //               <tr>
// //                 <td>3</td>
// //                 <td><h6>Web domain charge (Yearly)</h6></td>
// //                 <td><h6>₹ {invoiceData.webDomain}</h6></td>
// //               </tr>
// //             )}
// //             {invoiceData.webHosting && (
// //               <tr>
// //                 <td>4</td>
// //                 <td><h6>Web hosting charge (Yearly)</h6></td>
// //                 <td><h6>₹ {invoiceData.webHosting}</h6></td>
// //               </tr>
// //             )}
// //           </tbody>
// //         </table>
// //         <div className="invoice-display-summary">
// //           <div className="invoice-display-total-in-words">
// //             <p><strong>Total In Words</strong></p>
// //             <p>{invoiceData.totalInWords}</p>
// //           </div>
// //           <div className="invoice-display-totals">
// //             <p><h6><strong>Sub Total</strong> <span>₹ {invoiceData.subTotal}</span></h6></p>
// //             <p><h6><strong>CGST (9%)</strong> <span>₹ {invoiceData.cgst}</span></h6></p>
// //             <p><h6><strong>SGST (9%)</strong> <span>₹ {invoiceData.sgst}</span></h6></p>
// //             <p className="total"><h6><strong>Total</strong> <span>₹ {invoiceData.total}</span></h6></p>
// //           </div>
// //         </div>
// //         <div className="invoice-display-balance-due">
// //           <p><h6><strong>Balance Due</strong> <span>₹ {invoiceData.balanceDue}</span></h6></p>
// //         </div>
// //         <div className="invoice-display-thank-you">
// //           <p>Thank you for the valuable business! We will always be at your desk to support you.</p>
// //         </div>
// //         <div className="invoice-display-signature">
// //           <p>Authorized Signature</p>
// //         </div>
// //         <div className="invoice-display-terms">
// //           <h4>Terms & Conditions</h4>
// //           <p>Full payment is due upon receipt of this invoice. Late payments may incur additional charges or interest as per the applicable laws.</p>
// //         </div>
// //         <div className="invoice-display-bank-details">
// //           <h4>Our Bank Details</h4>
// //           <p>Name: Excerpt Technologies Private Limited</p>
// //           <p>Account Number: 10063739760</p>
// //           <p>Name of Bank: IDFC First Bank</p>
// //           <p>IFSC Code: IDFB0080151</p>
// //           <p>PAN No : AAGCE2327K</p>
// //         </div>
// //       </div>
// //       <div className="invoice-display-footer">
// //         <p><a href="https://excerptech.com">https://excerptech.com</a> | E-mail: info@excerptech.com</p>
// //       </div>
// //       <div className="invoice-display-download-button">
// //         <button onClick={handleDownload}>Download Invoice</button>
// //       </div>
// //     </div>
// //   );
// // };

// // export default InvoiceDisplay;






// // import React, { useState, useEffect, useRef } from 'react';
// // import { useParams } from 'react-router-dom';
// // import axios from 'axios';
// // import html2canvas from 'html2canvas';
// // import jsPDF from 'jspdf';
// // import './InvoiceDisplay.css';

// // const InvoiceDisplay = () => {
// //   const [invoiceData, setInvoiceData] = useState(null);
// //   const [error, setError] = useState(null);
// //   const { id } = useParams();
// //   const invoiceContentRef = useRef(null);

// //   useEffect(() => {
// //     const fetchInvoice = async () => {
// //       try {
// //         const response = await axios.get(`/invoices/${id}`);
// //         setInvoiceData(response.data);
// //       } catch (error) {
// //         setError(error.response?.data?.message || 'An error occurred while fetching the invoice');
// //       }
// //     };

// //     fetchInvoice();
// //   }, [id]);

// //   const handleDownload = () => {
// //     const input = invoiceContentRef.current;

// //     html2canvas(input, {
// //       scale: 2, // higher scale = better quality
// //       useCORS: true,
// //       backgroundColor: '#ffffff' // force white background
// //     }).then((canvas) => {
// //       const imgData = canvas.toDataURL('image/png');
// //       const pdf = new jsPDF('p', 'mm', 'a4');

// //       const pdfWidth = pdf.internal.pageSize.getWidth();
// //       const pdfHeight = pdf.internal.pageSize.getHeight();
// //       const imgWidth = canvas.width;
// //       const imgHeight = canvas.height;
// //       const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);

// //       const imgX = (pdfWidth - imgWidth * ratio) / 2;
// //       const imgY = 0; // margin from top

// //       pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
// //       pdf.save('invoice.pdf');
// //     });
// //   };


// //   if (error) return <div>Error: {error}</div>;
// //   if (!invoiceData) return <div>Loading...</div>;

// //   function convertNumberToWords(amount) {
// //     const words = [
// //       '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
// //       'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
// //       'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
// //       'Seventeen', 'Eighteen', 'Nineteen'
// //     ];
// //     const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

// //     const convert = (num) => {
// //       if (num < 20) return words[num];
// //       if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + words[num % 10] : '');
// //       if (num < 1000) return words[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' and ' + convert(num % 100) : '');
// //       if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + convert(num % 1000) : '');
// //       if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + convert(num % 100000) : '');
// //       return convert(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + convert(num % 10000000) : '');
// //     };

// //     const [whole, decimal] = Number(amount).toFixed(2).split('.');

// //     const inWords = convert(parseInt(whole)) + ' Rupees';
// //     const paisa = parseInt(decimal) ? ' and ' + convert(parseInt(decimal)) + ' Paise' : '';

// //     return inWords + paisa + ' only';
// //   }


// //   return (
// //     <div>
// //       <div
// //         className="invoice-display-wrapper"
// //         style={{
// //           fontFamily: 'Calibri, sans-serif',
// //           width: '794px',
// //           margin: '0 auto',
// //           height: "auto",
// //           backgroundColor: '#ffffff', // correct white background
// //           padding: '20px',
// //           paddingBottom: "5%",
// //           // thicker, visible border
// //           boxSizing: 'border-box'
// //         }}
// //       >

// //         <div className="invoice-content" ref={invoiceContentRef} style={{ padding: "6%" }}>
// //           <>
// //             <div style={{ border: '2px solid #ccc' }}>
// //               <div className="invoice-display-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', paddingBottom: '10px', marginBottom: '10px', marginTop: '0px', fontFamily: 'Calibri, sans-serif' }}>
// //                 {/* Logo Section */}
// //                 <div className="invoice-display-logo">
// //                   <img
// //                     src="/Image/excerpt.png"
// //                     alt="Excerpt Logo"
// //                     style={{ height: '80px', width: '170px', marginTop: '30px' }}
// //                   />
// //                 </div>

// //                 {/* Address and Company Info */}
// //                 <div
// //                   className="invoice-display-company-info"
// //                   style={{
// //                     fontSize: '10px',
// //                     lineHeight: '1',
// //                     fontWeight: '500',
// //                     paddingLeft: '30px',
// //                     paddingRight: '30px',
// //                     flexGrow: 1,
// //                     maxWidth: '500px',
// //                     fontFamily: 'Times New Roman, serif',
// //                     paddingTop: '30px'
// //                   }}
// //                 >
// //                   <h3 style={{ fontSize: '14px', marginBottom: '6px', fontFamily: 'Times New Roman, serif', marginTop: '-45px', lineHeight: '0.8' }}>
// //                     Excerpt Technologies Pvt Ltd
// //                   </h3>
// //                   <p style={{ fontSize: "10px", }}>B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,</p>
// //                   <p style={{ fontSize: "10px", }}>Mahadevpura Post, Bangalore – 560048</p>
// //                   <p style={{ fontSize: "10px", }}>Phone: +91(636) 465 7660, +91 (990) 050 2404</p>
// //                   <p style={{ fontSize: "10px", }}>GSTIN: 29AAGCE2327K1ZH</p>
// //                   <p style={{ fontSize: "10px", }}>LUT No: AD291021005439D</p>
// //                 </div>

// //                 {/* INVOICE Title */}
// //                 <div className="invoice-display-title" style={{ textAlign: 'right', marginTop: '20px', marginLeft: 'auto', fontFamily: 'Calibri' }}>
// //                   <h2 style={{ fontSize: '25px', fontWeight: '200' }}>INVOICE</h2>
// //                 </div>
// //               </div>
// //               <div className="invoice-display-content">
// //               <div
// //   className="invoice-display-details"
// //   style={{
// //     display: 'flex',
// //     width: '100%',
// //     position: 'relative',
// //   }}
// // >
// //   {/* Single Left Column with Right Border */}

// //   <div
// //     style={{
// //       width: '60%',
// //       borderRight: '1px solid #ccc', // Only right border

// //       marginTop: '-30px',


// //       marginLeft: '-60px',
// //     }}
// //   >
// //     {/* Invoice */}
// //     <p
// //       style={{
// //         fontSize: '10px',
// //         margin: '2px 0',
// //         display: 'flex',
// //         justifyContent: 'space-between',
// //         alignItems: 'center',
// //         whiteSpace: 'nowrap',
// //         marginLeft:'50px'
// //       }}
// //     >
// //       <span style={{ fontFamily: 'Verdana, sans-serif', minWidth: '70px',fontWeight:'normal' }}>Invoice</span>
// //       <span style={{ paddingLeft: '20px' }}>
// //         : <strong className="field-value">{invoiceData.invoiceNumber}</strong>
// //       </span>
// //     </p>

// //     {/* Date */}
// //     <p
// //       style={{
// //         fontSize: '10px',
// //         margin: '2px 0',
// //         display: 'flex',
// //         justifyContent: 'space-between',
// //         alignItems: 'center',
// //         whiteSpace: 'nowrap',
// //         marginLeft:'50px'

// //       }}
// //     >
// //       <span style={{ fontFamily: 'Verdana, sans-serif', minWidth: '70px',fontWeight:'normal' }}>Date</span>
// //       <span style={{ paddingLeft: '20px',paddingRight:'25px' }}>
// //         : <strong className="field-value">
// //           {new Date(invoiceData.date).toLocaleDateString('en-GB')}
// //         </strong>
// //       </span>
// //     </p>

// //     {/* Terms */}
// //     <p
// //       style={{
// //         fontSize: '10px',
// //         margin: '2px 0',
// //         display: 'flex',
// //         justifyContent: 'space-between',
// //         alignItems: 'center',
// //         whiteSpace: 'nowrap',
// //         marginLeft:'50px'

// //       }}
// //     >
// //       <span style={{ fontFamily: 'Verdana, sans-serif', minWidth: '70px',fontWeight:'normal' }}>Terms</span>
// //       <span style={{ paddingLeft: '20px' }}>
// //         : <strong className="field-value">{invoiceData.terms}</strong>
// //       </span>
// //     </p>

// //     {/* Due Date */}
// //     <p
// //       style={{
// //         fontSize: '10px',
// //         margin: '2px 0',
// //         display: 'flex',
// //         justifyContent: 'space-between',
// //         alignItems: 'center',
// //         whiteSpace: 'nowrap',
// //         marginLeft:'50px'

// //       }}
// //     >
// //       <span style={{ fontFamily: 'Verdana, sans-serif', minWidth: '70px',fontWeight:'normal' }}>Due Date</span>
// //       <span style={{ paddingLeft: '20px',paddingRight:'50px' }}>
// //         : <strong className="field-value">
// //           {new Date(invoiceData.dueDate).toLocaleDateString('en-GB')}
// //         </strong>
// //       </span>
// //     </p>
// //   </div>
// // </div>




// //                 <div className="invoice-display-address-details" >
// //                   <div className="invoice-display-bill-to" style={{
// //                     width: '100%', // or '60%', '400px', etc.
// //                     display: 'inline-block', // ensures width is respected
// //                   }}>
// //                     <div style={{ width: '120%', borderBottom: '1px solid #ccc', marginLeft: '-10px' }}>
// //                       <p style={{ fontSize: '8px', fontFamily: 'calibri', margin: 0, marginTop: '-13px', marginBottom: '-4px' }}><strong>&nbsp;&nbsp;&nbsp;&nbsp; Bill To</strong></p>
// //                     </div>

// //                    <div
// //   style={{
// //     textAlign: 'left',
// //     fontSize: '10px',
// //     width: '200px', // fixed compact width

// //   }}
// // >
// //   <p style={{ textTransform: 'uppercase',fontSize:'10px' }}>
// //     <strong>{invoiceData.billToName}</strong>
// //   </p>

// //   <p style={{ margin: '2px 0',fontSize:'10px' }}>
// //     {invoiceData.billToAddress}
// //   </p>

// //   <p style={{ margin: '2px 0',fontSize:'10px' }}>
// //     {invoiceData.billToCity}
// //   </p>
// // </div>



// //                   </div>
// //                   <div
// //                     className="invoice-display-ship-to"
// //                     style={{
// //                       width: '100%', // or '60%', '400px', etc.
// //                       display: 'inline-block', // ensures width is respected
// //                     }}
// //                   >
// //                     <div style={{ width: '106%', borderBottom: '1px solid #ccc', marginLeft: '-2.8%' }}>
// //                       <p style={{ fontSize: '8px', margin: 0, marginTop: '-13px', marginBottom: '-4px', fontFamily: 'calibri' }}><strong>&nbsp;&nbsp;&nbsp;&nbsp;Ship To</strong></p>
// //                     </div>
// //                    <div
// //   style={{
// //     textAlign: 'left',
// //     fontSize: '10px',
// //     width: '200px', // fixed compact width
// //     lineHeight: '1.4',
// //   }}
// // >
// //   <p style={{ textTransform: 'uppercase',fontSize:'10px' }}>
// //     <strong>{invoiceData.shipToName}</strong>
// //   </p>

// //   <p style={{ margin: '2px 0',fontSize:'10px' }}>
// //     {invoiceData.shipToAddress}
// //   </p>

// //   <p style={{ margin: '2px 0',fontSize:'10px' }}>
// //     {invoiceData.shipToCity}
// //   </p>
// // </div>


// //                   </div>

// //                 </div>

// //                 <div
// //                   className="invoice-display-table"
// //                   style={{
// //                     display: 'flex',
// //                     flexDirection: 'column',
// //                     width: '106%',
// //                     fontFamily: 'Verdana, Calibri, sans-serif',
// //                     borderTop: '1px solid #ccc',

// //                     marginLeft: '-20px'
// //                   }}
// //                 >
// //                   {/* Header Row */}
// //                   <div
// //                     style={{
// //                       display: 'flex',
// //                       borderBottom: '1px solid #ccc',
// //                       fontWeight: 'bold',
// //                       fontSize: '12px',
// //                       backgroundColor: '#f2f2f2'
// //                     }}
// //                   >
// //                     <div style={{ width: '5%', borderRight: '1px solid #ccc', borderLeft: 'none' }}></div>
// //                     <div style={{ width: '75%', borderRight: '1px solid #ccc', padding: '4px' }}>Item & Description</div>
// //                     <div style={{ width: '20%', textalign: 'right', padding: '4px', borderLeft: '1px solid #000', borderRight: 'none' }}>Amount</div>
// //                   </div>

// //                   {/* Content Rows */}
// //                   {invoiceData.parts?.map((part, partIndex) => (
// //                     <React.Fragment key={partIndex}>
// //                       {/* Part Title Row */}
// //                       <div
// //                         style={{
// //                            fontSize:'12px',
// //                           display: 'flex',
// //                           borderBottom: '1px solid #ccc',
// //                           backgroundColor: '#f9f9f9',
// //                           fontWeight: 'bold'

// //                         }}
// //                       >
// //                         <div style={{ width: '100%', padding: '4px' }}>{part.title}</div>
// //                       </div>

// //                       {/* Item Rows */}
// //                       {part.items.map((item, itemIndex) => (
// //                         <div
// //                           key={itemIndex}
// //                           style={{
// //                             display: 'flex',
// //                             borderBottom: '1px solid #ccc'
// //                           }}
// //                         >
// //                           <div style={{ width: '5%',fontSize:'12px',borderRight: '1px solid #ccc', padding: '4px' }}>
// //                             {itemIndex + 1}
// //                           </div>
// //                           <div style={{ width: '75%',fontSize:'12px' , borderRight: '1px solid #ccc', padding: '4px'}}>
// //                             {item.description}
// //                           </div>
// //                           <div
// //                             style={{
// //                               width: '20%',
// //                               textalign: 'right',
// //                               padding: '4px',
// //                               fontWeight: 'bold',
// //                               fontSize:'12px'
// //                             }}
// //                           >
// //                             ₹ {parseFloat(item.amount).toFixed(2)}
// //                           </div>
// //                         </div>
// //                       ))}
// //                     </React.Fragment>
// //                   ))}
// //                 </div>


// //                 <div className="invoice-display-summary">
// //                   <div className="">
// //                     <p style={{ fontSize: '12px' }}>Total In Words</p>
// //                     <div style={{ fontWeight: 'bold', fontSize: '10px', fontStyle: 'italic' }}>
// //                       {convertNumberToWords(invoiceData.total)}
// //                     </div>
// //                     {/* <p>{invoiceData.totalInWords}</p> */}
// //                   </div>

// //                   {/* One box with totals and signature inside */}
// //                   <div
// //                     style={{
// //                       border: '1px solid #ccc',
// //                       borderTopWidth: '0px',   // Force top border to 0
// //                       borderTopStyle: 'none',  // Ensure it's not styled
// //                       padding: '10px',
// //                       width: '45%',
// //                       marginTop: '-20px',
// //                       marginRight:'-20px',
// //                       borderRight:'none'

// //                     }}
// //                   >
// //                     <div className="summary-row">
// //                       <span className="label1">Sub Total</span>
// //                       <span className="value1">₹ {String(invoiceData.subTotal).split('').join(' ')}</span>
// //                     </div>
// //                     <div className="summary-row">
// //                       <span className="label1" >CGST ({invoiceData.cgstRate || 0}%)</span>
// //                       <span className="value"style={{fontSize:'12px',marginRight:'12px'}}>₹ {String(invoiceData.cgst?.toFixed(2) || '0.00').split('').join(' ')}</span>
// //                     </div>
// //                     <div className="summary-row">
// //                       <span className="label1" >SGST ({invoiceData.sgstRate || 0}%)</span>
// //                       <span className="value" style={{fontSize:'12px',marginRight:'10px'}}>₹ {String(invoiceData.sgst?.toFixed(2) || '0.00').split('').join(' ')}</span>
// //                     </div>
// //                     <div className="summary-row total-row">
// //                       <span className="label" style={{ fontWeight: 'bold', fontFamily: 'calibri', fontSize: '12px' }}>Total</span>
// //                       <span className="value" style={{ marginRight:'12px',fontWeight: 'bold',fontSize:'12px' }}>₹ {String(invoiceData.total).split('').join(' ')}</span>
// //                     </div>
// //                     <div className="summary-row balance-due-row">
// //                       <span className="label" style={{ fontWeight: 'bold',fontSize:'12px' }}>Balance Due</span>
// //                       <span className="value" style={{ marginRight:'25px' ,fontWeight: 'bold',fontSize:'12px'}}>₹ {String(invoiceData.balanceDue).split('').join(' ')}</span>
// //                     </div>


// //                     {/* Signature inside the box */}
// //                     <div style={{ textalign: 'right', marginLeft: '-10px', borderTop: '1px solid #ccc', marginTop: '20px', width: '304px', paddingTop: '5px', fontWeight: 'bold', fontSize: '12px' }}>

// //                     </div>
// //                     <div style={{ textalign: 'right', marginLeft: '-10px', marginTop: '100px', width: '456px', paddingTop: '5px', paddingRight: '150px', fontFamily: 'calibri', fontSize: '10px' }}>
// //                       Authorized Signature
// //                     </div>
// //                   </div>
// //                 </div>


// //                 <div style={{ textAlign: 'left', marginTop: '-190px', fontSize: '8px' }}>
// //                   <p className="invoice-display-thank-you">Thank you for the valuable business! We will always be at your desk <br />to support you.</p>
// //                 </div>



// //                 <div
// //                   className="invoice-display-terms"
// //                   style={{ textAlign: 'left', marginTop: '10px', fontSize: '10px', fontWeight: 'normal' }}
// //                 >
// //                   <h4 style={{ fontSize: '8px', fontWeight: 'normal', marginBottom: '6px' }}>
// //                     Terms & Conditions
// //                   </h4>
// //                   <p style={{ fontSize: '8px', fontWeight: 'normal', lineHeight: '1.5' }}>
// //                     Full payment is due upon receipt of this invoice.
// //                     Late <br />payments may incur additional
// //                     charges or interest as <br />per the applicable laws.
// //                   </p>
// //                 </div>


// //                 <div
// //                   className="invoice-display-bank-details"
// //                   style={{ textAlign: 'left', marginTop: '90px', fontSize: '10px',marginBottom:'35px' }}
// //                 >
// //                   <h5 style={{ color: '#5bc0de', fontSize: '12px', marginTop: '20px', marginBottom: '4px' }}>
// //                     Our Bank Details
// //                   </h5>

// //                   <div style={{ fontSize: '10px', }}>
// //                     <p style={{  fontSize: '10px',lineHeight:'0.8' }}><strong>Name: Excerpt Technologies Private Limited</strong></p>
// //                     <p style={{  fontSize: '10px',lineHeight:'0.8' }}>Account Number: 10063739760</p>
// //                     <p style={{  fontSize: '10px',lineHeight:'0.8' }}>Name of Bank: IDFC First Bank</p>
// //                     <p style={{  fontSize: '10px',lineHeight:'0.8' }}>IFSC Code: IDFB0080151</p>
// //                     <p style={{  fontSize: '10px',lineHeight:'0.8' }}>PAN No: AAGCE2327K</p>
// //                   </div>
// //                 </div>


// //                 <div className="invoice-display-qr-wrapper">
// //                   <div
// //                     className="invoice-display-qr-box"
// //                     style={{ textAlign: 'right', marginTop: '-150px' }}
// //                   >
// //                     <img
// //                       src="/images/nn.png"
// //                       alt="PhonePe QR"
// //                       className="phonepe-qr-img"
// //                       style={{ width: '100px', height: '100px' }}
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //             <div className="invoice-display-footer">
// //               <span className="footer-left">
// //                 <a href="https://excerptech.com">https://excerptech.com</a>
// //               </span>
// //               <span className="footer-right">
// //                 E-mail: info@excerptech.com
// //               </span>
// //             </div>

// //           </>
// //         </div>

// //         <div className="invoice-display-download-button">
// //           <button onClick={handleDownload}>Download Invoice</button>
// //         </div>
// //       </div></div>
// //   );
// // };

// // export default InvoiceDisplay;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import jsPDF from 'jspdf';
// import './InvoiceList.css';
// import InvoiceComponent from './InvoiceComponent';
// import { notoSansBase64 } from './notosans';
// import { verdanaFont } from './verdant';
// import { verdanaboldFont } from './verdanbold';


// import autoTable from 'jspdf-autotable';
// const InvoiceList = () => {
//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [downloading, setDownloading] = useState(null);

//   useEffect(() => {
//     fetchInvoices();
//   }, []);

//   const fetchInvoices = async () => {
//     try {
//       const response = await axios.get('/invoices');
//       setInvoices(response.data);
//       setLoading(false);
//     } catch (error) {
//       setError(error.response?.data?.message || 'Error fetching invoices');
//       setLoading(false);
//     }
//   };


// const convertNumberToWords = (amount) => {
//   const words = [
//     '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
//     'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
//     'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
//     'Seventeen', 'Eighteen', 'Nineteen'
//   ];
//   const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

//   const convert = (num) => {
//     if (num < 20) return words[num];
//     if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + words[num % 10] : '');
//     if (num < 1000) return words[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' and ' + convert(num % 100) : '');
//     if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + convert(num % 1000) : '');
//     if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + convert(num % 100000) : '');
//     return convert(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + convert(num % 10000000) : '');
//   };

//   const [whole, decimal] = Number(amount).toFixed(2).split('.');
//   const inWords = convert(parseInt(whole)) + ' Rupees';
//   const paisa = parseInt(decimal) ? ' and ' + convert(parseInt(decimal)) + ' Paise' : '';
//   return inWords + paisa + ' only';
// };

// const formatDate = (dateString) => {
//   return new Date(dateString).toLocaleDateString('en-GB');
// };

// const formatCurrency = (amount) => {
//   return `₹ ${parseFloat(amount).toFixed(2)}`;
// };

// ;



// // Paste your base64 logo here


// // const downloadInvoicePDF = async (invoice) => {
// //   try {
// //     setDownloading(invoice._id);

// //     const pdf = new jsPDF('p', 'mm', 'a4');
// //     const pageWidth = pdf.internal.pageSize.getWidth();
// //     const pageHeight = pdf.internal.pageSize.getHeight();

// //     // Add custom fonts
// //     pdf.addFileToVFS('Verdana.ttf', verdanaFont);
// //     pdf.addFont('Verdana.ttf', 'Verdana', 'normal');

// //     pdf.addFileToVFS('Verdana-Bold.ttf', verdanaboldFont);
// //     pdf.addFont('Verdana-Bold.ttf', 'Verdana', 'bold');

// //     pdf.addFileToVFS('NotoSans.ttf', notoSansBase64);
// //     pdf.addFont('NotoSans.ttf', 'NotoSans', 'normal');

// //     let currentY = 20;

// //     // Header Section with Blue Background - exact match
// //     pdf.setFillColor(59, 130, 246); // Blue color
// //     pdf.rect(0, 0, pageWidth, 35, 'F');

// //     // Add company logo on the left
// //     try {
// //       const logoImg = './image/112.png';
// //       pdf.addImage(logoImg, 'JPEG', 12, 3, 40, 25);
// //     } catch (error) {
// //       console.log('Logo not found, using text instead');
// //       // Fallback to text logo
// //       pdf.setTextColor(255, 255, 255);
// //       pdf.setFontSize(20);
// //       pdf.setFont('Verdana', 'bold');
// //       pdf.text('Excerpt', 12, 25);
// //     }

// //     // Company Details in Header - centered
// //     pdf.setTextColor(255, 255, 255);
// //     pdf.setFontSize(14);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Excerpt Technologies Pvt Ltd', pageWidth/2, 10, { align: 'right' });

// //     pdf.setFontSize(8);
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', pageWidth/2, 16, { align: 'right' });
// //     pdf.text('Mahadevpura Post, Bangalore – 560048', pageWidth/2, 20, { align: 'right' });
// //     pdf.text('Phone: +91(636) 465 7660, +91 (990) 050 2404', pageWidth/2, 24, { align: 'right' });
// //     pdf.text('GSTIN: 29AAGCE2327K1ZH', pageWidth/2, 29, { align: 'right' });
// //     pdf.text('LUT No: AD291021005439D', pageWidth/2, 33, { align: 'right' });

// //     // INVOICE label - white box on right
// //     // pdf.setFillColor(255, 255, 255);
// //     // pdf.rect(pageWidth - 50, 15, 40, 15, 'F');
// // pdf.setTextColor(255, 255, 255);

// //     pdf.setFontSize(17);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('INVOICE', pageWidth - 38, 33);

// //     // Reset to black text
// //     pdf.setTextColor(0, 0, 0);
// //     currentY = 35.5;

// //     // Main content area with border
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.setLineWidth(0.5);
// //     pdf.rect(10, currentY, pageWidth - 20, pageHeight - currentY - 20);

// //     // Invoice details section
// //     currentY += 7;
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'normal');

// //     // Left column - Invoice details
// //     pdf.text('Invoice:', 15, currentY);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(invoice.invoiceNumber, 35, currentY);

// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Date:', 15, currentY + 6);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(formatDate(invoice.date), 35, currentY + 6);

// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Terms:', 15, currentY + 12);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(invoice.terms, 35, currentY + 12);

// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Due Date:', 15, currentY + 18);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(formatDate(invoice.dueDate), 35, currentY + 18);

// //     currentY += 25;

// //     // Bill To and Ship To sections with borders
// //     const billToX = 15;
// //     const shipToX = 110;
// //     const sectionWidth = 90;
// //     const sectionHeight = 50;

// //     // Draw borders for Bill To and Ship To sections
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.setLineWidth(0.5);

// //     // Bill To border
// //     pdf.rect(billToX, currentY, sectionWidth, sectionHeight);

// //     // Ship To border  
// //     pdf.rect(shipToX, currentY, sectionWidth, sectionHeight);

// //     // Headers with background
// //     pdf.setFillColor(240, 240, 240);
// //     pdf.rect(billToX, currentY, sectionWidth, 8, 'F');
// //     pdf.rect(shipToX, currentY, sectionWidth, 8, 'F');

// //     // Header borders
// //     pdf.line(billToX, currentY + 8, billToX + sectionWidth, currentY + 8);
// //     pdf.line(shipToX, currentY + 8, shipToX + sectionWidth, currentY + 8);

// //     pdf.setFontSize(10);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Bill To:', billToX + 3, currentY + 6);
// //     pdf.text('Ship To:', shipToX + 3, currentY + 6);

// //     currentY += 12;

// //     // Names in bold
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(invoice.billToName.toUpperCase(), billToX + 3, currentY);
// //     pdf.text(invoice.shipToName.toUpperCase(), shipToX + 3, currentY);

// //     currentY += 6;

// //     // Addresses
// //     pdf.setFont('Verdana', 'normal');
// //     const billToLines = invoice.billToAddress.split('\n');
// //     const shipToLines = invoice.shipToAddress.split('\n');

// //     const maxLines = Math.max(billToLines.length, shipToLines.length);

// //     for (let i = 0; i < maxLines; i++) {
// //       if (billToLines[i]) {
// //         pdf.text(billToLines[i], billToX + 3, currentY);
// //       }
// //       if (shipToLines[i]) {
// //         pdf.text(shipToLines[i], shipToX + 3, currentY);
// //       }
// //       currentY += 4;
// //     }

// //     // Cities
// //     if (invoice.billToCity) {
// //       pdf.text(invoice.billToCity, billToX + 3, currentY);
// //     }
// //     if (invoice.shipToCity) {
// //       pdf.text(invoice.shipToCity, shipToX + 3, currentY);
// //     }

// //     currentY += 20;

// //     // Items table
// //     const tableStartY = currentY;
// //     const tableStartX = 15;
// //     const tableWidth = pageWidth - 30;
// //     const descriptionWidth = tableWidth - 50;
// //     const amountWidth = 50;

// //     // Table header
// //     pdf.setFillColor(230, 230, 230);
// //     pdf.rect(tableStartX, tableStartY, tableWidth, 12, 'F');
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.rect(tableStartX, tableStartY, tableWidth, 12);
// //     pdf.rect(tableStartX, tableStartY, descriptionWidth, 12);
// //     pdf.rect(tableStartX + descriptionWidth, tableStartY, amountWidth, 12);

// //     pdf.setFontSize(10);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Items & Description', tableStartX + 5, tableStartY + 8);
// //     pdf.text('Amount', tableStartX + descriptionWidth + 15, tableStartY + 8);

// //     currentY = tableStartY + 12;

// //     // Table rows
// //     let rowHeight = 0;
// //     if (invoice.parts) {
// //       invoice.parts.forEach((part, partIndex) => {
// //         // Part title row
// //         pdf.setFillColor(250, 250, 250);
// //         pdf.rect(tableStartX, currentY, tableWidth, 8, 'F');
// //         pdf.rect(tableStartX, currentY, descriptionWidth, 8);
// //         pdf.rect(tableStartX + descriptionWidth, currentY, amountWidth, 8);

// //         pdf.setFontSize(9);
// //         pdf.setFont('Verdana', 'bold');
// //         pdf.text(part.title, tableStartX + 5, currentY + 6);

// //         currentY += 8;

// //         // Part items
// //         part.items.forEach((item, itemIndex) => {
// //           const itemRowHeight = 8;

// //           // Row background
// //           pdf.setFillColor(255, 255, 255);
// //           pdf.rect(tableStartX, currentY, tableWidth, itemRowHeight, 'F');
// //           pdf.rect(tableStartX, currentY, descriptionWidth, itemRowHeight);
// //           pdf.rect(tableStartX + descriptionWidth, currentY, amountWidth, itemRowHeight);

// //           pdf.setFont('Verdana', 'normal');
// //           pdf.text(`${itemIndex + 1}. ${item.description}`, tableStartX + 8, currentY + 6);

// //           pdf.setFont('NotoSans', 'normal');
// //           pdf.text(formatCurrency(item.amount), tableStartX + descriptionWidth + 15, currentY + 6);

// //           currentY += itemRowHeight;
// //         });
// //       });
// //     }

// //     // Close table
// //     pdf.line(tableStartX, currentY, tableStartX + tableWidth, currentY);

// //     currentY += 15;

// //     // Total in words
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Total In Words:', 15, currentY);
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text(convertNumberToWords(invoice.total), 15, currentY + 6);

// //     // Totals section - right aligned
// //     const totalsX = pageWidth - 80;
// //     const totalsY = currentY - 10;

// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'normal');

// //     // Sub Total
// //     pdf.text('Sub Total:', totalsX, totalsY);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.subTotal), totalsX + 45, totalsY);

// //     // CGST
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text(`CGST (${invoice.cgstRate || 0}%):`, totalsX, totalsY + 6);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.cgst || 0), totalsX + 45, totalsY + 6);

// //     // SGST
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text(`SGST (${invoice.sgstRate || 0}%):`, totalsX, totalsY + 12);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.sgst || 0), totalsX + 45, totalsY + 12);

// //     // Total
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Total:', totalsX, totalsY + 18);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.total), totalsX + 45, totalsY + 18);

// //     // Balance Due
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Balance Due:', totalsX, totalsY + 24);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.balanceDue), totalsX + 45, totalsY + 24);

// //     currentY += 30;

// //     // Thank you message
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Thank you for the valuable business! We will always be at', 15, currentY);
// //     pdf.text('your desk to support you.', 15, currentY + 5);

// //     // Authorized signature
// //     pdf.text('Authorized Signature', totalsX + 20, currentY + 15);

// //     currentY += 35;

// //     // Terms and Bank Details
// //     pdf.setFontSize(8);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Terms & Conditions:', 15, currentY);
// //     pdf.text('Our Bank Details:', 110, currentY);

// //     pdf.setFont('Verdana', 'normal');
// //     currentY += 6;

// //     // Terms
// //     pdf.text('Full payment is due upon receipt of this invoice. Late', 15, currentY);
// //     pdf.text('payment may incur additional charges as per the applicable rates.', 15, currentY + 4);

// //     // Bank Details
// //     pdf.text('Name: Excerpt Technologies Private Limited', 110, currentY);
// //     pdf.text('Account Number: 10063739760', 110, currentY + 4);
// //     pdf.text('Name of Bank: IDFC First Bank', 110, currentY + 8);
// //     pdf.text('IFSC Code: IDFB0080151', 110, currentY + 12);
// //     pdf.text('PAN No: AAGCE2327K', 110, currentY + 16);

// //     // Footer
// //     const footerY = pageHeight - 25;
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.line(15, footerY, pageWidth - 15, footerY);

// //     pdf.setFontSize(8);
// //     pdf.setTextColor(0, 0, 255);
// //     pdf.text('https://excerptech.com', 15, footerY + 6);
// //     pdf.setTextColor(0, 0, 0);
// //     pdf.text('E-mail: info@excerptech.com', pageWidth - 65, footerY + 6);

// //     // Download the PDF
// //     pdf.save(`invoice-${invoice.invoiceNumber}.pdf`);

// //   } catch (error) {
// //     console.error('Error generating PDF:', error);
// //     alert('Error generating PDF. Please try again.');
// //   } finally {
// //     setDownloading(null);
// //   }
// // };
// const downloadInvoicePDF = async (invoice) => {
//   try {
//     setDownloading(invoice._id);

//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();

//     // Add custom fonts
//     pdf.addFileToVFS('Verdana.ttf', verdanaFont);
//     pdf.addFont('Verdana.ttf', 'Verdana', 'normal');

//     pdf.addFileToVFS('Verdana-Bold.ttf', verdanaboldFont);
//     pdf.addFont('Verdana-Bold.ttf', 'Verdana', 'bold');

//     pdf.addFileToVFS('NotoSans.ttf', notoSansBase64);
//     pdf.addFont('NotoSans.ttf', 'NotoSans', 'normal');

//     let currentY = 20;

//     // Header Section with Blue Background - exact match
//     pdf.setFillColor(59, 130, 246); // Blue color
//     pdf.rect(0, 0, pageWidth, 35, 'F');

//     // Add company logo on the left
//     try {
//       const logoImg = './image/112.png';
//       pdf.addImage(logoImg, 'JPEG', 12, 3, 40, 25);
//     } catch (error) {
//       console.log('Logo not found, using text instead');
//       // Fallback to text logo
//       pdf.setTextColor(255, 255, 255);
//       pdf.setFontSize(20);
//       pdf.setFont('Verdana', 'bold');
//       pdf.text('Excerpt', 12, 25);
//     }

//     // Company Details in Header - centered
//     pdf.setTextColor(255, 255, 255);
//     pdf.setFontSize(14);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Excerpt Technologies Pvt Ltd', pageWidth/2, 10, { align: 'right' });

//     pdf.setFontSize(8);
//     pdf.setFont('Verdana', 'normal');
//     pdf.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', pageWidth/2, 16, { align: 'right' });
//     pdf.text('Mahadevpura Post, Bangalore – 560048', pageWidth/2, 20, { align: 'right' });
//     pdf.text('Phone: +91(636) 465 7660, +91 (990) 050 2404', pageWidth/2, 24, { align: 'right' });
//     pdf.text('GSTIN: 29AAGCE2327K1ZH', pageWidth/2, 29, { align: 'right' });
//     pdf.text('LUT No: AD291021005439D', pageWidth/2, 33, { align: 'right' });

//     // INVOICE label - white text on right
//     pdf.setTextColor(255, 255, 255);
//     pdf.setFontSize(17);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('INVOICE', pageWidth - 38, 33);

//     // Reset to black text
//     pdf.setTextColor(0, 0, 0);
//     currentY = 35.5;

//     // Main content area with border
//     pdf.setDrawColor(0, 0, 0);
//     pdf.setLineWidth(0.5);
//     pdf.rect(10, currentY, pageWidth - 20, pageHeight - currentY - 20);

//     // Invoice details section
//     currentY += 7;
//     pdf.setFontSize(9);
//     pdf.setFont('Verdana', 'normal');

//     // Left column - Invoice details
//     pdf.text('Invoice:', 15, currentY);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text(invoice.invoiceNumber, 35, currentY);

//     pdf.setFont('Verdana', 'normal');
//     pdf.text('Date:', 15, currentY + 6);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text(formatDate(invoice.date), 35, currentY + 6);

//     pdf.setFont('Verdana', 'normal');
//     pdf.text('Terms:', 15, currentY + 12);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text(invoice.terms, 35, currentY + 12);

//     pdf.setFont('Verdana', 'normal');
//     pdf.text('Due Date:', 15, currentY + 18);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text(formatDate(invoice.dueDate), 35, currentY + 18);

//     currentY += 23;

//     // Bill To and Ship To sections with borders
//     const billToX = 15;
//     const shipToX = 107; // Adjusted to create proper gap
//     const sectionWidth = 88; // Slightly reduced to fit better
//     const sectionHeight = 50;

//     // Draw borders for Bill To and Ship To sections
//     pdf.setDrawColor(0, 0, 0);
//     pdf.setLineWidth(0.5);

//     // Bill To border
//     pdf.rect(billToX, currentY, sectionWidth, sectionHeight);

//     // Ship To border  
//     pdf.rect(shipToX, currentY, sectionWidth, sectionHeight);

//     // Headers with background
//     pdf.setFillColor(240, 240, 240);
//     pdf.rect(billToX, currentY, sectionWidth, 8, 'F');
//     pdf.rect(shipToX, currentY, sectionWidth, 8, 'F');

//     // Header borders
//     pdf.line(billToX, currentY + 8, billToX + sectionWidth, currentY + 8);
//     pdf.line(shipToX, currentY + 8, shipToX + sectionWidth, currentY + 8);

//     pdf.setFontSize(10);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Bill To:', billToX + 3, currentY + 6);
//     pdf.text('Ship To:', shipToX + 3, currentY + 6);

//     let billToY = currentY + 12;
//     let shipToY = currentY + 12;

//     // Names in bold
//     pdf.setFontSize(9);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text(invoice.billToName.toUpperCase(), billToX + 3, billToY);
//     pdf.text(invoice.shipToName.toUpperCase(), shipToX + 3, shipToY);

//     billToY += 6;
//     shipToY += 6;

//     // Helper function to wrap text within column width
//     const wrapText = (text, maxWidth) => {
//       const words = text.split(' ');
//       const lines = [];
//       let currentLine = '';

//       for (let word of words) {
//         const testLine = currentLine + (currentLine ? ' ' : '') + word;
//         const testWidth = pdf.getTextWidth(testLine);

//         if (testWidth > maxWidth && currentLine) {
//           lines.push(currentLine);
//           currentLine = word;
//         } else {
//           currentLine = testLine;
//         }
//       }

//       if (currentLine) {
//         lines.push(currentLine);
//       }

//       return lines;
//     };

//     // Bill To Address - properly wrapped
//     pdf.setFont('Verdana', 'normal');
//     const billToAddressLines = invoice.billToAddress.split('\n');
//     const maxTextWidth = sectionWidth - 6; // Account for padding

//     for (let line of billToAddressLines) {
//       const wrappedLines = wrapText(line, maxTextWidth);
//       for (let wrappedLine of wrappedLines) {
//         if (billToY < currentY + sectionHeight - 2) { // Check if we have space
//           pdf.text(wrappedLine, billToX + 3, billToY);
//           billToY += 4;
//         }
//       }
//     }

//     // Bill To City
//     if (invoice.billToCity && billToY < currentY + sectionHeight - 2) {
//       const cityLines = wrapText(invoice.billToCity, maxTextWidth);
//       for (let cityLine of cityLines) {
//         if (billToY < currentY + sectionHeight - 2) {
//           pdf.text(cityLine, billToX + 3, billToY);
//           billToY += 4;
//         }
//       }
//     }

//     // Ship To Address - properly wrapped
//     const shipToAddressLines = invoice.shipToAddress.split('\n');

//     for (let line of shipToAddressLines) {
//       const wrappedLines = wrapText(line, maxTextWidth);
//       for (let wrappedLine of wrappedLines) {
//         if (shipToY < currentY + sectionHeight - 2) { // Check if we have space
//           pdf.text(wrappedLine, shipToX + 3, shipToY);
//           shipToY += 4;
//         }
//       }
//     }

//     // Ship To City
//     if (invoice.shipToCity && shipToY < currentY + sectionHeight - 2) {
//       const cityLines = wrapText(invoice.shipToCity, maxTextWidth);
//       for (let cityLine of cityLines) {
//         if (shipToY < currentY + sectionHeight - 2) {
//           pdf.text(cityLine, shipToX + 3, shipToY);
//           shipToY += 4;
//         }
//       }
//     }

//     // Move currentY to after the Bill To/Ship To sections
//     currentY += sectionHeight + 5; // Add extra space to prevent overlap

//     // Items table
//     const tableStartY = currentY;
//     const tableStartX = 15;
//     const tableWidth = pageWidth - 30;
//     const descriptionWidth = tableWidth - 50;
//     const amountWidth = 50;

//     // Table header
//     pdf.setFillColor(230, 230, 230);
//     pdf.rect(tableStartX, tableStartY, tableWidth, 12, 'F');
//     pdf.setDrawColor(0, 0, 0);
//     pdf.rect(tableStartX, tableStartY, tableWidth, 12);
//     pdf.rect(tableStartX, tableStartY, descriptionWidth, 12);
//     pdf.rect(tableStartX + descriptionWidth, tableStartY, amountWidth, 12);

//     pdf.setFontSize(10);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Items & Description', tableStartX + 5, tableStartY + 8);
//     pdf.text('Amount', tableStartX + descriptionWidth + 15, tableStartY + 8);

//     currentY = tableStartY + 12;

//     // Table rows
//     if (invoice.parts) {
//       invoice.parts.forEach((part, partIndex) => {
//         // Part title row
//         pdf.setFillColor(250, 250, 250);
//         pdf.rect(tableStartX, currentY, tableWidth, 8, 'F');
//         pdf.rect(tableStartX, currentY, descriptionWidth, 8);
//         pdf.rect(tableStartX + descriptionWidth, currentY, amountWidth, 8);

//         pdf.setFontSize(9);
//         pdf.setFont('Verdana', 'bold');
//         pdf.text(part.title, tableStartX + 5, currentY + 6);

//         currentY += 8;

//         // Part items
//         part.items.forEach((item, itemIndex) => {
//           const itemRowHeight = 8;

//           // Row background
//           pdf.setFillColor(255, 255, 255);
//           pdf.rect(tableStartX, currentY, tableWidth, itemRowHeight, 'F');
//           pdf.rect(tableStartX, currentY, descriptionWidth, itemRowHeight);
//           pdf.rect(tableStartX + descriptionWidth, currentY, amountWidth, itemRowHeight);

//           pdf.setFont('Verdana', 'normal');
//           pdf.text(`${itemIndex + 1}. ${item.description}`, tableStartX + 8, currentY + 6);

//           pdf.setFont('NotoSans', 'normal');
//           pdf.text(formatCurrency(item.amount), tableStartX + descriptionWidth + 15, currentY + 6);

//           currentY += itemRowHeight;
//         });
//       });
//     }

//     // Close table
//     pdf.line(tableStartX, currentY, tableStartX + tableWidth, currentY);

//     currentY += 15;

//     // Total in words
//     pdf.setFontSize(9);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Total In Words:', 15, currentY);
//     pdf.setFont('Verdana', 'normal');
//     pdf.text(convertNumberToWords(invoice.total), 15, currentY + 6);

//     // Totals section - right aligned
//     const totalsX = pageWidth - 80;
//     const totalsY = currentY - 10;

//     pdf.setFontSize(9);
//     pdf.setFont('Verdana', 'normal');

//     // Sub Total
//     pdf.text('Sub Total:', totalsX, totalsY);
//     pdf.setFont('NotoSans', 'normal');
//     pdf.text(formatCurrency(invoice.subTotal), totalsX + 45, totalsY);

//     // CGST
//     pdf.setFont('Verdana', 'normal');
//     pdf.text(`CGST (${invoice.cgstRate || 0}%):`, totalsX, totalsY + 6);
//     pdf.setFont('NotoSans', 'normal');
//     pdf.text(formatCurrency(invoice.cgst || 0), totalsX + 45, totalsY + 6);

//     // SGST
//     pdf.setFont('Verdana', 'normal');
//     pdf.text(`SGST (${invoice.sgstRate || 0}%):`, totalsX, totalsY + 12);
//     pdf.setFont('NotoSans', 'normal');
//     pdf.text(formatCurrency(invoice.sgst || 0), totalsX + 45, totalsY + 12);

//     // Total
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Total:', totalsX, totalsY + 18);
//     pdf.setFont('NotoSans', 'normal');
//     pdf.text(formatCurrency(invoice.total), totalsX + 45, totalsY + 18);

//     // Balance Due
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Balance Due:', totalsX, totalsY + 24);
//     pdf.setFont('NotoSans', 'normal');
//     pdf.text(formatCurrency(invoice.balanceDue), totalsX + 45, totalsY + 24);

//     currentY += 30;

//     // Thank you message
//     pdf.setFontSize(9);
//     pdf.setFont('Verdana', 'normal');
//     pdf.text('Thank you for the valuable business! We will always be at', 15, currentY);
//     pdf.text('your desk to support you.', 15, currentY + 5);

//     // Authorized signature
//     pdf.text('Authorized Signature', totalsX + 20, currentY + 15);

//     currentY += 35;

//     // Terms and Bank Details
//     pdf.setFontSize(8);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Terms & Conditions:', 15, currentY);
//     pdf.text('Our Bank Details:', 110, currentY);

//     pdf.setFont('Verdana', 'normal');
//     currentY += 6;

//     // Terms
//     pdf.text('Full payment is due upon receipt of this invoice. Late', 15, currentY);
//     pdf.text('payment may incur additional charges as per the applicable rates.', 15, currentY + 4);

//     // Bank Details
//     pdf.text('Name: Excerpt Technologies Private Limited', 110, currentY);
//     pdf.text('Account Number: 10063739760', 110, currentY + 4);
//     pdf.text('Name of Bank: IDFC First Bank', 110, currentY + 8);
//     pdf.text('IFSC Code: IDFB0080151', 110, currentY + 12);
//     pdf.text('PAN No: AAGCE2327K', 110, currentY + 16);

//     // Footer
//     const footerY = pageHeight - 25;
//     pdf.setDrawColor(0, 0, 0);
//     pdf.line(15, footerY, pageWidth - 15, footerY);

//     pdf.setFontSize(8);
//     pdf.setTextColor(0, 0, 255);
//     pdf.text('https://excerptech.com', 15, footerY + 6);
//     pdf.setTextColor(0, 0, 0);
//     pdf.text('E-mail: info@excerptech.com', pageWidth - 65, footerY + 6);

//     // Download the PDF
//     pdf.save(`invoice-${invoice.invoiceNumber}.pdf`);

//   } catch (error) {
//     console.error('Error generating PDF:', error);
//     alert('Error generating PDF. Please try again.');
//   } finally {
//     setDownloading(null);
//   }
// };
//   if (loading) return <div className="loading">Loading invoices...</div>;
//   if (error) return <div className="error">Error: {error}</div>;

//   return (
//     <div className="invoice-list-container">
//       <h2>All Invoices</h2>

//       {invoices.length === 0 ? (
//         <div className="no-invoices">No invoices found.</div>
//       ) : (
//         <div className="table-container">
//           <table className="invoice-table">
//             <thead>
//               <tr>
//                 <th>Invoice Number</th>
//                 <th>Date</th>
//                 <th>Bill To</th>
//                 <th>Total Amount</th>
//                 {/* <th>Status</th> */}
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {invoices.map((invoice) => (
//                 <tr key={invoice._id}>
//                   <td>{invoice.invoiceNumber}</td>
//                   <td>{new Date(invoice.date).toLocaleDateString('en-GB')}</td>
//                   <td>{invoice.billToName}</td>
//                   <td>₹ {invoice.total}</td>
//                   {/* <td>
//                     <span className={`status ${invoice.balanceDue > 0 ? 'pending' : 'paid'}`}>
//                       {invoice.balanceDue > 0 ? 'Pending' : 'Paid'}
//                     </span>
//                   </td> */}
//                   <td>
//                     <button 
//                       onClick={() => downloadInvoicePDF(invoice)}
//                       disabled={downloading === invoice._id}
//                       className="download-btn"
//                     >
//                       {downloading === invoice._id ? 'Generating...' : 'Download PDF'}
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default InvoiceList;

// KARTHIK //
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import jsPDF from 'jspdf';
// import './InvoiceList.css';
// import InvoiceComponent from './InvoiceComponent';
// import { notoSansBase64 } from './notosans';
// import { verdanaFont } from './verdant';
// import { verdanaboldFont } from './verdanbold';



// const InvoiceList = () => {


//   const [invoices, setInvoices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [downloading, setDownloading] = useState(null);

//   useEffect(() => {
//     fetchInvoices();
//   }, []);

//   const fetchInvoices = async () => {
//     try {
//       const response = await axios.get('/invoices');
//       setInvoices(response.data);
//       setLoading(false);
//     } catch (error) {
//       setError(error.response?.data?.message || 'Error fetching invoices');
//       setLoading(false);
//     }
//   };


// const convertNumberToWords = (amount) => {
//   const words = [
//     '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
//     'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
//     'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
//     'Seventeen', 'Eighteen', 'Nineteen'
//   ];
//   const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

//   const convert = (num) => {
//     if (num < 20) return words[num];
//     if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + words[num % 10] : '');
//     if (num < 1000) return words[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' and ' + convert(num % 100) : '');
//     if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + convert(num % 1000) : '');
//     if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + convert(num % 100000) : '');
//     return convert(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + convert(num % 10000000) : '');
//   };

//   const [whole, decimal] = Number(amount).toFixed(2).split('.');
//   const inWords = convert(parseInt(whole)) + ' Rupees';
//   const paisa = parseInt(decimal) ? ' and ' + convert(parseInt(decimal)) + ' Paise' : '';
//   return inWords + paisa + ' only';
// };

// const formatDate = (dateString) => {
//   return new Date(dateString).toLocaleDateString('en-GB');
// };

// const formatCurrency = (amount) => {
//   return `₹ ${parseFloat(amount).toFixed(2)}`;
// };
// ;



// // Paste your base64 logo here


// // const downloadInvoicePDF = async (invoice) => {
// //   try {
// //     setDownloading(invoice._id);

// //     const pdf = new jsPDF('p', 'mm', 'a4');
// //     const pageWidth = pdf.internal.pageSize.getWidth();
// //     const pageHeight = pdf.internal.pageSize.getHeight();

// //     // Add custom fonts
// //     pdf.addFileToVFS('Verdana.ttf', verdanaFont);
// //     pdf.addFont('Verdana.ttf', 'Verdana', 'normal');

// //     pdf.addFileToVFS('Verdana-Bold.ttf', verdanaboldFont);
// //     pdf.addFont('Verdana-Bold.ttf', 'Verdana', 'bold');

// //     pdf.addFileToVFS('NotoSans.ttf', notoSansBase64);
// //     pdf.addFont('NotoSans.ttf', 'NotoSans', 'normal');

// //     let currentY = 20;

// //     // Header Section with Blue Background - exact match
// //     pdf.setFillColor(59, 130, 246); // Blue color
// //     pdf.rect(0, 0, pageWidth, 35, 'F');

// //     // Add company logo on the left
// //     try {
// //       const logoImg = './image/112.png';
// //       pdf.addImage(logoImg, 'JPEG', 12, 3, 40, 25);
// //     } catch (error) {
// //       console.log('Logo not found, using text instead');
// //       // Fallback to text logo
// //       pdf.setTextColor(255, 255, 255);
// //       pdf.setFontSize(20);
// //       pdf.setFont('Verdana', 'bold');
// //       pdf.text('Excerpt', 12, 25);
// //     }

// //     // Company Details in Header - centered
// //     pdf.setTextColor(255, 255, 255);
// //     pdf.setFontSize(14);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Excerpt Technologies Pvt Ltd', pageWidth/2, 10, { align: 'right' });

// //     pdf.setFontSize(8);
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', pageWidth/2, 16, { align: 'right' });
// //     pdf.text('Mahadevpura Post, Bangalore – 560048', pageWidth/2, 20, { align: 'right' });
// //     pdf.text('Phone: +91(636) 465 7660, +91 (990) 050 2404', pageWidth/2, 24, { align: 'right' });
// //     pdf.text('GSTIN: 29AAGCE2327K1ZH', pageWidth/2, 29, { align: 'right' });
// //     pdf.text('LUT No: AD291021005439D', pageWidth/2, 33, { align: 'right' });

// //     // INVOICE label - white box on right
// //     // pdf.setFillColor(255, 255, 255);
// //     // pdf.rect(pageWidth - 50, 15, 40, 15, 'F');
// // pdf.setTextColor(255, 255, 255);

// //     pdf.setFontSize(17);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('INVOICE', pageWidth - 38, 33);

// //     // Reset to black text
// //     pdf.setTextColor(0, 0, 0);
// //     currentY = 35.5;

// //     // Main content area with border
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.setLineWidth(0.5);
// //     pdf.rect(10, currentY, pageWidth - 20, pageHeight - currentY - 20);

// //     // Invoice details section
// //     currentY += 7;
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'normal');

// //     // Left column - Invoice details
// //     pdf.text('Invoice:', 15, currentY);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(invoice.invoiceNumber, 35, currentY);

// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Date:', 15, currentY + 6);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(formatDate(invoice.date), 35, currentY + 6);

// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Terms:', 15, currentY + 12);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(invoice.terms, 35, currentY + 12);

// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Due Date:', 15, currentY + 18);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(formatDate(invoice.dueDate), 35, currentY + 18);

// //     currentY += 25;

// //     // Bill To and Ship To sections with borders
// //     const billToX = 15;
// //     const shipToX = 110;
// //     const sectionWidth = 90;
// //     const sectionHeight = 50;

// //     // Draw borders for Bill To and Ship To sections
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.setLineWidth(0.5);

// //     // Bill To border
// //     pdf.rect(billToX, currentY, sectionWidth, sectionHeight);

// //     // Ship To border  
// //     pdf.rect(shipToX, currentY, sectionWidth, sectionHeight);

// //     // Headers with background
// //     pdf.setFillColor(240, 240, 240);
// //     pdf.rect(billToX, currentY, sectionWidth, 8, 'F');
// //     pdf.rect(shipToX, currentY, sectionWidth, 8, 'F');

// //     // Header borders
// //     pdf.line(billToX, currentY + 8, billToX + sectionWidth, currentY + 8);
// //     pdf.line(shipToX, currentY + 8, shipToX + sectionWidth, currentY + 8);

// //     pdf.setFontSize(10);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Bill To:', billToX + 3, currentY + 6);
// //     pdf.text('Ship To:', shipToX + 3, currentY + 6);

// //     currentY += 12;

// //     // Names in bold
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(invoice.billToName.toUpperCase(), billToX + 3, currentY);
// //     pdf.text(invoice.shipToName.toUpperCase(), shipToX + 3, currentY);

// //     currentY += 6;

// //     // Addresses
// //     pdf.setFont('Verdana', 'normal');
// //     const billToLines = invoice.billToAddress.split('\n');
// //     const shipToLines = invoice.shipToAddress.split('\n');

// //     const maxLines = Math.max(billToLines.length, shipToLines.length);

// //     for (let i = 0; i < maxLines; i++) {
// //       if (billToLines[i]) {
// //         pdf.text(billToLines[i], billToX + 3, currentY);
// //       }
// //       if (shipToLines[i]) {
// //         pdf.text(shipToLines[i], shipToX + 3, currentY);
// //       }
// //       currentY += 4;
// //     }

// //     // Cities
// //     if (invoice.billToCity) {
// //       pdf.text(invoice.billToCity, billToX + 3, currentY);
// //     }
// //     if (invoice.shipToCity) {
// //       pdf.text(invoice.shipToCity, shipToX + 3, currentY);
// //     }

// //     currentY += 20;

// //     // Items table
// //     const tableStartY = currentY;
// //     const tableStartX = 15;
// //     const tableWidth = pageWidth - 30;
// //     const descriptionWidth = tableWidth - 50;
// //     const amountWidth = 50;

// //     // Table header
// //     pdf.setFillColor(230, 230, 230);
// //     pdf.rect(tableStartX, tableStartY, tableWidth, 12, 'F');
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.rect(tableStartX, tableStartY, tableWidth, 12);
// //     pdf.rect(tableStartX, tableStartY, descriptionWidth, 12);
// //     pdf.rect(tableStartX + descriptionWidth, tableStartY, amountWidth, 12);

// //     pdf.setFontSize(10);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Items & Description', tableStartX + 5, tableStartY + 8);
// //     pdf.text('Amount', tableStartX + descriptionWidth + 15, tableStartY + 8);

// //     currentY = tableStartY + 12;

// //     // Table rows
// //     let rowHeight = 0;
// //     if (invoice.parts) {
// //       invoice.parts.forEach((part, partIndex) => {
// //         // Part title row
// //         pdf.setFillColor(250, 250, 250);
// //         pdf.rect(tableStartX, currentY, tableWidth, 8, 'F');
// //         pdf.rect(tableStartX, currentY, descriptionWidth, 8);
// //         pdf.rect(tableStartX + descriptionWidth, currentY, amountWidth, 8);

// //         pdf.setFontSize(9);
// //         pdf.setFont('Verdana', 'bold');
// //         pdf.text(part.title, tableStartX + 5, currentY + 6);

// //         currentY += 8;

// //         // Part items
// //         part.items.forEach((item, itemIndex) => {
// //           const itemRowHeight = 8;

// //           // Row background
// //           pdf.setFillColor(255, 255, 255);
// //           pdf.rect(tableStartX, currentY, tableWidth, itemRowHeight, 'F');
// //           pdf.rect(tableStartX, currentY, descriptionWidth, itemRowHeight);
// //           pdf.rect(tableStartX + descriptionWidth, currentY, amountWidth, itemRowHeight);

// //           pdf.setFont('Verdana', 'normal');
// //           pdf.text(`${itemIndex + 1}. ${item.description}`, tableStartX + 8, currentY + 6);

// //           pdf.setFont('NotoSans', 'normal');
// //           pdf.text(formatCurrency(item.amount), tableStartX + descriptionWidth + 15, currentY + 6);

// //           currentY += itemRowHeight;
// //         });
// //       });
// //     }

// //     // Close table
// //     pdf.line(tableStartX, currentY, tableStartX + tableWidth, currentY);

// //     currentY += 15;

// //     // Total in words
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Total In Words:', 15, currentY);
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text(convertNumberToWords(invoice.total), 15, currentY + 6);

// //     // Totals section - right aligned
// //     const totalsX = pageWidth - 80;
// //     const totalsY = currentY - 10;

// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'normal');

// //     // Sub Total
// //     pdf.text('Sub Total:', totalsX, totalsY);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.subTotal), totalsX + 45, totalsY);

// //     // CGST
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text(`CGST (${invoice.cgstRate || 0}%):`, totalsX, totalsY + 6);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.cgst || 0), totalsX + 45, totalsY + 6);

// //     // SGST
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text(`SGST (${invoice.sgstRate || 0}%):`, totalsX, totalsY + 12);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.sgst || 0), totalsX + 45, totalsY + 12);

// //     // Total
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Total:', totalsX, totalsY + 18);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.total), totalsX + 45, totalsY + 18);

// //     // Balance Due
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Balance Due:', totalsX, totalsY + 24);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.balanceDue), totalsX + 45, totalsY + 24);

// //     currentY += 30;

// //     // Thank you message
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Thank you for the valuable business! We will always be at', 15, currentY);
// //     pdf.text('your desk to support you.', 15, currentY + 5);

// //     // Authorized signature
// //     pdf.text('Authorized Signature', totalsX + 20, currentY + 15);

// //     currentY += 35;

// //     // Terms and Bank Details
// //     pdf.setFontSize(8);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Terms & Conditions:', 15, currentY);
// //     pdf.text('Our Bank Details:', 110, currentY);

// //     pdf.setFont('Verdana', 'normal');
// //     currentY += 6;

// //     // Terms
// //     pdf.text('Full payment is due upon receipt of this invoice. Late', 15, currentY);
// //     pdf.text('payment may incur additional charges as per the applicable rates.', 15, currentY + 4);

// //     // Bank Details
// //     pdf.text('Name: Excerpt Technologies Private Limited', 110, currentY);
// //     pdf.text('Account Number: 10063739760', 110, currentY + 4);
// //     pdf.text('Name of Bank: IDFC First Bank', 110, currentY + 8);
// //     pdf.text('IFSC Code: IDFB0080151', 110, currentY + 12);
// //     pdf.text('PAN No: AAGCE2327K', 110, currentY + 16);

// //     // Footer
// //     const footerY = pageHeight - 25;
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.line(15, footerY, pageWidth - 15, footerY);

// //     pdf.setFontSize(8);
// //     pdf.setTextColor(0, 0, 255);
// //     pdf.text('https://excerptech.com', 15, footerY + 6);
// //     pdf.setTextColor(0, 0, 0);
// //     pdf.text('E-mail: info@excerptech.com', pageWidth - 65, footerY + 6);

// //     // Download the PDF
// //     pdf.save(`invoice-${invoice.invoiceNumber}.pdf`);

// //   } catch (error) {
// //     console.error('Error generating PDF:', error);
// //     alert('Error generating PDF. Please try again.');
// //   } finally {
// //     setDownloading(null);
// //   }
// // };
// // const downloadInvoicePDF = async (invoice) => {
// //   try {
// //     setDownloading(invoice._id);

// //     const pdf = new jsPDF('p', 'mm', 'a4');
// //     const pageWidth = pdf.internal.pageSize.getWidth();
// //     const pageHeight = pdf.internal.pageSize.getHeight();

// //     // Add custom fonts
// //     pdf.addFileToVFS('Verdana.ttf', verdanaFont);
// //     pdf.addFont('Verdana.ttf', 'Verdana', 'normal');

// //     pdf.addFileToVFS('Verdana-Bold.ttf', verdanaboldFont);
// //     pdf.addFont('Verdana-Bold.ttf', 'Verdana', 'bold');

// //     pdf.addFileToVFS('NotoSans.ttf', notoSansBase64);
// //     pdf.addFont('NotoSans.ttf', 'NotoSans', 'normal');

// //     let currentY = 20;

// //     // Header Section with Blue Background - exact match
// //     pdf.setFillColor(59, 130, 246); // Blue color
// //     pdf.rect(0, 0, pageWidth, 35, 'F');

// //     // Add company logo on the left
// //     try {
// //       const logoImg = './image/112.png';
// //       pdf.addImage(logoImg, 'JPEG', 12, 3, 40, 25);
// //     } catch (error) {
// //       console.log('Logo not found, using text instead');
// //       // Fallback to text logo
// //       pdf.setTextColor(255, 255, 255);
// //       pdf.setFontSize(20);
// //       pdf.setFont('Verdana', 'bold');
// //       pdf.text('Excerpt', 12, 25);
// //     }

// //     // Company Details in Header - centered
// //     pdf.setTextColor(255, 255, 255);
// //     pdf.setFontSize(14);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Excerpt Technologies Pvt Ltd', pageWidth/2, 10, { align: 'right' });

// //     pdf.setFontSize(8);
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', pageWidth/2, 16, { align: 'right' });
// //     pdf.text('Mahadevpura Post, Bangalore – 560048', pageWidth/2, 20, { align: 'right' });
// //     pdf.text('Phone: +91(636) 465 7660, +91 (990) 050 2404', pageWidth/2, 24, { align: 'right' });
// //     pdf.text('GSTIN: 29AAGCE2327K1ZH', pageWidth/2, 29, { align: 'right' });
// //     pdf.text('LUT No: AD291021005439D', pageWidth/2, 33, { align: 'right' });

// //     // INVOICE label - white text on right
// //     pdf.setTextColor(255, 255, 255);
// //     pdf.setFontSize(17);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('INVOICE', pageWidth - 38, 33);

// //     // Reset to black text
// //     pdf.setTextColor(0, 0, 0);
// //     currentY = 35.5;

// //     // Main content area with border
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.setLineWidth(0.5);
// //     pdf.rect(10, currentY, pageWidth - 20, pageHeight - currentY - 20);

// //     // Invoice details section
// //     currentY += 7;
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'normal');

// //     // Left column - Invoice details
// //     pdf.text('Invoice:', 15, currentY);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(invoice.invoiceNumber, 35, currentY);

// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Date:', 15, currentY + 6);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(formatDate(invoice.date), 35, currentY + 6);

// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Terms:', 15, currentY + 12);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(invoice.terms, 35, currentY + 12);

// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Due Date:', 15, currentY + 18);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(formatDate(invoice.dueDate), 35, currentY + 18);

// //     currentY += 23;

// //     // Bill To and Ship To sections with borders
// //     const billToX = 15;
// //     const shipToX = 107; // Adjusted to create proper gap
// //     const sectionWidth = 88; // Slightly reduced to fit better
// //     const sectionHeight = 50;

// //     // Draw borders for Bill To and Ship To sections
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.setLineWidth(0.5);

// //     // Bill To border
// //     pdf.rect(billToX, currentY, sectionWidth, sectionHeight);

// //     // Ship To border  
// //     pdf.rect(shipToX, currentY, sectionWidth, sectionHeight);

// //     // Headers with background
// //     pdf.setFillColor(240, 240, 240);
// //     pdf.rect(billToX, currentY, sectionWidth, 8, 'F');
// //     pdf.rect(shipToX, currentY, sectionWidth, 8, 'F');

// //     // Header borders
// //     pdf.line(billToX, currentY + 8, billToX + sectionWidth, currentY + 8);
// //     pdf.line(shipToX, currentY + 8, shipToX + sectionWidth, currentY + 8);

// //     pdf.setFontSize(10);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Bill To:', billToX + 3, currentY + 6);
// //     pdf.text('Ship To:', shipToX + 3, currentY + 6);

// //     let billToY = currentY + 12;
// //     let shipToY = currentY + 12;

// //     // Names in bold
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text(invoice.billToName.toUpperCase(), billToX + 3, billToY);
// //     pdf.text(invoice.shipToName.toUpperCase(), shipToX + 3, shipToY);

// //     billToY += 6;
// //     shipToY += 6;

// //     // Helper function to wrap text within column width
// //     const wrapText = (text, maxWidth) => {
// //       const words = text.split(' ');
// //       const lines = [];
// //       let currentLine = '';

// //       for (let word of words) {
// //         const testLine = currentLine + (currentLine ? ' ' : '') + word;
// //         const testWidth = pdf.getTextWidth(testLine);

// //         if (testWidth > maxWidth && currentLine) {
// //           lines.push(currentLine);
// //           currentLine = word;
// //         } else {
// //           currentLine = testLine;
// //         }
// //       }

// //       if (currentLine) {
// //         lines.push(currentLine);
// //       }

// //       return lines;
// //     };

// //     // Bill To Address - properly wrapped
// //     pdf.setFont('Verdana', 'normal');
// //     const billToAddressLines = invoice.billToAddress.split('\n');
// //     const maxTextWidth = sectionWidth - 6; // Account for padding

// //     for (let line of billToAddressLines) {
// //       const wrappedLines = wrapText(line, maxTextWidth);
// //       for (let wrappedLine of wrappedLines) {
// //         if (billToY < currentY + sectionHeight - 2) { // Check if we have space
// //           pdf.text(wrappedLine, billToX + 3, billToY);
// //           billToY += 4;
// //         }
// //       }
// //     }

// //     // Bill To City
// //     if (invoice.billToCity && billToY < currentY + sectionHeight - 2) {
// //       const cityLines = wrapText(invoice.billToCity, maxTextWidth);
// //       for (let cityLine of cityLines) {
// //         if (billToY < currentY + sectionHeight - 2) {
// //           pdf.text(cityLine, billToX + 3, billToY);
// //           billToY += 4;
// //         }
// //       }
// //     }

// //     // Ship To Address - properly wrapped
// //     const shipToAddressLines = invoice.shipToAddress.split('\n');

// //     for (let line of shipToAddressLines) {
// //       const wrappedLines = wrapText(line, maxTextWidth);
// //       for (let wrappedLine of wrappedLines) {
// //         if (shipToY < currentY + sectionHeight - 2) { // Check if we have space
// //           pdf.text(wrappedLine, shipToX + 3, shipToY);
// //           shipToY += 4;
// //         }
// //       }
// //     }

// //     // Ship To City
// //     if (invoice.shipToCity && shipToY < currentY + sectionHeight - 2) {
// //       const cityLines = wrapText(invoice.shipToCity, maxTextWidth);
// //       for (let cityLine of cityLines) {
// //         if (shipToY < currentY + sectionHeight - 2) {
// //           pdf.text(cityLine, shipToX + 3, shipToY);
// //           shipToY += 4;
// //         }
// //       }
// //     }

// //     // Move currentY to after the Bill To/Ship To sections
// //     currentY += sectionHeight + 5; // Add extra space to prevent overlap

// //     // Items table
// //     const tableStartY = currentY;
// //     const tableStartX = 15;
// //     const tableWidth = pageWidth - 30;
// //     const descriptionWidth = tableWidth - 50;
// //     const amountWidth = 50;

// //     // Table header
// //     pdf.setFillColor(230, 230, 230);
// //     pdf.rect(tableStartX, tableStartY, tableWidth, 12, 'F');
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.rect(tableStartX, tableStartY, tableWidth, 12);
// //     pdf.rect(tableStartX, tableStartY, descriptionWidth, 12);
// //     pdf.rect(tableStartX + descriptionWidth, tableStartY, amountWidth, 12);

// //     pdf.setFontSize(10);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Items & Description', tableStartX + 5, tableStartY + 8);
// //     pdf.text('Amount', tableStartX + descriptionWidth + 15, tableStartY + 8);

// //     currentY = tableStartY + 12;

// //     // Table rows
// //     if (invoice.parts) {
// //       invoice.parts.forEach((part, partIndex) => {
// //         // Part title row
// //         pdf.setFillColor(250, 250, 250);
// //         pdf.rect(tableStartX, currentY, tableWidth, 8, 'F');
// //         pdf.rect(tableStartX, currentY, descriptionWidth, 8);
// //         pdf.rect(tableStartX + descriptionWidth, currentY, amountWidth, 8);

// //         pdf.setFontSize(9);
// //         pdf.setFont('Verdana', 'bold');
// //         pdf.text(part.title, tableStartX + 5, currentY + 6);

// //         currentY += 8;

// //         // Part items
// //         part.items.forEach((item, itemIndex) => {
// //           const itemRowHeight = 8;

// //           // Row background
// //           pdf.setFillColor(255, 255, 255);
// //           pdf.rect(tableStartX, currentY, tableWidth, itemRowHeight, 'F');
// //           pdf.rect(tableStartX, currentY, descriptionWidth, itemRowHeight);
// //           pdf.rect(tableStartX + descriptionWidth, currentY, amountWidth, itemRowHeight);

// //           pdf.setFont('Verdana', 'normal');
// //           pdf.text(`${itemIndex + 1}. ${item.description}`, tableStartX + 8, currentY + 6);

// //           pdf.setFont('NotoSans', 'normal');
// //           pdf.text(formatCurrency(item.amount), tableStartX + descriptionWidth + 15, currentY + 6);

// //           currentY += itemRowHeight;
// //         });
// //       });
// //     }

// //     // Close table
// //     pdf.line(tableStartX, currentY, tableStartX + tableWidth, currentY);

// //     currentY += 15;

// //     // Total in words
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Total In Words:', 15, currentY);
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text(convertNumberToWords(invoice.total), 15, currentY + 6);

// //     // Totals section - right aligned
// //     const totalsX = pageWidth - 80;
// //     const totalsY = currentY - 10;

// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'normal');

// //     // Sub Total
// //     pdf.text('Sub Total:', totalsX, totalsY);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.subTotal), totalsX + 45, totalsY);

// //     // CGST
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text(`CGST (${invoice.cgstRate || 0}%):`, totalsX, totalsY + 6);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.cgst || 0), totalsX + 45, totalsY + 6);

// //     // SGST
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text(`SGST (${invoice.sgstRate || 0}%):`, totalsX, totalsY + 12);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.sgst || 0), totalsX + 45, totalsY + 12);

// //     // Total
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Total:', totalsX, totalsY + 18);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.total), totalsX + 45, totalsY + 18);

// //     // Balance Due
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Balance Due:', totalsX, totalsY + 24);
// //     pdf.setFont('NotoSans', 'normal');
// //     pdf.text(formatCurrency(invoice.balanceDue), totalsX + 45, totalsY + 24);

// //     currentY += 30;

// //     // Thank you message
// //     pdf.setFontSize(9);
// //     pdf.setFont('Verdana', 'normal');
// //     pdf.text('Thank you for the valuable business! We will always be at', 15, currentY);
// //     pdf.text('your desk to support you.', 15, currentY + 5);

// //     // Authorized signature
// //     pdf.text('Authorized Signature', totalsX + 20, currentY + 15);

// //     currentY += 35;

// //     // Terms and Bank Details
// //     pdf.setFontSize(8);
// //     pdf.setFont('Verdana', 'bold');
// //     pdf.text('Terms & Conditions:', 15, currentY);
// //     pdf.text('Our Bank Details:', 110, currentY);

// //     pdf.setFont('Verdana', 'normal');
// //     currentY += 6;

// //     // Terms
// //     pdf.text('Full payment is due upon receipt of this invoice. Late', 15, currentY);
// //     pdf.text('payment may incur additional charges as per the applicable rates.', 15, currentY + 4);

// //     // Bank Details
// //     pdf.text('Name: Excerpt Technologies Private Limited', 110, currentY);
// //     pdf.text('Account Number: 10063739760', 110, currentY + 4);
// //     pdf.text('Name of Bank: IDFC First Bank', 110, currentY + 8);
// //     pdf.text('IFSC Code: IDFB0080151', 110, currentY + 12);
// //     pdf.text('PAN No: AAGCE2327K', 110, currentY + 16);

// //     // Footer
// //     const footerY = pageHeight - 25;
// //     pdf.setDrawColor(0, 0, 0);
// //     pdf.line(15, footerY, pageWidth - 15, footerY);

// //     pdf.setFontSize(8);
// //     pdf.setTextColor(0, 0, 255);
// //     pdf.text('https://excerptech.com', 15, footerY + 6);
// //     pdf.setTextColor(0, 0, 0);
// //     pdf.text('E-mail: info@excerptech.com', pageWidth - 65, footerY + 6);

// //     // Download the PDF
// //     pdf.save(`invoice-${invoice.invoiceNumber}.pdf`);

// //   } catch (error) {
// //     console.error('Error generating PDF:', error);
// //     alert('Error generating PDF. Please try again.');
// //   } finally {
// //     setDownloading(null);
// //   }
// // };



// const downloadInvoicePDF = async (invoice) => {
//   try {
//     setDownloading(invoice._id);

//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();

//     // Add custom fonts
//     pdf.addFileToVFS('Verdana.ttf', verdanaFont);
//     pdf.addFont('Verdana.ttf', 'Verdana', 'normal');

//     pdf.addFileToVFS('Verdana-Bold.ttf', verdanaboldFont);
//     pdf.addFont('Verdana-Bold.ttf', 'Verdana', 'bold');

//     pdf.addFileToVFS('NotoSans.ttf', notoSansBase64);
//     pdf.addFont('NotoSans.ttf', 'NotoSans', 'normal');

//     let currentY = 20;

//     // Header Section with Blue Background - exact match
//     pdf.setFillColor(59, 130, 246); // Blue color
//     pdf.rect(0, 0, pageWidth, 35, 'F');

//     // HEADER BACKGROUND

// pdf.setFillColor(0, 81, 255); // Rich blue like in the image
// pdf.rect(0, 0, pageWidth, 38, 'F');

// // LOGO on the LEFT
// try {
//       const logoImg = './image/excerpt.png';
//       pdf.addImage(logoImg, 'PNG', 12, 3, 40, 25);
//     } catch (error) {
//       console.log('Logo not found, using text instead');
//       // Fallback to text logo
//       pdf.setTextColor(255, 255, 255);
//       pdf.setFontSize(20);
//       pdf.setFont('Verdana', 'bold');
//       pdf.text('Excerpt', 12, 25);
//     }

// // COMPANY TEXT (starts next to logo)
// const contentX = 60; // space after logo
// const contentY = 8;

// pdf.setTextColor(255, 255, 255);
// pdf.setFont('Verdana', 'bold');
// pdf.setFontSize(12);
// pdf.text('Excerpt Technologies Pvt Ltd', contentX, contentY);

// pdf.setFont('Verdana', 'normal');
// pdf.setFontSize(8);
// pdf.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', contentX, contentY + 5.5);
// pdf.text('Mahadevpura Post, Bangalore – 560048', contentX, contentY + 9.5);
// pdf.text('Phone:+91(636) 465 7660, +91 (990) 050 2404 GSTIN:', contentX, contentY + 13.5);
// pdf.text('29AAGCE2327K1ZH', contentX, contentY + 17.5);
// pdf.text('LUT No.: AD291021005439D', contentX, contentY + 21.5);

// // INVOICE TEXT AT FAR RIGHT
// pdf.setFont('Verdana', 'bold');
// pdf.setFontSize(18);
// pdf.text('INVOICE', pageWidth - 15, contentY + 21.5, { align: 'right' });

// // Reset for content
// pdf.setTextColor(0, 0, 0);
// currentY = 40;



//     pdf.setDrawColor(0, 0, 0);
//     pdf.setLineWidth(0.05);
//     pdf.rect(10, currentY, pageWidth - 20, pageHeight - currentY - 20);



//     // Invoice details section
//     currentY += 7;
//     pdf.setFontSize(9);
//     pdf.setFont('Verdana', 'normal');

//     // Left column - Invoice details
//     pdf.text('Invoice:', 15, currentY);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text(invoice.invoiceNumber, 35, currentY);

//     pdf.setFont('Verdana', 'normal');
//     pdf.text('Date:', 15, currentY + 6);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text(formatDate(invoice.date), 35, currentY + 6);

//     pdf.setFont('Verdana', 'normal');
//     pdf.text('Terms:', 15, currentY + 12);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text(invoice.terms, 35, currentY + 12);

//     pdf.setFont('Verdana', 'normal');
//     pdf.text('Due Date:', 15, currentY + 18);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text(formatDate(invoice.dueDate), 35, currentY + 18);

//     currentY += 26;

//     // Calculate dynamic height for address sections based on content
//     const calculateAddressHeight = (billToAddress, shipToAddress, billToCity, shipToCity) => {
//       const baseHeight = 12; // Minimum height for headers and names
//       const lineHeight = 4;

//       // Calculate lines needed for bill to address
//       const billToAddressLines = billToAddress ? billToAddress.split('\n').length : 0;
//       const billToCityLines = billToCity ? Math.ceil(pdf.getTextWidth(billToCity) / 80) : 0;
//       const billToTotalLines = billToAddressLines + billToCityLines;

//       // Calculate lines needed for ship to address
//       const shipToAddressLines = shipToAddress ? shipToAddress.split('\n').length : 0;
//       const shipToCityLines = shipToCity ? Math.ceil(pdf.getTextWidth(shipToCity) / 80) : 0;
//       const shipToTotalLines = shipToAddressLines + shipToCityLines;

//       // Use the maximum lines needed plus some padding
//       const maxLines = Math.max(billToTotalLines, shipToTotalLines);
//       return Math.max(baseHeight + (maxLines * lineHeight) + 8, 35); // Minimum 35mm height
//     };

//     // Bill To and Ship To sections with dynamic borders
//     const billToX = 15;
//     const shipToX = 107;
//     const sectionWidth = 88;
//     const sectionHeight = calculateAddressHeight(
//       invoice.billToAddress, 
//       invoice.shipToAddress, 
//       invoice.billToCity, 
//       invoice.shipToCity
//     );

//     // Draw borders for Bill To and Ship To sections
//     pdf.setDrawColor(0, 0, 0);
//     pdf.setLineWidth(0.1);

//     // Bill To border
//     pdf.rect(billToX, currentY, sectionWidth, sectionHeight);

//     // Ship To border  
//     pdf.rect(shipToX, currentY, sectionWidth, sectionHeight);

//     // Headers with background
//     pdf.setFillColor(240, 240, 240);
//     pdf.rect(billToX, currentY, sectionWidth, 8, 'F');
//     pdf.rect(shipToX, currentY, sectionWidth, 8, 'F');

//     // Header borders
//     pdf.line(billToX, currentY + 8, billToX + sectionWidth, currentY + 8);
//     pdf.line(shipToX, currentY + 8, shipToX + sectionWidth, currentY + 8);

//     pdf.setFontSize(10);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Bill To:', billToX + 3, currentY + 6);
//     pdf.text('Ship To:', shipToX + 3, currentY + 6);

//     let billToY = currentY + 12;
//     let shipToY = currentY + 12;

//     // Names in bold
//     pdf.setFontSize(9);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text(invoice.billToName.toUpperCase(), billToX + 3, billToY);
//     pdf.text(invoice.shipToName.toUpperCase(), shipToX + 3, shipToY);

//     billToY += 6;
//     shipToY += 6;

//     // Helper function to wrap text within column width
//     const wrapText = (text, maxWidth) => {
//       const words = text.split(' ');
//       const lines = [];
//       let currentLine = '';

//       for (let word of words) {
//         const testLine = currentLine + (currentLine ? ' ' : '') + word;
//         const testWidth = pdf.getTextWidth(testLine);

//         if (testWidth > maxWidth && currentLine) {
//           lines.push(currentLine);
//           currentLine = word;
//         } else {
//           currentLine = testLine;
//         }
//       }

//       if (currentLine) {
//         lines.push(currentLine);
//       }

//       return lines;
//     };

//     // Bill To Address - properly wrapped
//     pdf.setFont('Verdana', 'normal');
//     if (invoice.billToAddress) {
//       const billToAddressLines = invoice.billToAddress.split('\n');
//       const maxTextWidth = sectionWidth - 6;

//       for (let line of billToAddressLines) {
//         const wrappedLines = wrapText(line, maxTextWidth);
//         for (let wrappedLine of wrappedLines) {
//           if (billToY < currentY + sectionHeight - 2) {
//             pdf.text(wrappedLine, billToX + 3, billToY);
//             billToY += 4;
//           }
//         }
//       }
//     }

//     // Bill To City
//     if (invoice.billToCity && billToY < currentY + sectionHeight - 2) {
//       const cityLines = wrapText(invoice.billToCity, sectionWidth - 6);
//       for (let cityLine of cityLines) {
//         if (billToY < currentY + sectionHeight - 2) {
//           pdf.text(cityLine, billToX + 3, billToY);
//           billToY += 4;
//         }
//       }
//     }

//     // Ship To Address - properly wrapped
//     if (invoice.shipToAddress) {
//       const shipToAddressLines = invoice.shipToAddress.split('\n');

//       for (let line of shipToAddressLines) {
//         const wrappedLines = wrapText(line, sectionWidth - 6);
//         for (let wrappedLine of wrappedLines) {
//           if (shipToY < currentY + sectionHeight - 2) {
//             pdf.text(wrappedLine, shipToX + 3, shipToY);
//             shipToY += 4;
//           }
//         }
//       }
//     }

//     // Ship To City
//     if (invoice.shipToCity && shipToY < currentY + sectionHeight - 2) {
//       const cityLines = wrapText(invoice.shipToCity, sectionWidth - 6);
//       for (let cityLine of cityLines) {
//         if (shipToY < currentY + sectionHeight - 2) {
//           pdf.text(cityLine, shipToX + 3, shipToY);
//           shipToY += 4;
//         }
//       }
//     }

//     // Move currentY to after the Bill To/Ship To sections
//     currentY += sectionHeight + 5;

//     // Items table - FIXED VERSION
//     const tableStartY = currentY;
//     const tableStartX = 15;
//     const tableWidth = pageWidth - 30;
//     const descriptionWidth = tableWidth - 50;
//     const amountWidth = 50;

//     // Table header with proper styling
//     pdf.setFillColor(230, 230, 230);
//     pdf.rect(tableStartX, tableStartY, tableWidth, 10, 'F');
//     pdf.setDrawColor(0, 0, 0);
//     pdf.setLineWidth(0.1);

//     // Draw table header borders
//     pdf.rect(tableStartX, tableStartY, tableWidth, 10);
//     pdf.line(tableStartX + descriptionWidth, tableStartY, tableStartX + descriptionWidth, tableStartY + 10);

//     pdf.setFontSize(10);
//     pdf.setFont('Verdana', 'bold');
//     pdf.setTextColor(0, 0, 0);
//     pdf.text('Items & Description', tableStartX + 3, tableStartY + 7);
//     pdf.text('Amount', tableStartX + descriptionWidth + 15, tableStartY + 7);

//     currentY = tableStartY + 10;

//     // Table rows - COMPLETELY REWRITTEN for proper formatting
//     let rowNumber = 1;
//     const rowHeight = 8;

//     if (invoice.parts) {
//       invoice.parts.forEach((part, partIndex) => {
//         // Part title row with gray background
//         pdf.setFillColor(220, 220, 220);
//         pdf.rect(tableStartX, currentY, tableWidth, rowHeight, 'F');

//         // Draw borders
//         pdf.setDrawColor(0, 0, 0);
//         pdf.rect(tableStartX, currentY, tableWidth, rowHeight);
//         pdf.line(tableStartX + descriptionWidth, currentY, tableStartX + descriptionWidth, currentY + rowHeight);

//         pdf.setFontSize(9);
//         pdf.setFont('Verdana', 'bold');
//         pdf.setTextColor(0, 0, 0);
//         pdf.text(part.title, tableStartX + 3, currentY + 5.5);

//         currentY += rowHeight;

//         // Part items
//         if (part.items) {
//           part.items.forEach((item, itemIndex) => {
//             // Row background
//             pdf.setFillColor(255, 255, 255);
//             pdf.rect(tableStartX, currentY, tableWidth, rowHeight, 'F');

//             // Draw borders
//             pdf.setDrawColor(0, 0, 0);
//             pdf.rect(tableStartX, currentY, tableWidth, rowHeight);
//             pdf.line(tableStartX + descriptionWidth, currentY, tableStartX + descriptionWidth, currentY + rowHeight);

//             pdf.setFontSize(9);
//             pdf.setFont('Verdana', 'normal');
//             pdf.setTextColor(0, 0, 0);

//             // Item description with proper numbering
//             const description = `${rowNumber}. ${item.description}`;
//             pdf.text(description, tableStartX + 3, currentY + 5.5);

//             // Amount - right aligned within amount column
//             pdf.setFont('NotoSans', 'normal');
//             const amountText = formatCurrency(item.amount);
//             const amountX = tableStartX + descriptionWidth + amountWidth - 3 - pdf.getTextWidth(amountText);
//             pdf.text(amountText, amountX, currentY + 5.5);

//             currentY += rowHeight;
//             rowNumber++;
//           });
//         }
//       });
//     }

//     // Close table with bottom border
//     pdf.setDrawColor(0, 0, 0);
//     pdf.line(tableStartX, currentY, tableStartX + tableWidth, currentY);

//     currentY += 8;

//     // Create a two-column layout for totals section
//     const leftColumnX = 15;
//     const rightColumnX = pageWidth - 95; // Adjusted for better alignment
//     const rightColumnWidth = 80;

//     // Total in words (left side)
//     pdf.setFontSize(10);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Total In Words:', leftColumnX, currentY);

//     pdf.setFontSize(9);
//     pdf.setFont('Verdana', 'normal');
//     const totalInWords = convertNumberToWords(invoice.total);
//     pdf.text(totalInWords, leftColumnX, currentY + 6);

//     // Totals section (right side) - Fixed alignment
//     pdf.setFontSize(9);

//     // Sub Total
//     pdf.setFont('Verdana', 'normal');
//     pdf.text('Sub Total:', rightColumnX +30, currentY);
//     pdf.setFont('NotoSans', 'normal');
//     const subTotalText = formatCurrency(invoice.subTotal);
//     pdf.text(subTotalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(subTotalText), currentY);

//     // CGST
//     pdf.setFont('Verdana', 'normal');
//     pdf.text(`CGST (${invoice.cgstRate || 0}%):`, rightColumnX +30, currentY + 6);
//     pdf.setFont('NotoSans', 'normal');
//     const cgstText = formatCurrency(invoice.cgst || 0);
//     pdf.text(cgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(cgstText), currentY + 6);

//     // SGST
//     pdf.setFont('Verdana', 'normal');
//     pdf.text(`SGST (${invoice.sgstRate || 0}%):`, rightColumnX +30, currentY + 12);
//     pdf.setFont('NotoSans', 'normal');
//     const sgstText = formatCurrency(invoice.sgst || 0);
//     pdf.text(sgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(sgstText), currentY + 12);

//     // Total
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Total:', rightColumnX +30, currentY + 18);
//     pdf.setFont('NotoSans', 'normal');
//     const totalText = formatCurrency(invoice.total);
//     pdf.text(totalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(totalText), currentY + 18);

//     // Balance Due
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Balance Due:', rightColumnX +30, currentY + 24);
//     pdf.setFont('NotoSans', 'normal');
//     const balanceText = formatCurrency(invoice.balanceDue || invoice.total);
//     pdf.text(balanceText, rightColumnX + rightColumnWidth - pdf.getTextWidth(balanceText), currentY + 24);

//     currentY += 35;

//     // Thank you message
//     pdf.setFontSize(9);
//     pdf.setFont('Verdana', 'normal');
//     pdf.text('Thank you for the valuable business! We will always be at', 15, currentY);
//     pdf.text('your desk to support you.', 15, currentY + 5);

//     // Authorized signature section with seal and signature images
//     const signatureY = currentY + 15;

//     // Add signature image if available
//     try {
//       const signatureImg = './image/sign.jpeg';
//       pdf.addImage(signatureImg, 'JPEG', rightColumnX + 52, signatureY -20, 30, 15);
//     } catch (error) {
//       console.log('Signature image not found');
//     }

//     // Add company seal if available
//     try {
//       const sealImg = './image/seal.jpeg';
//       pdf.addImage(sealImg, 'JPEG', rightColumnX + 12, signatureY - 22, 25, 25);
//     } catch (error) {
//       console.log('Seal image not found');
//     }

//     // Scanner image (QR code) if available
//     try {
//       const scannerImg = './image/scanner.png';
//       pdf.addImage(scannerImg, 'PNG', rightColumnX + 50, signatureY +9, 20, 20);
//     } catch (error) {
//       console.log('Scanner image not found');
//     }

//     pdf.setFont('Verdana', 'normal');
//     pdf.text('Authorized Signature', rightColumnX + 10, signatureY +10);

//     currentY = signatureY - 5;

//     // Terms and Bank Details - Fixed layout
//     pdf.setFontSize(8);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Terms & Conditions:', 15, currentY);


//     pdf.setFont('Verdana', 'normal');
//     currentY +=5;

//     // Terms (left column)
//     pdf.text('Full payment is due upon receipt of this invoice. Late', 15, currentY);
//     pdf.text('payment may incur additional charges as per the applicable rates.', 15, currentY + 4);
//         currentY=signatureY +8
//             pdf.setFontSize(8);
//     pdf.setFont('Verdana', 'bold');
//     pdf.text('Our Bank Details:', 15, currentY);
//      currentY += 5;
//        pdf.setFont('Verdana', 'normal');
//     // Bank Details (right column)
//     pdf.text('Name: Excerpt Technologies Private Limited', 15, currentY);
//     pdf.text('Account Number: 10063739760', 15, currentY + 4);
//     pdf.text('Name of Bank: IDFC First Bank', 15, currentY + 8);
//     pdf.text('IFSC Code: IDFB0080151', 15, currentY + 12);
//     pdf.text('PAN No: AAGCE2327K', 15, currentY + 16);

//     // Footer
//     // const footerY = pageHeight - 25;
//     // pdf.setDrawColor(0, 0, 0);
//     // pdf.line(15, footerY, pageWidth - 15, footerY);

//     pdf.setFontSize(8);
//     pdf.setTextColor(0, 0, 255);
//     pdf.text('https://excerptech.com', 15, currentY+30);
//     pdf.setTextColor(0, 0, 0);
//     pdf.text('E-mail: info@excerptech.com', pageWidth - 65, currentY+30);

//     // Download the PDF
//     pdf.save(`invoice-${invoice.invoiceNumber}.pdf`);

//   } catch (error) {
//     console.error('Error generating PDF:', error);
//     alert('Error generating PDF. Please try again.');
//   } finally {
//     setDownloading(null);
//   }
// };




//   if (loading) return <div className="loading">Loading invoices...</div>;
//   if (error) return <div className="error">Error: {error}</div>;

//   return (
//     <div className="invoice-list-container">
//       <h2>All Invoices</h2>

//       {invoices.length === 0 ? (
//         <div className="no-invoices">No invoices found.</div>
//       ) : (
//         <div className="table-container">
//           <table className="invoice-table">
//             <thead>
//               <tr>
//                 <th>Invoice Number</th>
//                 <th>Date</th>
//                 <th>Bill To</th>
//                 <th>Total Amount</th>
//                 {/* <th>Status</th> */}
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {invoices.map((invoice) => (
//                 <tr key={invoice._id}>
//                   <td>{invoice.invoiceNumber}</td>
//                   <td>{new Date(invoice.date).toLocaleDateString('en-GB')}</td>
//                   <td>{invoice.billToName}</td>
//                   <td>₹ {invoice.total}</td>
//                   {/* <td>
//                     <span className={`status ${invoice.balanceDue > 0 ? 'pending' : 'paid'}`}>
//                       {invoice.balanceDue > 0 ? 'Pending' : 'Paid'}
//                     </span>
//                   </td> */}
//                   <td>
//                     <button 
//                       onClick={() => downloadInvoicePDF(invoice)}
//                       disabled={downloading === invoice._id}
//                       className="download-btn"
//                     >
//                       {downloading === invoice._id ? 'Generating...' : 'Download PDF'}
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default InvoiceList;




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import './InvoiceList.css';
import InvoiceComponent from './InvoiceComponent';
import { notoSansBase64 } from './notosans';
import { verdanaFont } from './verdant';
import { verdanaboldFont } from './verdanbold';


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const InvoiceList = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [downloading, setDownloading] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(null);
  // Edit Modal States
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [editFormData, setEditFormData] = useState({});
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    try {
      const response = await axios.get('/invoices');
      setInvoices(response.data);
      setLoading(false);
    } catch (error) {
      setError(error.response?.data?.message || 'Error fetching invoices');
      setLoading(false);
    }
  };

  // Open Edit Modal
  // const openEditModal = (invoice) => {
  //   setEditingInvoice(invoice);
  //   setEditFormData({
  //     invoiceNumber: invoice.invoiceNumber,
  //     date: invoice.date ? invoice.date.split('T')[0] : '',
  //     terms: invoice.terms || '',
  //     dueDate: invoice.dueDate ? invoice.dueDate.split('T')[0] : '',
  //     billToName: invoice.billToName || '',
  //     billToAddress: invoice.billToAddress || '',
  //     billToCity: invoice.billToCity || '',
  //     shipToName: invoice.shipToName || '',
  //     shipToAddress: invoice.shipToAddress || '',
  //     shipToCity: invoice.shipToCity || '',
  //     balanceDue: invoice.balanceDue || '',
  //     totalInWords: invoice.totalInWords || '',
  //     thankYouMessage: invoice.thankYouMessage || '',
  //     termsAndConditions: invoice.termsAndConditions || '',
  //     bankDetails: invoice.bankDetails || '',
  //     parts: invoice.parts || [{ title: 'Part A', items: [{ description: '', amount: '' }] }],
  //     cgstRate: invoice.cgstRate || '',
  //     sgstRate: invoice.sgstRate || ''
  //   });
  //   setShowEditModal(true);
  // };
  const [cgstRate, setCgstRate] = useState('');
  const [sgstRate, setSgstRate] = useState('');
  const openEditModal = (invoice) => {
    setEditingInvoice(invoice);
    setEditFormData({
      invoiceNumber: invoice.invoiceNumber, // Make this editable
      date: invoice.date ? invoice.date.split('T')[0] : '',
      terms: invoice.terms || '',
      dueDate: invoice.dueDate ? invoice.dueDate.split('T')[0] : '',
      billToName: invoice.billToName || '',
      billtocompanyname: invoice.billtocompanyname || '',
      billToAddress: invoice.billToAddress || '',
      billToemail: invoice.billToemail || '',
      billTophone: invoice.billTophone || '',
      billTogstin: invoice.billTogstin || '',

      shipToName: invoice.shipToName || '',
      shipTocompanyname: invoice.shipTocompanyname || '',
      shipToAddress: invoice.shipToAddress || '',
      shipToemail: invoice.shipToemail || '',
      shipTophone: invoice.shipTophone || '',
      shipTogstin: invoice.shipTogstin || '',
      balanceDue: invoice.balanceDue || invoice.total || '', // Show total as balance due
      totalInWords: invoice.totalInWords || '',
      thankYouMessage: invoice.thankYouMessage || '',
      termsAndConditions: invoice.termsAndConditions || '',
      bankDetails: invoice.bankDetails || '',
      parts: invoice.parts || [{ title: 'Part A', items: [{ description: '', amount: '' }] }],
      cgstRate: invoice.cgstRate || '',
      sgstRate: invoice.sgstRate || '',
      total: invoice.total || '',// Add total field
      discounts: invoice.discounts
    });
    setShowEditModal(true);
  };
  // Handle form input changes
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setEditFormData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  // };

  // Handle part changes
  const handlePartTitleChange = (index, value) => {
    const newParts = [...editFormData.parts];
    newParts[index].title = value;
    setEditFormData(prev => ({
      ...prev,
      parts: newParts
    }));
  };
  // 1. ADD THIS CALCULATION FUNCTION (add this after your existing functions, around line 200)
  // const calculateTotals = (parts, cgstRate = 0, sgstRate = 0) => {
  //   // Calculate subtotal from all parts
  //   const subTotal = parts.reduce((total, part) => {
  //     const partTotal = part.items.reduce((partSum, item) => {
  //       return partSum + (parseFloat(item.amount) || 0);
  //     }, 0);
  //     return total + partTotal;
  //   }, 0);

  //   // Calculate taxes
  //   const cgst = (subTotal * (parseFloat(cgstRate) || 0)) / 100;
  //   const sgst = (subTotal * (parseFloat(sgstRate) || 0)) / 100;

  //   // Calculate final total
  //   const total = subTotal + cgst + sgst;

  //   return {
  //     subTotal: subTotal.toFixed(2),
  //     cgst: cgst.toFixed(2),
  //     sgst: sgst.toFixed(2),
  //     total: total.toFixed(2)
  //   };
  // };

  // 2. ADD useEffect TO AUTO-CALCULATE (add this after your existing useEffects, around line 220)
  // useEffect(() => {
  //   if (editFormData.parts && editFormData.parts.length > 0) {
  //     const calculations = calculateTotals(
  //       editFormData.parts, 
  //       editFormData.cgstRate, 
  //       editFormData.sgstRate
  //     );

  //     setEditFormData(prev => ({
  //       ...prev,
  //       subTotal: calculations.subTotal,
  //       cgst: calculations.cgst,
  //       sgst: calculations.sgst,
  //       total: calculations.total,
  //       balanceDue: calculations.total, // Set balance due equal to total by default
  //       totalInWords: convertNumberToWords(calculations.total)
  //     }));
  //   }
  // }, [editFormData.parts, editFormData.cgstRate, editFormData.sgstRate]);
  const calculateTotals = (parts, cgstRate = 0, sgstRate = 0, discounts = []) => {
    // Calculate subtotal from all parts
    const subTotal = parts.reduce((total, part) => {
      const partTotal = part.items.reduce((partSum, item) => {
        return partSum + (parseFloat(item.amount) || 0);
      }, 0);
      return total + partTotal;
    }, 0);

    // Calculate total discount amount
    const totalDiscount = discounts.reduce((total, discount) => {
      return total + (parseFloat(discount.amount) || 0);
    }, 0);

    // Calculate taxes on subtotal after discount
    const taxableAmount = subTotal - totalDiscount;
    const cgst = (taxableAmount * (parseFloat(cgstRate) || 0)) / 100;
    const sgst = (taxableAmount * (parseFloat(sgstRate) || 0)) / 100;

    // Calculate final total
    const total = taxableAmount + cgst + sgst;

    return {
      subTotal: subTotal.toFixed(2),
      totalDiscount: totalDiscount.toFixed(2),
      cgst: cgst.toFixed(2),
      sgst: sgst.toFixed(2),
      total: total.toFixed(2)
    };
  };
  useEffect(() => {
    if (editFormData.parts && editFormData.parts.length > 0) {
      const calculations = calculateTotals(
        editFormData.parts,
        editFormData.cgstRate,
        editFormData.sgstRate,
        editFormData.discounts || [] // ADD THIS LINE
      );

      setEditFormData(prev => ({
        ...prev,
        subTotal: calculations.subTotal,
        totalDiscount: calculations.totalDiscount, // ADD THIS LINE
        cgst: calculations.cgst,
        sgst: calculations.sgst,
        total: calculations.total,
        balanceDue: calculations.total,
        totalInWords: convertNumberToWords(calculations.total)
      }));
    }
  }, [editFormData.parts, editFormData.cgstRate, editFormData.sgstRate, editFormData.discounts]); // ADD discounts to dependency array

  // // Add these functions after your existing handler functions
  // const handleDiscountChange = (index, field, value) => {
  //   const newDiscounts = [...(editFormData.discounts || [])];
  //   newDiscounts[index][field] = value;
  //   setEditFormData(prev => ({
  //     ...prev,
  //     discounts: newDiscounts
  //   }));
  // };
  const handleDiscountChange = (index, field, value) => {
    const newDiscounts = [...(editFormData.discounts || [])];

    if (field === 'amount') {
      // Validate amount: only numbers up to 9 digits and optional 2 decimal places
      if (value === '' || /^\d{1,9}(\.\d{0,2})?$/.test(value)) {
        newDiscounts[index][field] = value;
        setEditFormData(prev => ({
          ...prev,
          discounts: newDiscounts
        }));
      }
      return;
    }

    // For other fields, update directly
    newDiscounts[index][field] = value;
    setEditFormData(prev => ({
      ...prev,
      discounts: newDiscounts
    }));
  };
  const validateEmail = (email) => {
    if (!email) return true; // Optional field

    // Regex: local part does NOT contain '@' or '.', then '@', then a domain with at least one dot.
    const emailRegex = /^[^@.\s]+@[^@\s]+\.[^@\s]+$/;

    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    if (!phone) return true; // Optional field
    // Remove spaces and check format: +91 followed by 10 digits starting with 6,7,8,9
    const cleanPhone = phone.replace(/\s+/g, '');
    const phoneRegex = /^\+91[6-9]\d{9}$/;
    return phoneRegex.test(cleanPhone);
  };

  const validateGST = (gst) => {
    if (!gst) return true; // Optional field
    // GST format: 15 characters alphanumeric
    const gstRegex = /^[A-Z0-9]{15}$/;
    return gstRegex.test(gst.toUpperCase());
  };
  const handleAddDiscount = () => {
    setEditFormData(prev => ({
      ...prev,
      discounts: [{ label: '', amount: '' }]
    }));
  };

  const handleDeleteDiscount = (index) => {
    const newDiscounts = [...(editFormData.discounts || [])];
    newDiscounts.splice(index, 1);
    setEditFormData(prev => ({
      ...prev,
      discounts: newDiscounts
    }));
  };

  const handlePartItemChange = (partIndex, itemIndex, field, value) => {
    const newParts = [...editFormData.parts];
    newParts[partIndex].items[itemIndex][field] = value;
    setEditFormData(prev => ({
      ...prev,
      parts: newParts
    }));

  };

  const addPartItem = (partIndex) => {
    const newParts = [...editFormData.parts];
    newParts[partIndex].items.push({ description: '', amount: '' });
    setEditFormData(prev => ({
      ...prev,
      parts: newParts
    }));
  };

  const removePartItem = (partIndex, itemIndex) => {
    const newParts = [...editFormData.parts];
    newParts[partIndex].items.splice(itemIndex, 1);
    setEditFormData(prev => ({
      ...prev,
      parts: newParts
    }));
  };

  const addNewPart = () => {
    const nextChar = String.fromCharCode(65 + editFormData.parts.length);
    setEditFormData(prev => ({
      ...prev,
      parts: [...prev.parts, { title: `Part ${nextChar}`, items: [{ description: '', amount: '' }] }]
    }));
  };

  const removePart = (index) => {
    const newParts = editFormData.parts.filter((_, i) => i !== index);
    setEditFormData(prev => ({
      ...prev,
      parts: newParts
    }));
  };
  //   const removePartItem = (partIndex, itemIndex) => {
  //   const newParts = [...editFormData.parts];

  //   // Don't remove if it's the last item in the part
  //   if (newParts[partIndex].items.length <= 1) {
  //     alert('Cannot remove the last item. Each part must have at least one item.');
  //     return;
  //   }

  //   newParts[partIndex].items.splice(itemIndex, 1);

  //   setEditFormData(prev => ({
  //     ...prev,
  //     parts: newParts
  //   }));
  // };
  const convertNumberToWords = (amount) => {
    const words = [
      '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
      'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
      'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
      'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const convert = (num) => {
      if (num < 20) return words[num];
      if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + words[num % 10] : '');
      if (num < 1000) return words[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' and ' + convert(num % 100) : '');
      if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + convert(num % 1000) : '');
      if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + convert(num % 100000) : '');
      return convert(Math.floor(num / 10000000)) + ' Crore' + (num % 10000000 ? ' ' + convert(num % 10000000) : '');
    };

    const [whole, decimal] = Number(amount).toFixed(2).split('.');
    const inWords = convert(parseInt(whole)) + ' Rupees';
    const paisa = parseInt(decimal) ? ' and ' + convert(parseInt(decimal)) + ' Paise' : '';
    return inWords + paisa + ' only';
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB');
  };

  const formatCurrency = (amount) => {
    return `₹ ${parseFloat(amount).toFixed(2)}`;
  };
  ;

  // 1. ADD THIS STATE for preview modal (add this with your other state declarations)
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewPdfUrl, setPreviewPdfUrl] = useState(null);
  const [previewing, setPreviewing] = useState(null);

  // 2. ADD THIS PREVIEW FUNCTION (add this after your downloadInvoicePDF function)


  const downloadInvoicePDF = async (invoice) => {
    try {
      setDownloading(invoice._id);

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add custom fonts
      pdf.addFileToVFS('Verdana.ttf', verdanaFont);
      pdf.addFont('Verdana.ttf', 'Verdana', 'normal');

      pdf.addFileToVFS('Verdana-Bold.ttf', verdanaboldFont);
      pdf.addFont('Verdana-Bold.ttf', 'Verdana', 'bold');

      pdf.addFileToVFS('NotoSans.ttf', notoSansBase64);
      pdf.addFont('NotoSans.ttf', 'NotoSans', 'normal');

      let currentY = 25;

      // Header Section with Blue Background - exact match
      // pdf.setFillColor(59, 130, 246); // Blue color
      // pdf.rect(200, 100, pageWidth, 35, 'F');

      // HEADER BACKGROUND

      pdf.setFillColor(0, 81, 255); // Rich blue like in the image
      pdf.rect(10, 5, pageWidth - 20, 28, 'F');

      // LOGO on the LEFT
      try {
        const logoImg = './image/excerpt.png';
        pdf.addImage(logoImg, 'PNG', 12, 12, 35, 14);
      } catch (error) {
        console.log('Logo not found, using text instead');
        // Fallback to text logo
        pdf.setTextColor(255, 255, 255);
        pdf.setFontSize(20);
        pdf.setFont('Verdana', 'bold');
        pdf.text('Excerpt', 12, 25);
      }

      // COMPANY TEXT (starts next to logo)
      const contentX = 60; // space after logo
      const contentY = 10;

      pdf.setTextColor(255, 255, 255);
      pdf.setFont('NotoSans', 'normal');
      pdf.setFontSize(12);
      pdf.text('Excerpt Technologies Pvt Ltd', contentX, contentY);

      pdf.setFont('NotoSans', 'normal');
      pdf.setFontSize(8);
      pdf.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', contentX, contentY + 5.5);
      pdf.text('Mahadevpura Post, Bangalore – 560048', contentX, contentY + 9.5);
      pdf.text('Phone:+91(636) 465 7660, +91 (990) 050 2404 ', contentX, contentY + 13.5);
      pdf.text('GSTIN:29AAGCE2327K1ZH', contentX, contentY + 17.5);
      pdf.text('LUT No.: AD291021005439D', contentX, contentY + 21.5);

      // INVOICE TEXT AT FAR RIGHT
      pdf.setFont('NotoSans', 'bold');
      pdf.setFontSize(18);
      pdf.text('INVOICE', pageWidth - 15, contentY + 15.5, { align: 'right' });

      // Reset for content
      pdf.setTextColor(0, 0, 0);
      currentY = 30;



      pdf.setDrawColor(0, 0, 0);

      pdf.setLineWidth(0.05);

      // pdf.rect(10, currentY, pageWidth - 20, pageHeight - currentY - 20); kARTHIK
      const mainBoxY = currentY;
      const mainBoxHeight = pageHeight - mainBoxY - 20;
      pdf.rect(10, mainBoxY + 3, pageWidth - 20, mainBoxHeight);




      // Invoice details section KARTHIK//
      // currentY += 7;
      // pdf.setFontSize(9);
      // pdf.setFont('Verdana', 'normal');

      // pdf.text('Invoice:', 15, currentY);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text(invoice.invoiceNumber, 35, currentY);

      // pdf.setFont('Verdana', 'normal');
      // pdf.text('Date:', 15, currentY + 6);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text(formatDate(invoice.date), 35, currentY + 6);

      // pdf.setFont('Verdana', 'normal');
      // pdf.text('Terms:', 15, currentY + 12);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text(invoice.terms, 35, currentY + 12);

      // pdf.setFont('Verdana', 'normal');
      // pdf.text('Due Date:', 15, currentY + 18);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text(formatDate(invoice.dueDate), 35, currentY + 18);





      // Invoice Info Container
      const infoBoxX = 10;
      const infoBoxWidth = pageWidth - 20;
      const infoBoxHeight = 22;
      pdf.rect(infoBoxX, currentY + 3, infoBoxWidth, infoBoxHeight); // Outer border

      // Split into two columns
      const midX = infoBoxX + infoBoxWidth / 2;
      pdf.line(midX, currentY + 3, midX, currentY + infoBoxHeight + 3); // Vertical center line

      // Left Column
      pdf.setFontSize(8);
      pdf.setFont('Verdana', 'normal');
      pdf.text('Invoice', infoBoxX + 4, currentY + 7);
      pdf.text('Date', infoBoxX + 4, currentY + 12);
      pdf.text('Terms', infoBoxX + 4, currentY + 17);
      pdf.text('Due Date', infoBoxX + 4, currentY + 22);

      // Values (bold)
      pdf.setFont('Verdana', 'bold');
      pdf.text(`: ${invoice.invoiceNumber}`, infoBoxX + 28, currentY + 7);
      pdf.text(`: ${formatDate(invoice.date)}`, infoBoxX + 28, currentY + 12);
      pdf.text(`: ${invoice.terms}`, infoBoxX + 28, currentY + 17);
      pdf.text(`: ${formatDate(invoice.dueDate)}`, infoBoxX + 28, currentY + 22);

      // Right Column (blank or for future use if needed)
      // You can fill it if required


      currentY += infoBoxHeight + 3;



      const calculateAddressHeight = (billToName, billToCompanyName, billToAddress, billToEmail, billToPhone, billToGstin,
        shipToName, shipToCompanyName, shipToAddress, shipToEmail, shipToPhone, shipToGstin) => {
        const baseHeight = 12; // Minimum height for headers
        const lineHeight = 4;

        // Calculate lines needed for bill to section
        let billToLines = 0;
        if (billToName) billToLines += 1; // Name line
        if (billToCompanyName) billToLines += 1; // Company name line
        if (billToAddress) billToLines += billToAddress.split('\n').length; // Address lines
        if (billToEmail) billToLines += 1; // Email line
        if (billToPhone) billToLines += 1; // Phone line
        if (billToGstin) billToLines += 1; // GSTIN line

        // Calculate lines needed for ship to section
        let shipToLines = 0;
        if (shipToName) shipToLines += 1; // Name line
        if (shipToCompanyName) shipToLines += 1; // Company name line
        if (shipToAddress) shipToLines += shipToAddress.split('\n').length; // Address lines
        if (shipToEmail) shipToLines += 1; // Email line
        if (shipToPhone) shipToLines += 1; // Phone line
        if (shipToGstin) shipToLines += 1; // GSTIN line

        // Use the maximum lines needed plus some padding
        const maxLines = Math.max(billToLines, shipToLines);
        return Math.max(baseHeight + (maxLines * lineHeight) + 8, 36); // Minimum 36mm height
      };

      // Bill To and Ship To sections with dynamic borders
      const billToX = 10;
      const shipToX = 105;
      const sectionWidth = 95;
      const sectionHeight = calculateAddressHeight(
        invoice.billToName,
        invoice.billToCompanyName,
        invoice.billToAddress,
        invoice.billToEmail,
        invoice.billToPhone,
        invoice.billToGstin,
        invoice.shipToName,
        invoice.shipToCompanyName,
        invoice.shipToAddress,
        invoice.shipToEmail,
        invoice.shipToPhone,
        invoice.shipToGstin
      );


      // Draw borders for Bill To and Ship To sections
      pdf.setDrawColor(0, 0, 0);
      pdf.setLineWidth(0.1);
      pdf.setFillColor(220, 220, 220);
      // Bill To border KARTHIK //
      // pdf.rect(billToX, currentY, sectionWidth, sectionHeight);

      pdf.rect(billToX, currentY, sectionWidth * 2, sectionHeight);

      // pdf.rect(shipToX, currentY, sectionWidth, sectionHeight);
      pdf.line(shipToX, currentY, shipToX, currentY + sectionHeight);

      // Headers with background KARTHIK//

      pdf.rect(billToX + 0.1, currentY + 0.5, sectionWidth - 0.6, 4, 'F');
      pdf.rect(shipToX + 0.1, currentY + 0.5, sectionWidth - 0.6, 4, 'F');

      // Header borders

      pdf.line(billToX, currentY + 4, billToX + sectionWidth, currentY + 4);
      pdf.line(shipToX, currentY + 4, shipToX + sectionWidth, currentY + 4);

      // pdf.setFontSize(10);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text('Bill To:', billToX + 1, currentY + 3.7);
      // pdf.text('Ship To:', shipToX + 1, currentY + 3.7);

      let billToY = currentY + 10;
      let shipToY = currentY + 10;

      // Names in bold
      // pdf.setFontSize(9);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text(invoice.billToName.toUpperCase(), billToX + 3, billToY);
      // pdf.text(invoice.shipToName.toUpperCase(), shipToX + 3, shipToY);

      billToY += 6;
      shipToY += 6;

      // Helper function to wrap text within column width
      const wrapText = (text, maxWidth) => {
        const words = text.split(' ');
        const lines = [];
        let currentLine = '';

        for (let word of words) {
          const testLine = currentLine + (currentLine ? ' ' : '') + word;
          const testWidth = pdf.getTextWidth(testLine);

          if (testWidth > maxWidth && currentLine) {
            lines.push(currentLine);
            currentLine = word;


          } else {
            currentLine = testLine;
          }
        }

        if (currentLine) {
          lines.push(currentLine);
        }

        return lines;
      };

      // Bill To Address - properly wrapped
      pdf.setFont('Verdana', 'normal');
      // if (invoice.billToAddress) {
      //   const billToAddressLines = invoice.billToAddress.split('\n');
      //   const maxTextWidth = sectionWidth - 6;

      //   for (let line of billToAddressLines) {
      //     const wrappedLines = wrapText(line, maxTextWidth);
      //     for (let wrappedLine of wrappedLines) {
      //       if (billToY < currentY + sectionHeight - 2) {
      //         pdf.text(wrappedLine, billToX + 3, billToY);
      //         billToY += 4;
      //       }
      //     }
      //   }
      // }

      // // Bill To City
      // if (invoice.billToCity && billToY < currentY + sectionHeight - 2) {
      //   const cityLines = wrapText(invoice.billToCity, sectionWidth - 6);
      //   for (let cityLine of cityLines) {
      //     if (billToY < currentY + sectionHeight - 2) {
      //       pdf.text(cityLine, billToX + 3, billToY);
      //       billToY += 4;
      //     }
      //   }
      // }

      // Ship To Address - properly wrapped
      // if (invoice.shipToAddress) {
      //   const shipToAddressLines = invoice.shipToAddress.split('\n');

      //   for (let line of shipToAddressLines) {
      //     const wrappedLines = wrapText(line, sectionWidth - 6);
      //     for (let wrappedLine of wrappedLines) {
      //       if (shipToY < currentY + sectionHeight - 2) {
      //         pdf.text(wrappedLine, shipToX + 3, shipToY);
      //         shipToY += 4;
      //       }
      //     }
      //   }
      // }

      // // Ship To City
      // if (invoice.shipToCity && shipToY < currentY + sectionHeight - 2) {
      //   const cityLines = wrapText(invoice.shipToCity, sectionWidth - 6);
      //   for (let cityLine of cityLines) {
      //     if (shipToY < currentY + sectionHeight - 2) {
      //       pdf.text(cityLine, shipToX + 3, shipToY);
      //       shipToY += 4;
      //     }
      //   }
      // }


      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(7);
      pdf.setFillColor(230, 230, 230);

      pdf.text('Bill To', billToX + 2, currentY + 3);
      pdf.text('Ship To', shipToX + 2, currentY + 3);

      // Function to render address section content
      const renderAddressSection = (x, name, companyName, address, email, phone, gstin) => {
        let yOffset = currentY + 8; // Start below header

        // Name (first line)
        if (name) {
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(9);
          pdf.text(name, x + 2, yOffset);
          yOffset += 4;
        }

        // Company name (second line, bold)
        if (companyName) {
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(9);
          pdf.text(companyName, x + 2, yOffset);
          yOffset += 4;
        }

        // Address
        if (address) {
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(7);
          const maxLineWidth = 80; // Adjust as per your layout
          const addressLines = address.split('\n');

          addressLines.forEach(line => {
            if (line.trim()) {
              const wrappedLines = pdf.splitTextToSize(line.trim(), maxLineWidth);
              wrappedLines.forEach(wrappedLine => {
                pdf.text(wrappedLine, x + 2, yOffset);
                yOffset += 3;
              });
            }
          });
        }


        // Email
        if (email) {
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(7);
          pdf.text(`EMAIL: ${email}`, x + 2, yOffset + 1);
          yOffset += 3;
        }

        // Phone
        if (phone) {
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(7);
          pdf.text(`PHONE: ${phone}`, x + 2, yOffset + 1);
          yOffset += 3;
        }

        // GSTIN
        if (gstin) {
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(7);
          pdf.text(`GSTIN: ${gstin}`, x + 2, yOffset + 1);
          yOffset += 3;
        }
      };

      // Render Bill To section
      renderAddressSection(
        billToX,
        invoice.billToName,
        invoice.billtocompanyname,


        invoice.billToAddress,
        invoice.billToemail,
        invoice.billTophone,
        invoice.billTogstin
      );

      // Render Ship To section
      renderAddressSection(
        shipToX,
        invoice.shipToName,
        invoice.shipTocompanyname,
        invoice.shipToAddress,
        invoice.shipToemail,
        invoice.shipTophone,
        invoice.shipTogstin
      );

      // Update currentY to move past the address sections
      currentY += sectionHeight;
      // Move currentY to after the Bill To/Ship To sections


      // Items table - FIXED VERSION
      const tableStartY = currentY;
      const tableStartX = 10;
      const tableWidth = pageWidth - 20;
      const descriptionWidth = tableWidth - 50;
      const amountWidth = 50;

      // Table header with proper styling
      pdf.setFillColor(230, 230, 230);
      pdf.rect(tableStartX, tableStartY, tableWidth, 6, 'F');
      pdf.setDrawColor(0, 0, 0);
      pdf.setLineWidth(0.1);

      // Draw table header borders
      pdf.rect(tableStartX, tableStartY, tableWidth, 6);
      pdf.line(tableStartX + descriptionWidth + 20, tableStartY, tableStartX + descriptionWidth + 20, tableStartY + 10);

      pdf.setFontSize(8);
      pdf.setFont('Verdana', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('Items & Description', tableStartX + 3, tableStartY + 4);
      pdf.text('Amount', tableStartX + descriptionWidth + 30, tableStartY + 4);



      currentY = tableStartY + (5);

      // Table rows - COMPLETELY REWRITTEN for proper formatting
      let rowNumber = 1;
      const rowHeight = 7;

      if (invoice.parts) {
        invoice.parts.forEach((part, partIndex) => {
          // Part title row with gray background
          pdf.setFillColor(220, 220, 220);
          pdf.rect(tableStartX, currentY, tableWidth, rowHeight, 'F');

          // Draw borders
          pdf.setDrawColor(0, 0, 0);
          pdf.rect(tableStartX, currentY, tableWidth, rowHeight);
          pdf.line(tableStartX + descriptionWidth + 20, currentY, tableStartX + descriptionWidth + 20, currentY + rowHeight);

          pdf.setFontSize(8);
          pdf.setFont('Verdana', 'bold');
          pdf.setTextColor(0, 0, 0);
          pdf.text(part.title, tableStartX + 3, currentY + 4.5);

          currentY += rowHeight - 1;

          // Part items
          if (part.items) {
            part.items.forEach((item, itemIndex) => {
              // Row background
              pdf.setFillColor(255, 255, 255);
              pdf.rect(tableStartX, currentY, tableWidth, rowHeight, 'F');

              // Draw borders
              pdf.setDrawColor(0, 0, 0);
              pdf.rect(tableStartX, currentY, tableWidth, rowHeight);
              pdf.line(tableStartX + descriptionWidth + 20, currentY, tableStartX + descriptionWidth + 20, currentY + rowHeight);
              pdf.line(tableStartX + 7, currentY, tableStartX + 7, currentY + rowHeight);

              // Set font and color
              pdf.setFontSize(9);
              pdf.setFont('Verdana', 'normal');
              pdf.setTextColor(0, 0, 0);

              // Description with row number
              const description = `${rowNumber}.   ${item.description}`;
              pdf.text(description, tableStartX + 2, currentY + 5.5);

              // Fixed ₹ symbol alignment
              const rupeeX = tableStartX + descriptionWidth + 23; // Set column for ₹
              const amountText = formatCurrency(item.amount);     // Eg: "₹ 200"
              const valueText = amountText.replace('₹', '').trim(); // Remove ₹ for manual placement
              const valueX = rupeeX + 5; // space between ₹ and value

              // ₹ and amount
              pdf.setFont('NotoSans', 'normal');
              pdf.text('₹', rupeeX+2, currentY + 5.5);
              pdf.text(valueText, valueX+2, currentY + 5.5);

              currentY += rowHeight;
              rowNumber++;
            });
          }

        });
      }

      // Close table with bottom border
      pdf.setDrawColor(0, 0, 0);
      pdf.line(tableStartX, currentY, tableStartX + tableWidth, currentY);



      currentY += 8;

      // // Create a two-column layout for totals section KARTHIK
      // const leftColumnX = 15;
      // const maxTextWidth = 70;
      // const rightColumnX = pageWidth - 95; // Adjusted for better alignment
      // const rightColumnWidth = 80;

      // // Total in words (left side)
      // pdf.setFontSize(10);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text('Total In Words:', leftColumnX , currentY);

      // pdf.setFontSize(9);
      // pdf.setFont('Verdana', 'normal');

      // const totalInWords = convertNumberToWords(invoice.total);
      // const wrappedText = pdf.splitTextToSize(totalInWords, maxTextWidth);

      // pdf.text(wrappedText, leftColumnX, currentY + 6);

      // // Totals section (right side) - Fixed alignment
      // pdf.setFontSize(9);
      // pdf.line(pageWidth/1.5, (pageHeight/2)+7, pageWidth/1.5, pageHeight-100);
      //  pdf.line(pageWidth/1.5, pageHeight-100, pageWidth-10, pageHeight-100);
      // // Sub Total
      // pdf.setFont('Verdana', 'normal');
      // pdf.text('Sub Total:', rightColumnX +30, currentY);
      // pdf.setFont('NotoSans', 'normal');
      // const subTotalText = formatCurrency(invoice.subTotal);
      // pdf.text(subTotalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(subTotalText), currentY);

      // // CGST
      // pdf.setFont('Verdana', 'normal');
      // pdf.text(`CGST (${invoice.cgstRate || 0}%):`, rightColumnX +30, currentY + 6);
      // pdf.setFont('NotoSans', 'normal');
      // const cgstText = formatCurrency(invoice.cgst || 0);
      // pdf.text(cgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(cgstText), currentY + 6);

      // // SGST
      // pdf.setFont('Verdana', 'normal');
      // pdf.text(`SGST (${invoice.sgstRate || 0}%):`, rightColumnX +30, currentY + 12);
      // pdf.setFont('NotoSans', 'normal');
      // const sgstText = formatCurrency(invoice.sgst || 0);
      // pdf.text(sgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(sgstText), currentY + 12);

      // // Total
      // pdf.setFont('Verdana', 'bold');
      // pdf.text('Total:', rightColumnX +30, currentY + 18);
      // pdf.setFont('NotoSans', 'normal');
      // const totalText = formatCurrency(invoice.total);
      // pdf.text(totalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(totalText), currentY + 18);

      // // Balance Due
      // pdf.setFont('Verdana', 'bold');
      // pdf.text('Balance Due:', rightColumnX +30, currentY + 24);
      // pdf.setFont('NotoSans', 'normal');
      // const balanceText = formatCurrency(invoice.balanceDue || invoice.total);
      // pdf.text(balanceText, rightColumnX + rightColumnWidth - pdf.getTextWidth(balanceText), currentY + 24);




      const leftColumnX = 15;
      const maxTextWidth = 120;
      const rightColumnX = pageWidth - 95;
      const rightColumnWidth = 83;

      // Total in Words (Left side)
      pdf.setFontSize(10);
      pdf.setFont('Verdana', 'bold');
      pdf.text('Total In Words:', leftColumnX, currentY);

      pdf.setFontSize(9);
      // pdf.setFont('Verdana', 'bold');
      pdf.setFont('NotoSans', 'bolditalic');
      const totalInWords = convertNumberToWords(invoice.total);
      const wrappedText = pdf.splitTextToSize(totalInWords, maxTextWidth);
      pdf.text(wrappedText, leftColumnX, currentY + 6);

      // Draw vertical and horizontal lines for the right column
      pdf.line(pageWidth / 1.5, currentY - 8, pageWidth / 1.5, currentY + 62);
      pdf.line(pageWidth / 1.5, currentY + 62, pageWidth - 10, currentY + 62);
      pdf.setLineWidth(0.35)
      pdf.line(pageWidth / 1.236, currentY - 8, pageWidth / 1.236, currentY + 36);
      // Totals Section (Right side)
      pdf.setFontSize(9);


      const amountX = rightColumnX + 60; // ₹ symbol column
      let rightY = currentY;

      // 1. Sub Total
      pdf.setFont('Verdana', 'normal');
      const subTotalLabel = 'Sub Total:';
      pdf.text(subTotalLabel, amountX - pdf.getTextWidth(subTotalLabel) - 10, rightY);
      pdf.setFont('NotoSans', 'normal');
      const subTotalText = formatCurrency(invoice.subTotal || 0);
      pdf.text('₹', amountX, rightY);
      pdf.text(subTotalText.replace('₹', '').trim(), amountX + 5, rightY);

      // 2. CGST
      rightY += 6;
      pdf.setFont('Verdana', 'normal');
      const cgstLabel = `CGST (${invoice.cgstRate || 0}%):`;
      pdf.text(cgstLabel, amountX - pdf.getTextWidth(cgstLabel) - 10, rightY);
      pdf.setFont('NotoSans', 'normal');
      const cgstText = formatCurrency(invoice.cgst || 0);
      pdf.text('₹', amountX, rightY);
      pdf.text(cgstText.replace('₹', '').trim(), amountX + 5, rightY);

      // 3. SGST
      rightY += 6;
      pdf.setFont('Verdana', 'normal');
      const sgstLabel = `SGST (${invoice.sgstRate || 0}%):`;
      pdf.text(sgstLabel, amountX - pdf.getTextWidth(sgstLabel) - 10, rightY);
      pdf.setFont('NotoSans', 'normal');
      const sgstText = formatCurrency(invoice.sgst || 0);
      pdf.text('₹', amountX, rightY);
      pdf.text(sgstText.replace('₹', '').trim(), amountX + 5, rightY);

      // 4. Discount (if any)
      if (invoice.totalDiscount > 0) {
        rightY += 6;
        pdf.setFont('Verdana', 'normal');
        const discountLabel = 'Discount :';
        pdf.text(discountLabel, amountX - pdf.getTextWidth(discountLabel) - 10, rightY);
        pdf.setFont('NotoSans', 'normal');
        const discountText = formatCurrency(invoice.totalDiscount || 0);
        pdf.text('₹', amountX, rightY);
        pdf.text(`-${discountText.replace('₹', '').trim()}`, amountX + 5, rightY);
      }

      // 5. Total
      rightY += 6;
      pdf.setFont('Verdana', 'bold');
      const totalLabel = 'Total:';
      pdf.text(totalLabel, amountX - pdf.getTextWidth(totalLabel) - 10, rightY);
      pdf.setFont('NotoSans', 'normal');
      const totalText = formatCurrency(invoice.total);
      for (let i = 0; i < 2; i++) {
        pdf.text('₹', amountX + i * 0.2, rightY);
        pdf.text(totalText.replace('₹', '').trim(), amountX + 5 + i * 0.2, rightY);
      }

      // 6. Balance Due
      rightY += 6;
      pdf.setFont('Verdana', 'bold');
      const balanceLabel = 'Balance Due:';
      pdf.text(balanceLabel, amountX - pdf.getTextWidth(balanceLabel) - 10, rightY);
      pdf.setFont('NotoSans', 'normal');
      const balanceText = formatCurrency(invoice.balanceDue || invoice.total);
      for (let i = 0; i < 2; i++) {
        pdf.text('₹', amountX + i * 0.2, rightY);
        pdf.text(balanceText.replace('₹', '').trim(), amountX + 5 + i * 0.2, rightY);
      }


      currentY += 20;

      // Thank you message
      pdf.setFontSize(9);
      pdf.setFont('Verdana', 'normal');
      pdf.text('Thank you for the valuable business! We will always be at', 15, currentY);
      pdf.text('your desk to support you.', 15, currentY + 5);

      // Authorized signature section with seal and signature images
      const signatureY = currentY + 15;
      //  pdf.line(pageWidth/1.5, pageHeight-100, pageWidth/1.5, pageHeight-70);
      pdf.line(pageWidth / 1.5, signatureY, pageWidth - 10, signatureY);
      // Add signature image if available
      try {
        const signatureImg = './image/sign.png';
        pdf.addImage(signatureImg, 'JPEG', rightColumnX + 55, signatureY+3 , 25, 15);
      } catch (error) {
        console.log('Signature image not found');
      }

      // Add company seal if available
      try {
        const sealImg = './image/seal.jpeg';
        pdf.addImage(sealImg, 'JPEG', rightColumnX + 30, signatureY + 1, 22, 22);
      } catch (error) {
        console.log('Seal image not found');
      }

      // Scanner image (QR code) if available
      try {
        const scannerImg = './image/scanner.png';
        pdf.addImage(scannerImg, 'PNG', rightColumnX + 40, signatureY + 30, 25, 25);
      } catch (error) {
        console.log('Scanner image not found');
      }
      pdf.setFontSize(7);
      pdf.setFont('Verdana', 'normal');
      pdf.text('Authorized Signature', rightColumnX + 55, signatureY + 20);

      currentY = signatureY - 5;


      currentY += 6;

      pdf.setFontSize(8);
      pdf.setFont('Verdana', 'bold');
      pdf.text('Terms & Conditions:', 15, currentY);

      pdf.setFont('Verdana', 'normal');
      currentY += 5;

      // Use dynamic terms and conditions from invoice data
      const termsAndConditions = invoice.termsAndConditions || 'Full payment is due upon receipt of this invoice. Late payment may incur additional charges as per the applicable rates.';
      const termsLines = wrapText(termsAndConditions, pageWidth - 140);
      termsLines.forEach((line, index) => {
        pdf.text(line, 15, currentY + (index * 4));
      });
      currentY += Math.max(termsLines.length * 4, 8); // Minimum spacing

      currentY += 5;
      // DYNAMIC Bank Details
      pdf.setFontSize(8);
      pdf.setFont('Verdana', 'bold');
      pdf.text('Our Bank Details:', 15, currentY);
      currentY += 5;

      pdf.setFont('Verdana', 'normal');
      // Use dynamic bank details from invoice data
      const bankDetails = invoice.bankDetails || `Name: Excerpt Technologies Private Limited
Account Number: 10063739760
Name of Bank: IDFC First Bank  
IFSC Code: IDFB0080151
PAN No: AAGCE2327K`;

      const bankDetailsLines = bankDetails.split('\n');
      bankDetailsLines.forEach((line, index) => {
        if (index === 0 || index === 1) {
          pdf.setFont('Verdana', 'bold'); // Bold for first line
        } else {
          pdf.setFont('Verdana', 'normal'); // Normal for others
        }
        pdf.text(line, 15, currentY + (index * 4));
      });


      currentY += bankDetailsLines.length - 8;
      // Footer
      // const footerY = pageHeight - 25;
      // pdf.setDrawColor(0, 0, 0);
      // pdf.line(15, footerY, pageWidth - 15, footerY);

      pdf.setFontSize(8);
      pdf.setTextColor(0, 0, 255);
      pdf.text('https://excerptech.com', 15, pageHeight - 10);
      pdf.setTextColor(0, 0, 0);
      pdf.text('E-mail: info@excerptech.com', pageWidth - 65, pageHeight - 10);

      // Download the PDF
      // pdf.save(`invoice-${invoice.invoiceNumber}.pdf`);
      const invoiceNumberParts = invoice.invoiceNumber.split('/');
      const lastNumber1 = invoiceNumberParts[invoiceNumberParts.length - 1];

      // Get company name, default to 'Company' if not available
      const companyName = invoice.billtocompanyname || invoice.billToCompanyName || 'Company';

      // Create filename: INV [lastNumber] [companyName]
      const filename = `INV ${lastNumber1} ${companyName}.pdf`;

      pdf.save(filename);

    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Error generating PDF. Please try again.');
    } finally {
      setDownloading(null);
    }
  };



  // Optional: Modal function for showing PDF in modal instead of new tab

  const [sameAsBillTo, setSameAsBillTo] = useState(false);

  const handleSameAsBillTo = (e) => {
    const isChecked = e.target.checked;
    setSameAsBillTo(isChecked);

    if (isChecked) {
      setEditFormData(prev => ({
        ...prev,
        shipToName: prev.billToName,
        shipTocompanyname: prev.billtocompanyname,
        shipToAddress: prev.billToAddress,
        shipToemail: prev.billToemail,
        shipTophone: prev.billTophone,
        shipTogstin: prev.billTogstin,
      }));
    }
  };

  // Modified handleInputChange to sync Bill To changes to Ship To when checkbox is checked
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setEditFormData(prev => {
      const updatedData = { ...prev, [name]: value };

      // If "same as bill to" is checked, sync bill to changes to ship to
      if (sameAsBillTo) {
        const billToShipToMapping = {
          billToName: 'shipToName',
          billtocompanyname: 'shipTocompanyname',
          billToAddress: 'shipToAddress',
          billToemail: 'shipToemail',
          billTophone: 'shipTophone',
          billTogstin: 'shipTogstin'
        };

        if (billToShipToMapping[name]) {
          updatedData[billToShipToMapping[name]] = value;
        }
      }

      return updatedData;
    });
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Made this configurable
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredInvoices, setFilteredInvoices] = useState([]);

  // 2. UPDATE YOUR useEffect TO HANDLE FILTERING AND SORTING
  useEffect(() => {
    let filtered = invoices;

    // Search functionality - searches across all fields
    if (searchTerm) {
      filtered = invoices.filter(invoice =>
        invoice.invoiceNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        invoice.billToName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        invoice.shipToName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        invoice.billToAddress?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        invoice.shipToAddress?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        invoice.billToCity?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        invoice.shipToCity?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        invoice.terms?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        invoice.total?.toString().includes(searchTerm) ||
        new Date(invoice.date).toLocaleDateString('en-GB').includes(searchTerm)
      );
    }

    // Sort by createdAt (latest first) - assuming you have createdAt field
    // If you don't have createdAt, you can use date field instead
    filtered.sort((a, b) => new Date(b.createdAt || b.date) - new Date(a.createdAt || a.date));

    setFilteredInvoices(filtered);
    setCurrentPage(1); // Reset to first page when search changes
  }, [invoices, searchTerm]);

  // 3. PAGINATION LOGIC FUNCTIONS (add these functions)
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoices = filteredInvoices.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredInvoices.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Handle search input change (FIXED: prevents cursor jumping)
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Handle items per page change (FIXED: resets pagination)
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  // 4. SEARCH AND ITEMS PER PAGE COMPONENT (UPDATED to show both controls)
  const SearchAndControlsComponent = () => (
    <div className="row mb-3 align-items-center">
      <div className="col-md-6">
        <div className="input-group">
          <span className="input-group-text">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Search invoices (number, customer, address, amount, etc.)"
            value={searchTerm}
            onChange={handleSearchChange}
          />
          {searchTerm && (
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={() => setSearchTerm('')}
              title="Clear search"
            >
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
        <small className="text-muted mt-1 d-block">
          Showing {currentInvoices.length} of {filteredInvoices.length} invoices
          {searchTerm && ` (filtered from ${invoices.length} total)`}
        </small>
      </div>

      {/* Items per page selector */}
      <div className="col-md-6 text-end">
        <div className="d-flex align-items-center justify-content-end">
          <label className="form-label me-2 mb-0">Show:</label>
          <select
            className="form-select w-auto"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            style={{ minWidth: '80px' }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span className="ms-2">per page</span>
        </div>
      </div>
    </div>
  );

  // 5. PAGINATION COMPONENT (add this after your table)
  const PaginationComponent = () => (
    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3">
      <div className="mb-2 mb-md-0">
        <small className="text-muted">
          Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filteredInvoices.length)} of {filteredInvoices.length} entries
        </small>
      </div>
      <nav>
        <ul className="pagination pagination-sm mb-0">
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={handlePrevious}
              disabled={currentPage === 1}
              type="button"
            >
              <i className="fas fa-chevron-left"></i> Previous
            </button>
          </li>

          {/* Page numbers with improved logic */}
          {(() => {
            const pages = [];
            const maxVisiblePages = 5;
            let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
            let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

            // Adjust start page if we're near the end
            if (endPage - startPage + 1 < maxVisiblePages) {
              startPage = Math.max(1, endPage - maxVisiblePages + 1);
            }

            // Add first page and ellipsis if needed
            if (startPage > 1) {
              pages.push(
                <li key={1} className="page-item">
                  <button className="page-link" onClick={() => paginate(1)} type="button">1</button>
                </li>
              );
              if (startPage > 2) {
                pages.push(
                  <li key="ellipsis1" className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                );
              }
            }

            // Add visible page numbers
            for (let i = startPage; i <= endPage; i++) {
              pages.push(
                <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                  <button className="page-link" onClick={() => paginate(i)} type="button">
                    {i}
                  </button>
                </li>
              );
            }

            // Add ellipsis and last page if needed
            if (endPage < totalPages) {
              if (endPage < totalPages - 1) {
                pages.push(
                  <li key="ellipsis2" className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                );
              }
              pages.push(
                <li key={totalPages} className="page-item">
                  <button className="page-link" onClick={() => paginate(totalPages)} type="button">
                    {totalPages}
                  </button>
                </li>
              );
            }

            return pages;
          })()}

          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={handleNext}
              disabled={currentPage === totalPages}
              type="button"
            >
              Next <i className="fas fa-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
  // Update Invoice
  // const handleUpdateInvoice = async () => {
  //   setUpdating(true);
  //   try {
  //     const response = await axios.put(`/invoices/${editingInvoice._id}`, editFormData);

  //     // Update local state
  //     setInvoices(prev => 
  //       prev.map(inv => 
  //         inv._id === editingInvoice._id ? response.data : inv
  //       )
  //     );

  //     setShowEditModal(false);
  //     setEditingInvoice(null);
  //     alert('Invoice updated successfully!');
  //   } catch (error) {
  //     console.error('Error updating invoice:', error);
  //     alert('Error updating invoice: ' + (error.response?.data?.message || error.message));
  //   } finally {
  //     setUpdating(false);
  //   }
  // };
  // Add this preview function alongside your existing downloadInvoicePDF function

  const previewInvoicePDF = async (invoice) => {
    try {
      setPreviewLoading(invoice._id); // You'll need this state: const [previewLoading, setPreviewLoading] = useState(null);

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Add custom fonts
      pdf.addFileToVFS('Verdana.ttf', verdanaFont);
      pdf.addFont('Verdana.ttf', 'Verdana', 'normal');

      pdf.addFileToVFS('Verdana-Bold.ttf', verdanaboldFont);
      pdf.addFont('Verdana-Bold.ttf', 'Verdana', 'bold');

      pdf.addFileToVFS('NotoSans.ttf', notoSansBase64);
      pdf.addFont('NotoSans.ttf', 'NotoSans', 'normal');

      let currentY = 25;

      // Header Section with Blue Background - exact match
      // pdf.setFillColor(59, 130, 246); // Blue color
      // pdf.rect(200, 100, pageWidth, 35, 'F');

      // HEADER BACKGROUND

      pdf.setFillColor(0, 81, 255); // Rich blue like in the image
      pdf.rect(10, 5, pageWidth - 20, 28, 'F');

      // LOGO on the LEFT
      try {
        const logoImg = './image/excerpt.png';
        pdf.addImage(logoImg, 'PNG', 12, 12, 35, 14);
      } catch (error) {
        console.log('Logo not found, using text instead');
        // Fallback to text logo
        pdf.setTextColor(255, 255, 255);
        pdf.setFontSize(20);
        pdf.setFont('Verdana', 'bold');
        pdf.text('Excerpt', 12, 25);
      }

      // COMPANY TEXT (starts next to logo)
      const contentX = 60; // space after logo
      const contentY = 9;

      pdf.setTextColor(255, 255, 255);
      pdf.setFont('NotoSans', 'normal');
      pdf.setFontSize(12);
      pdf.text('Excerpt Technologies Pvt Ltd', contentX, contentY);

      pdf.setFont('NotoSans', 'normal');
      pdf.setFontSize(8);
      pdf.text('B133/1, 2nd FL, KSSIDC ITI Estate, Whitefield Rd,', contentX, contentY + 5.5);
      pdf.text('Mahadevpura Post, Bangalore – 560048', contentX, contentY + 9.5);
      pdf.text('Phone:+91(636) 465 7660, +91 (990) 050 2404 ', contentX, contentY + 13.5);
      pdf.text('GSTIN:29AAGCE2327K1ZH', contentX, contentY + 17.5);
      pdf.text('LUT No.: AD291021005439D', contentX, contentY + 21.5);

      // INVOICE TEXT AT FAR RIGHT
      pdf.setFont('NotoSans', 'bold');
      pdf.setFontSize(18);
      pdf.text('INVOICE', pageWidth - 15, contentY + 15.5, { align: 'right' });

      // Reset for content
      pdf.setTextColor(0, 0, 0);
      currentY = 30;



      pdf.setDrawColor(0, 0, 0);

      pdf.setLineWidth(0.05);

      // pdf.rect(10, currentY, pageWidth - 20, pageHeight - currentY - 20); kARTHIK
      const mainBoxY = currentY;
      const mainBoxHeight = pageHeight - mainBoxY - 20;
      pdf.rect(10, mainBoxY + 3, pageWidth - 20, mainBoxHeight);




      // Invoice details section KARTHIK//
      // currentY += 7;
      // pdf.setFontSize(9);
      // pdf.setFont('Verdana', 'normal');

      // pdf.text('Invoice:', 15, currentY);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text(invoice.invoiceNumber, 35, currentY);

      // pdf.setFont('Verdana', 'normal');
      // pdf.text('Date:', 15, currentY + 6);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text(formatDate(invoice.date), 35, currentY + 6);

      // pdf.setFont('Verdana', 'normal');
      // pdf.text('Terms:', 15, currentY + 12);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text(invoice.terms, 35, currentY + 12);

      // pdf.setFont('Verdana', 'normal');
      // pdf.text('Due Date:', 15, currentY + 18);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text(formatDate(invoice.dueDate), 35, currentY + 18);





      // Invoice Info Container
      const infoBoxX = 10;
      const infoBoxWidth = pageWidth - 20;
      const infoBoxHeight = 22;
      pdf.rect(infoBoxX, currentY + 3, infoBoxWidth, infoBoxHeight); // Outer border

      // Split into two columns
      const midX = infoBoxX + infoBoxWidth / 2;
      pdf.line(midX, currentY + 3, midX, currentY + infoBoxHeight + 3); // Vertical center line

      // Left Column
      pdf.setFontSize(8);
      pdf.setFont('Verdana', 'normal');
      pdf.text('Invoice', infoBoxX + 4, currentY + 7);
      pdf.text('Date', infoBoxX + 4, currentY + 12);
      pdf.text('Terms', infoBoxX + 4, currentY + 17);
      pdf.text('Due Date', infoBoxX + 4, currentY + 22);

      // Values (bold)
      pdf.setFont('Verdana', 'bold');
      pdf.text(`: ${invoice.invoiceNumber}`, infoBoxX + 28, currentY + 7);
      pdf.text(`: ${formatDate(invoice.date)}`, infoBoxX + 28, currentY + 12);
      pdf.text(`: ${invoice.terms}`, infoBoxX + 28, currentY + 17);
      pdf.text(`: ${formatDate(invoice.dueDate)}`, infoBoxX + 28, currentY + 22);

      // Right Column (blank or for future use if needed)
      // You can fill it if required


      currentY += infoBoxHeight + 3;



      const calculateAddressHeight = (billToName, billToCompanyName, billToAddress, billToEmail, billToPhone, billToGstin,
        shipToName, shipToCompanyName, shipToAddress, shipToEmail, shipToPhone, shipToGstin) => {
        const baseHeight = 12; // Minimum height for headers
        const lineHeight = 4;

        // Calculate lines needed for bill to section
        let billToLines = 0;
        if (billToName) billToLines += 1; // Name line
        if (billToCompanyName) billToLines += 1; // Company name line
        if (billToAddress) billToLines += billToAddress.split('\n').length; // Address lines
        if (billToEmail) billToLines += 1; // Email line
        if (billToPhone) billToLines += 1; // Phone line
        if (billToGstin) billToLines += 1; // GSTIN line

        // Calculate lines needed for ship to section
        let shipToLines = 0;
        if (shipToName) shipToLines += 1; // Name line
        if (shipToCompanyName) shipToLines += 1; // Company name line
        if (shipToAddress) shipToLines += shipToAddress.split('\n').length; // Address lines
        if (shipToEmail) shipToLines += 1; // Email line
        if (shipToPhone) shipToLines += 1; // Phone line
        if (shipToGstin) shipToLines += 1; // GSTIN line

        // Use the maximum lines needed plus some padding
        const maxLines = Math.max(billToLines, shipToLines);
        return Math.max(baseHeight + (maxLines * lineHeight) + 8, 36); // Minimum 36mm height
      };

      // Bill To and Ship To sections with dynamic borders
      const billToX = 10;
      const shipToX = 105;
      const sectionWidth = 95;
      const sectionHeight = calculateAddressHeight(
        invoice.billToName,
        invoice.billToCompanyName,
        invoice.billToAddress,
        invoice.billToEmail,
        invoice.billToPhone,
        invoice.billToGstin,
        invoice.shipToName,
        invoice.shipToCompanyName,
        invoice.shipToAddress,
        invoice.shipToEmail,
        invoice.shipToPhone,
        invoice.shipToGstin
      );


      // Draw borders for Bill To and Ship To sections
      pdf.setDrawColor(0, 0, 0);
      pdf.setLineWidth(0.1);
      pdf.setFillColor(220, 220, 220);
      // Bill To border KARTHIK //
      // pdf.rect(billToX, currentY, sectionWidth, sectionHeight);

      pdf.rect(billToX, currentY, sectionWidth * 2, sectionHeight);

      // pdf.rect(shipToX, currentY, sectionWidth, sectionHeight);
      pdf.line(shipToX, currentY, shipToX, currentY + sectionHeight);

      // Headers with background KARTHIK//

      pdf.rect(billToX + 0.1, currentY + 0.5, sectionWidth - 0.6, 4, 'F');
      pdf.rect(shipToX + 0.1, currentY + 0.5, sectionWidth - 0.6, 4, 'F');

      // Header borders

      pdf.line(billToX, currentY + 4, billToX + sectionWidth, currentY + 4);
      pdf.line(shipToX, currentY + 4, shipToX + sectionWidth, currentY + 4);

      // pdf.setFontSize(10);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text('Bill To:', billToX + 1, currentY + 3.7);
      // pdf.text('Ship To:', shipToX + 1, currentY + 3.7);

      let billToY = currentY + 10;
      let shipToY = currentY + 10;

      // Names in bold
      // pdf.setFontSize(9);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text(invoice.billToName.toUpperCase(), billToX + 3, billToY);
      // pdf.text(invoice.shipToName.toUpperCase(), shipToX + 3, shipToY);

      billToY += 6;
      shipToY += 6;

      // Helper function to wrap text within column width
      const wrapText = (text, maxWidth) => {
        const words = text.split(' ');
        const lines = [];
        let currentLine = '';

        for (let word of words) {
          const testLine = currentLine + (currentLine ? ' ' : '') + word;
          const testWidth = pdf.getTextWidth(testLine);

          if (testWidth > maxWidth && currentLine) {
            lines.push(currentLine);
            currentLine = word;


          } else {
            currentLine = testLine;
          }
        }

        if (currentLine) {
          lines.push(currentLine);
        }

        return lines;
      };

      // Bill To Address - properly wrapped
      pdf.setFont('Verdana', 'normal');
      // if (invoice.billToAddress) {
      //   const billToAddressLines = invoice.billToAddress.split('\n');
      //   const maxTextWidth = sectionWidth - 6;

      //   for (let line of billToAddressLines) {
      //     const wrappedLines = wrapText(line, maxTextWidth);
      //     for (let wrappedLine of wrappedLines) {
      //       if (billToY < currentY + sectionHeight - 2) {
      //         pdf.text(wrappedLine, billToX + 3, billToY);
      //         billToY += 4;
      //       }
      //     }
      //   }
      // }

      // // Bill To City
      // if (invoice.billToCity && billToY < currentY + sectionHeight - 2) {
      //   const cityLines = wrapText(invoice.billToCity, sectionWidth - 6);
      //   for (let cityLine of cityLines) {
      //     if (billToY < currentY + sectionHeight - 2) {
      //       pdf.text(cityLine, billToX + 3, billToY);
      //       billToY += 4;
      //     }
      //   }
      // }

      // Ship To Address - properly wrapped
      // if (invoice.shipToAddress) {
      //   const shipToAddressLines = invoice.shipToAddress.split('\n');

      //   for (let line of shipToAddressLines) {
      //     const wrappedLines = wrapText(line, sectionWidth - 6);
      //     for (let wrappedLine of wrappedLines) {
      //       if (shipToY < currentY + sectionHeight - 2) {
      //         pdf.text(wrappedLine, shipToX + 3, shipToY);
      //         shipToY += 4;
      //       }
      //     }
      //   }
      // }

      // // Ship To City
      // if (invoice.shipToCity && shipToY < currentY + sectionHeight - 2) {
      //   const cityLines = wrapText(invoice.shipToCity, sectionWidth - 6);
      //   for (let cityLine of cityLines) {
      //     if (shipToY < currentY + sectionHeight - 2) {
      //       pdf.text(cityLine, shipToX + 3, shipToY);
      //       shipToY += 4;
      //     }
      //   }
      // }


      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(7);
      pdf.setFillColor(230, 230, 230);

      pdf.text('Bill To', billToX + 2, currentY + 3);
      pdf.text('Ship To', shipToX + 2, currentY + 3);

      // Function to render address section content
      const renderAddressSection = (x, name, companyName, address, email, phone, gstin) => {
        let yOffset = currentY + 8; // Start below header

        // Name (first line)
        if (name) {
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(9);
          pdf.text(name, x + 2, yOffset);
          yOffset += 4;
        }

        // Company name (second line, bold)
        if (companyName) {
          pdf.setFont('helvetica', 'bold');
          pdf.setFontSize(9);
          pdf.text(companyName, x + 2, yOffset);
          yOffset += 4;
        }

        // Address
        if (address) {
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(7);
          const maxLineWidth = 80; // Adjust as per your layout
          const addressLines = address.split('\n');

          addressLines.forEach(line => {
            if (line.trim()) {
              const wrappedLines = pdf.splitTextToSize(line.trim(), maxLineWidth);
              wrappedLines.forEach(wrappedLine => {
                pdf.text(wrappedLine, x + 2, yOffset);
                yOffset += 3;
              });
            }
          });
        }


        // Email
        if (email) {
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(7);
          pdf.text(`EMAIL: ${email}`, x + 2, yOffset + 1);
          yOffset += 3;
        }

        // Phone
        if (phone) {
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(7);
          pdf.text(`PHONE: ${phone}`, x + 2, yOffset + 1);
          yOffset += 3;
        }

        // GSTIN
        if (gstin) {
          pdf.setFont('helvetica', 'normal');
          pdf.setFontSize(7);
          pdf.text(`GSTIN: ${gstin}`, x + 2, yOffset + 1);
          yOffset += 3;
        }
      };

      // Render Bill To section
      renderAddressSection(
        billToX,
        invoice.billToName,
        invoice.billtocompanyname,


        invoice.billToAddress,
        invoice.billToemail,
        invoice.billTophone,
        invoice.billTogstin
      );

      // Render Ship To section
      renderAddressSection(
        shipToX,
        invoice.shipToName,
        invoice.shipTocompanyname,
        invoice.shipToAddress,
        invoice.shipToemail,
        invoice.shipTophone,
        invoice.shipTogstin
      );

      // Update currentY to move past the address sections
      currentY += sectionHeight;
      // Move currentY to after the Bill To/Ship To sections


      // Items table - FIXED VERSION
      const tableStartY = currentY;
      const tableStartX = 10;
      const tableWidth = pageWidth - 20;
      const descriptionWidth = tableWidth - 50;
      const amountWidth = 50;

      // Table header with proper styling
      pdf.setFillColor(230, 230, 230);
      pdf.rect(tableStartX, tableStartY, tableWidth, 6, 'F');
      pdf.setDrawColor(0, 0, 0);
      pdf.setLineWidth(0.1);

      // Draw table header borders
      pdf.rect(tableStartX, tableStartY, tableWidth, 6);
      pdf.line(tableStartX + descriptionWidth + 20, tableStartY, tableStartX + descriptionWidth + 20, tableStartY + 10);

      pdf.setFontSize(8);
      pdf.setFont('Verdana', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text('Items & Description', tableStartX + 3, tableStartY + 4);
      pdf.text('Amount', tableStartX + descriptionWidth + 30, tableStartY + 4);



      currentY = tableStartY + (5);

      // Table rows - COMPLETELY REWRITTEN for proper formatting
      let rowNumber = 1;
      const rowHeight = 7;

      if (invoice.parts) {
        invoice.parts.forEach((part, partIndex) => {
          // Part title row with gray background
          pdf.setFillColor(220, 220, 220);
          pdf.rect(tableStartX, currentY, tableWidth, rowHeight, 'F');

          // Draw borders
          pdf.setDrawColor(0, 0, 0);
          pdf.rect(tableStartX, currentY, tableWidth, rowHeight);
          pdf.line(tableStartX + descriptionWidth + 20, currentY, tableStartX + descriptionWidth + 20, currentY + rowHeight);

          pdf.setFontSize(8);
          pdf.setFont('Verdana', 'bold');
          pdf.setTextColor(0, 0, 0);
          pdf.text(part.title, tableStartX + 3, currentY + 4.5);

          currentY += rowHeight - 1;

          // Part items
          if (part.items) {
            part.items.forEach((item, itemIndex) => {
              // Row background
              pdf.setFillColor(255, 255, 255);
              pdf.rect(tableStartX, currentY, tableWidth, rowHeight, 'F');

              // Draw borders
              pdf.setDrawColor(0, 0, 0);
              pdf.rect(tableStartX, currentY, tableWidth, rowHeight);
              pdf.line(tableStartX + descriptionWidth + 20, currentY, tableStartX + descriptionWidth + 20, currentY + rowHeight);
              pdf.line(tableStartX + 7, currentY, tableStartX + 7, currentY + rowHeight);
              pdf.setFontSize(9);
              pdf.setFont('Verdana', 'normal');
              pdf.setTextColor(0, 0, 0);

              // Item description with proper numbering
              const description = `${rowNumber}.   ${item.description}`;
              pdf.text(description, tableStartX + 2, currentY + 5.5);

              // Amount - right aligned within amount column
              pdf.setFont('NotoSans', 'normal');
              const amountText = formatCurrency(item.amount);
              const amountX = tableStartX + descriptionWidth + amountWidth - 3 - pdf.getTextWidth(amountText);
              pdf.text(amountText, amountX, currentY + 5.5);

              currentY += rowHeight;
              rowNumber++;
            });
          }
        });
      }

      // Close table with bottom border
      pdf.setDrawColor(0, 0, 0);
      pdf.line(tableStartX, currentY, tableStartX + tableWidth, currentY);



      currentY += 8;

      // // Create a two-column layout for totals section KARTHIK
      // const leftColumnX = 15;
      // const maxTextWidth = 70;
      // const rightColumnX = pageWidth - 95; // Adjusted for better alignment
      // const rightColumnWidth = 80;

      // // Total in words (left side)
      // pdf.setFontSize(10);
      // pdf.setFont('Verdana', 'bold');
      // pdf.text('Total In Words:', leftColumnX , currentY);

      // pdf.setFontSize(9);
      // pdf.setFont('Verdana', 'normal');

      // const totalInWords = convertNumberToWords(invoice.total);
      // const wrappedText = pdf.splitTextToSize(totalInWords, maxTextWidth);

      // pdf.text(wrappedText, leftColumnX, currentY + 6);

      // // Totals section (right side) - Fixed alignment
      // pdf.setFontSize(9);
      // pdf.line(pageWidth/1.5, (pageHeight/2)+7, pageWidth/1.5, pageHeight-100);
      //  pdf.line(pageWidth/1.5, pageHeight-100, pageWidth-10, pageHeight-100);
      // // Sub Total
      // pdf.setFont('Verdana', 'normal');
      // pdf.text('Sub Total:', rightColumnX +30, currentY);
      // pdf.setFont('NotoSans', 'normal');
      // const subTotalText = formatCurrency(invoice.subTotal);
      // pdf.text(subTotalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(subTotalText), currentY);

      // // CGST
      // pdf.setFont('Verdana', 'normal');
      // pdf.text(`CGST (${invoice.cgstRate || 0}%):`, rightColumnX +30, currentY + 6);
      // pdf.setFont('NotoSans', 'normal');
      // const cgstText = formatCurrency(invoice.cgst || 0);
      // pdf.text(cgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(cgstText), currentY + 6);

      // // SGST
      // pdf.setFont('Verdana', 'normal');
      // pdf.text(`SGST (${invoice.sgstRate || 0}%):`, rightColumnX +30, currentY + 12);
      // pdf.setFont('NotoSans', 'normal');
      // const sgstText = formatCurrency(invoice.sgst || 0);
      // pdf.text(sgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(sgstText), currentY + 12);

      // // Total
      // pdf.setFont('Verdana', 'bold');
      // pdf.text('Total:', rightColumnX +30, currentY + 18);
      // pdf.setFont('NotoSans', 'normal');
      // const totalText = formatCurrency(invoice.total);
      // pdf.text(totalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(totalText), currentY + 18);

      // // Balance Due
      // pdf.setFont('Verdana', 'bold');
      // pdf.text('Balance Due:', rightColumnX +30, currentY + 24);
      // pdf.setFont('NotoSans', 'normal');
      // const balanceText = formatCurrency(invoice.balanceDue || invoice.total);
      // pdf.text(balanceText, rightColumnX + rightColumnWidth - pdf.getTextWidth(balanceText), currentY + 24);




      const leftColumnX = 15;
      const maxTextWidth = 120;
      const rightColumnX = pageWidth - 95;
      const rightColumnWidth = 83;

      // Total in Words (Left side)
      pdf.setFontSize(10);
      pdf.setFont('Verdana', 'bold');
      pdf.text('Total In Words:', leftColumnX, currentY);

      pdf.setFontSize(10);
      // pdf.setFont('Verdana', 'bold');
      pdf.setFont('NotoSans', 'bolditalic');
      const totalInWords = convertNumberToWords(invoice.total);
      const wrappedText = pdf.splitTextToSize(totalInWords, maxTextWidth);
      pdf.text(wrappedText, leftColumnX, currentY + 6);

      // Draw vertical and horizontal lines for the right column
      pdf.line(pageWidth / 1.5, currentY - 8, pageWidth / 1.5, currentY + 58);
      pdf.line(pageWidth / 1.5, currentY + 58, pageWidth - 10, currentY + 58);
      pdf.setLineWidth(0.35)
      pdf.line(pageWidth / 1.236, currentY - 8, pageWidth / 1.236, currentY + 36);
      // Totals Section (Right side)
      pdf.setFontSize(9);
      let rightY = currentY;

      // 1. Sub Total
      pdf.setFont('Verdana', 'normal');
      pdf.text('Sub Total:', rightColumnX + 30, rightY);
      pdf.setFont('NotoSans', 'normal');
      const subTotalText = formatCurrency(invoice.subTotal);
      pdf.text(subTotalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(subTotalText), rightY);

      // 2. CGST
      rightY += 6;
      pdf.setFont('Verdana', 'normal');
      pdf.text(`CGST (${invoice.cgstRate || 0}%):`, rightColumnX + 30, rightY);
      pdf.setFont('NotoSans', 'normal');
      const cgstText = formatCurrency(invoice.cgst || 0);
      pdf.text(cgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(cgstText), rightY);

      // 3. SGST
      rightY += 6;
      pdf.setFont('Verdana', 'normal');
      pdf.text(`SGST (${invoice.sgstRate || 0}%):`, rightColumnX + 30, rightY);
      pdf.setFont('NotoSans', 'normal');
      const sgstText = formatCurrency(invoice.sgst || 0);
      pdf.text(sgstText, rightColumnX + rightColumnWidth - pdf.getTextWidth(sgstText), rightY);
      if (invoice.totalDiscount > 0) {
        rightY += 6;
        pdf.setFont('Verdana', 'normal');
        pdf.text(`Discount :`, rightColumnX + 30, rightY);
        pdf.setFont('NotoSans', 'normal');
        const totalDiscount = formatCurrency(invoice.totalDiscount || 0);
        pdf.text(`- ${totalDiscount}`, rightColumnX + rightColumnWidth - pdf.getTextWidth(sgstText), rightY);
      }
      // 4. Total (Bold value)
      rightY += 6;
      pdf.setFont('Verdana', 'bold');
      pdf.text('Total:', rightColumnX + 30, rightY);
      pdf.setFont('NotoSans', 'normal');

      // Simulate bold for rupee value
      const totalText = formatCurrency(invoice.total);
      for (let i = 0; i < 2; i++) {
        pdf.text(totalText, rightColumnX + rightColumnWidth - pdf.getTextWidth(totalText) + i * 0.2, rightY);
      }

      // 5. Balance Due (Bold value)
      rightY += 6;
      pdf.setFont('Verdana', 'bold');
      pdf.text('Balance Due:', rightColumnX + 30, rightY);
      pdf.setFont('NotoSans', 'normal');
      const balanceText = formatCurrency(invoice.balanceDue || invoice.total);
      for (let i = 0; i < 2; i++) {
        pdf.text(balanceText, rightColumnX + rightColumnWidth - pdf.getTextWidth(balanceText) + i * 0.2, rightY);
      }

      currentY += 20;

      // Thank you message
      pdf.setFontSize(9);
      pdf.setFont('Verdana', 'normal');
      pdf.text('Thank you for the valuable business! We will always be at', 15, currentY);
      pdf.text('your desk to support you.', 15, currentY + 5);

      // Authorized signature section with seal and signature images
      const signatureY = currentY + 15;
      //  pdf.line(pageWidth/1.5, pageHeight-100, pageWidth/1.5, pageHeight-70);
      pdf.line(pageWidth / 1.5, signatureY, pageWidth - 10, signatureY);
      // Add signature image if available
      try {
        const signatureImg = './image/sign.jpeg';
        pdf.addImage(signatureImg, 'JPEG', rightColumnX + 55, signatureY+3 , 25, 15);
      } catch (error) {
        console.log('Signature image not found');
      }

      // Add company seal if available
      try {
        const sealImg = './image/seal.jpeg';
        pdf.addImage(sealImg, 'JPEG', rightColumnX + 30, signatureY + 1, 20, 20);
      } catch (error) {
        console.log('Seal image not found');
      }

      // Scanner image (QR code) if available
      try {
        const scannerImg = './image/scanner.png';
        pdf.addImage(scannerImg, 'PNG', rightColumnX + 40, signatureY + 25, 25, 25);
      } catch (error) {
        console.log('Scanner image not found');
      }
      pdf.setFontSize(7);
      pdf.setFont('Verdana', 'normal');
      pdf.text('Authorized Signature', rightColumnX + 55, signatureY + 20);

      currentY = signatureY - 5;


      currentY += 6;

      pdf.setFontSize(8);
      pdf.setFont('Verdana', 'bold');
      pdf.text('Terms & Conditions:', 15, currentY);

      pdf.setFont('Verdana', 'normal');
      currentY += 5;

      // Use dynamic terms and conditions from invoice data
      const termsAndConditions = invoice.termsAndConditions || 'Full payment is due upon receipt of this invoice. Late payment may incur additional charges as per the applicable rates.';
      const termsLines = wrapText(termsAndConditions, pageWidth - 140);
      termsLines.forEach((line, index) => {
        pdf.text(line, 15, currentY + (index * 4));
      });
      currentY += Math.max(termsLines.length * 4, 8); // Minimum spacing

      currentY += 5;
      // DYNAMIC Bank Details
      pdf.setFontSize(8);
      pdf.setFont('Verdana', 'bold');
      pdf.text('Our Bank Details:', 15, currentY);
      currentY += 5;

      pdf.setFont('Verdana', 'normal');
      // Use dynamic bank details from invoice data
      const bankDetails = invoice.bankDetails || `Name: Excerpt Technologies Private Limited
Account Number: 10063739760
Name of Bank: IDFC First Bank  
IFSC Code: IDFB0080151
PAN No: AAGCE2327K`;

      const bankDetailsLines = bankDetails.split('\n');
      bankDetailsLines.forEach((line, index) => {
        if (index === 0 || index === 1) {
          pdf.setFont('Verdana', 'bold'); // Bold for first line
        } else {
          pdf.setFont('Verdana', 'normal'); // Normal for others
        }
        pdf.text(line, 15, currentY + (index * 4));
      });


      currentY += bankDetailsLines.length - 8;
      // Footer
      // const footerY = pageHeight - 25;
      // pdf.setDrawColor(0, 0, 0);
      // pdf.line(15, footerY, pageWidth - 15, footerY);

      pdf.setFontSize(8);
      pdf.setTextColor(0, 0, 255);
      pdf.text('https://excerptech.com', 15, pageHeight - 10);
      pdf.setTextColor(0, 0, 0);
      pdf.text('E-mail: info@excerptech.com', pageWidth - 65, pageHeight - 10);

      // Instead of saving, open preview in new tab
      // const pdfOutput = pdf.output('bloburl');
      // window.open(pdfOutput, '_blank');
      const invoiceNumberParts = invoice.invoiceNumber.split('/');
      const lastNumber1 = invoiceNumberParts[invoiceNumberParts.length - 1];

      // Get company name, default to 'Company' if not available
      const companyName1 = invoice.billtocompanyname || invoice.billToCompanyName || 'Company';

      // Create filename: INV [lastNumber] [companyName]
      const filename = `INV ${lastNumber1} ${companyName1}.pdf`;

      const pdfOutput = pdf.output('bloburl');
      const newWindow = window.open(pdfOutput, '_blank');
      // Set the title of the new window to match the filename
      if (newWindow) {
        newWindow.document.title = filename;
      }

    } catch (error) {
      console.error('Error generating PDF preview:', error);
      alert('Error generating PDF preview. Please try again.');
    } finally {
      setPreviewLoading(null);
    }
  };

  // Updated handleUpdateInvoice function with preview option
  const handleUpdateInvoice = async () => {
    setUpdating(true);
    try {
      const response = await axios.put(`/invoices/${editingInvoice._id}`, editFormData);

      // Update local state
      setInvoices(prev =>
        prev.map(inv =>
          inv._id === editingInvoice._id ? response.data : inv
        )
      );

      setShowEditModal(false);
      setEditingInvoice(null);
      alert('Invoice updated successfully!');

      // Automatically preview the updated invoice
      setTimeout(() => {
        previewInvoicePDF(response.data); // Use the updated data from server response
      }, 200); // Small delay to ensure modal closes first

    } catch (error) {
      console.error('Error updating invoice:', error);
      alert('Error updating invoice: ' + (error.response?.data?.message || error.message));
    } finally {
      setUpdating(false);
    }
  };

  // REPLACE YOUR EXISTING handleUpdateInvoice FUNCTION WITH THIS:


  // Delete Invoice
  const handleDeleteInvoice = async (invoiceId, invoiceNumber) => {
    if (window.confirm(`Are you sure you want to delete invoice ${invoiceNumber}?`)) {
      try {
        await axios.delete(`/invoices/${invoiceId}`);
        setInvoices(prev => prev.filter(inv => inv._id !== invoiceId));
        alert('Invoice deleted successfully!');
      } catch (error) {
        console.error('Error deleting invoice:', error);
        alert('Error deleting invoice: ' + (error.response?.data?.message || error.message));
      }
    }
  };
  // 1. ADD THESE STATE VARIABLES (add with your existing state declarations)
  const [showCloneModal, setShowCloneModal] = useState(false);
  const [cloning, setCloning] = useState(false);

  // 2. ADD THIS FUNCTION to fetch the next invoice number
  const getNextInvoiceNumber = async () => {
    try {
      const response = await axios.get('/last-invoice-number');
      const lastNumber = response.data.lastNumber;
      const nextNumber = lastNumber + 1;
      const paddedNumber = nextNumber.toString().padStart(3, '0');
      return `ETPL/24-25/${paddedNumber}`;
    } catch (error) {
      console.error('Error fetching next invoice number:', error);
      return 'PKV/001'; // fallback
    }
  };

  // 3. ADD THIS CLONE FUNCTION
  const openCloneModal = async (invoice) => {
    try {
      setCloning(true);
      const nextInvoiceNumber = await getNextInvoiceNumber();

      setEditingInvoice(null); // Set to null for clone mode
      setEditFormData({
        invoiceNumber: nextInvoiceNumber, // NEW invoice number
        date: new Date().toISOString().split('T')[0], // TODAY's date
        terms: invoice.terms || '',
        dueDate: '', // EMPTY due date
        billToName: invoice.billToName || '',
        billtocompanyname: invoice.billtocompanyname || '',
        billToAddress: invoice.billToAddress || '',
        billToemail: invoice.billToemail || '',
        billTophone: invoice.billTophone || '',
        billTogstin: invoice.billTogstin || '',

        shipToName: invoice.shipToName || '',
        shipTocompanyname: invoice.shipTocompanyname || '',
        shipToAddress: invoice.shipToAddress || '',
        shipToemail: invoice.shipToemail || '',
        shipTophone: invoice.shipTophone || '',
        shipTogstin: invoice.shipTogstin || '',
        balanceDue: '', // EMPTY
        totalInWords: '',
        thankYouMessage: invoice.thankYouMessage || '',
        termsAndConditions: invoice.termsAndConditions || '',
        bankDetails: invoice.bankDetails || '',
        parts: [{ title: 'Part A', items: [{ description: '', amount: '' }] }], // EMPTY parts
        cgstRate: invoice.cgstRate || '',
        sgstRate: invoice.sgstRate || '',
        total: '', // EMPTY total
        discounts: [] // EMPTY discounts
      });
      setShowCloneModal(true);
    } catch (error) {
      console.error('Error preparing clone:', error);
      alert('Error preparing clone: ' + error.message);
    } finally {
      setCloning(false);
    }
  };

  // 4. ADD THIS SAVE CLONE FUNCTION
  const handleSaveClone = async () => {
    setUpdating(true);
    try {
      const response = await axios.post('/invoices', editFormData);

      // Add new invoice to local state
      setInvoices(prev => [response.data, ...prev]);

      setShowCloneModal(false);
      alert('Invoice cloned successfully!');
      setTimeout(() => {
        previewInvoicePDF(response.data); // Use the updated data from server response
      }, 200);
    } catch (error) {
      console.error('Error saving cloned invoice:', error);
      alert('Error saving cloned invoice: ' + (error.response?.data?.message || error.message));
    } finally {
      setUpdating(false);
    }
  };
  if (loading) return <div className="loading">Loading invoices...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="invoice-list-container">
      <h2>All Invoices</h2>

      {invoices.length === 0 ? (
        <div className="no-invoices">No invoices found.</div>
      ) : (
        <>

          <div className="row mb-3 align-items-center">
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                placeholder="Search invoices (number, customer, address, amount, etc.)"
                value={searchTerm}
                onChange={handleSearchChange}
              />

            </div>

            <div className="col-md-6 ">
              <div className="d-flex align-items-center justify-content-end">
                <label className="form-label me-2 mb-0">Show:</label>
                <select
                  className="form-select w-auto"
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  style={{ minWidth: '80px' }}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <span className="ms-2">per page</span>
              </div>
            </div>
          </div>

          <div className="">
            <table className='table table-bordered' >
              <thead >
                <tr>
                  <th>Invoice Number</th>
                  <th>Date</th>
                  <th>Bill To</th>
                  <th>Services</th>
                  <th>Total Amount</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentInvoices.map((invoice) => (
                  <tr key={invoice._id}>
                    <td>{invoice.invoiceNumber}</td>
                    <td>{new Date(invoice.date).toLocaleDateString('en-GB')}</td>
                    <td style={{ whiteSpace: 'normal', wordWrap: 'break-word', maxWidth: '200px' }}>
                      {invoice.billToName}
                    </td>

                    <td>
                      {invoice.parts && invoice.parts.length > 0 ? (
                        <div>
                          {invoice.parts.map((part, index) => (
                            <>
                              <span key={index} >
                                {part.title}
                              </span>
                              <br /></>
                          ))}
                        </div>
                      ) : (
                        <span className="text-muted">No parts</span>
                      )}
                    </td>
                    <td>₹ {invoice.total}</td>
                    <td style={{ display: "flex" }}>
                      <button
                        onClick={() => previewInvoicePDF(invoice)}
                        disabled={previewing === invoice._id}
                        className="btn-sm me-1"
                        style={{ width: "40px", height: "32px" }}
                        title={previewing === invoice._id ? 'Generating Preview...' : 'Preview PDF'}
                      >
                        <i className={previewing === invoice._id ? 'fas fa-spinner fa-spin' : 'fas fa-eye'}></i>
                      </button>
                      <button
                        onClick={() => downloadInvoicePDF(invoice)}
                        disabled={downloading === invoice._id}
                        className=" btn-sm me-1"
                        style={{ width: "40px", height: "32px" }}
                        title={downloading === invoice._id ? 'Generating...' : 'Download PDF'}
                      >
                        <i className={downloading === invoice._id ? 'fas fa-spinner fa-spin' : 'fas fa-download'}></i>
                      </button>

                      <button
                        className=" btn-sm me-1"
                        onClick={() => openEditModal(invoice)}
                        style={{ width: "40px", height: "32px" }}
                        title="Edit"
                      >
                        <i className="fas fa-edit"></i>
                      </button>
                      <button
                        className="btn-sm me-1"
                        onClick={() => openCloneModal(invoice)}
                        disabled={cloning}
                        style={{ width: "40px", height: "32px" }}
                        title="Clone Invoice"
                      >
                        <i className={cloning ? 'fas fa-spinner fa-spin' : 'fas fa-copy'}></i>
                      </button>

                      <button
                        className=" btn-sm"
                        onClick={() => handleDeleteInvoice(invoice._id, invoice.invoiceNumber)}
                        style={{ width: "40px", height: "32px" }}
                        title="Delete"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && <PaginationComponent />}
        </>
      )}

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Invoice - {editFormData.invoiceNumber}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <div className="row">
                  {/* Basic Details */}

                  <h6>Invoice Details</h6>
                  <div className="mb-3 col-xl-3">
                    <label className="form-label">Invoice Number</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="invoiceNumber"
                      value={editFormData.invoiceNumber}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="mb-3 col-md-3">
                    <label className="form-label">Date</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      name="date"
                      value={editFormData.date}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3 col-md-3">
                    <label className="form-label">Terms</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="terms"
                      value={editFormData.terms}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3 col-md-3">
                    <label className="form-label">Due Date</label>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      name="dueDate"
                      value={editFormData.dueDate}
                      onChange={handleInputChange}
                    />
                  </div>
                  {/* <div className="mb-3">
                      <label className="form-label">Balance Due</label>
                      <input
                        type="number"
                        className="form-control"
                        name="balanceDue"
                        value={editFormData.balanceDue}
                        onChange={handleInputChange}
                      />
                    </div> */}



                  {/* Billing & Shipping */}
                  <div className='row'>
                    <h6 >Bill To</h6>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billToName"
                          value={editFormData.billToName}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billtocompanyname"
                          value={editFormData.billtocompanyname}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billToAddress"
                          value={editFormData.billToAddress}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Phone</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billTophone"
                          value={editFormData.billTophone}
                          onChange={handleInputChange}
                          style={{
                            borderColor: editFormData.billTophone && !validatePhone(editFormData.billTophone) ? 'red' : ''
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billToemail"
                          value={editFormData.billToemail}
                          onChange={handleInputChange}
                          style={{
                            borderColor: editFormData.billToemail && !validateEmail(editFormData.billToemail) ? 'red' : ''
                          }}
                        />
                      </div>
                      <div className="">
                        <label className="form-label">GSTIN</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billTogstin"
                          value={editFormData.billTogstin}
                          onChange={handleInputChange}
                          style={{
                            borderColor: editFormData.billTogstin && !validateGST(editFormData.billTogstin) ? 'red' : ''
                          }}
                        />
                      </div>

                    </div>
                    <div className="col-md-6">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
                          <input type="checkbox" checked={sameAsBillTo} onChange={handleSameAsBillTo} />
                          Ship To same as Bill To
                        </label>
                      </div>


                      <h6>Ship To</h6>
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipToName"
                          value={editFormData.shipToName}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipTocompanyname"
                          value={editFormData.shipTocompanyname}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipToAddress"
                          value={editFormData.shipToAddress}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Phone</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipTophone"
                          value={editFormData.shipTophone}
                          onChange={handleInputChange}
                          style={{
                            borderColor: editFormData.shipTophone && !validatePhone(editFormData.shipTophone) ? 'red' : ''
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipToemail"
                          value={editFormData.shipToemail}
                          onChange={handleInputChange}
                          style={{
                            borderColor: editFormData.shipToemail && !validateEmail(editFormData.shipToemail) ? 'red' : ''
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">GSTIN</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipTogstin"
                          value={editFormData.shipTogstin}
                          onChange={handleInputChange}
                          style={{
                            borderColor: editFormData.shipTogstin && !validateGST(editFormData.shipTogstin) ? 'red' : ''
                          }}
                        />
                      </div>
                    </div>

                  </div>
                </div>

                {/* Parts and Items */}
                <div className="row">
                  <div className="col-12">
                    <h6>Invoice Items</h6>

                    {editFormData.parts.map((part, partIndex) => (
                      <div key={partIndex} className="border p-3 mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <input
                            type="text"
                            className="form-control me-2"
                            value={part.title}
                            onChange={(e) => handlePartTitleChange(partIndex, e.target.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => removePart(partIndex)}
                          >
                            Remove Part
                          </button>
                        </div>

                        {/* {part.items.map((item, itemIndex) => (
                          <div key={itemIndex} className="row mb-2">
                            <div className="col-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Description"
                                value={item.description}
                                onChange={(e) => handlePartItemChange(partIndex, itemIndex, 'description', e.target.value)}
                              />
                            </div>
                            <div className="col-3">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Amount"
                                value={item.amount}
                                onChange={(e) => handlePartItemChange(partIndex, itemIndex, 'amount', e.target.value)}
                                step="0.01"
                              />
                            </div>
                            <div className="col-1">
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => removePartItem(partIndex, itemIndex)}
                              >
                                ×
                              </button>
                            </div>
                          </div>
                        ))} */}
                        {part.items.map((item, itemIndex) => (
                          <div key={itemIndex} className="row mb-2 align-items-center">
                            <div className="col-7">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Description"
                                value={item.description}
                                onChange={(e) => handlePartItemChange(partIndex, itemIndex, 'description', e.target.value)}
                              />
                            </div>
                            <div className="col-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Amount"
                                value={item.amount}
                                onChange={(e) => handlePartItemChange(partIndex, itemIndex, 'amount', e.target.value)}
                                step="0.01"
                              />
                            </div>
                            <div className="col-2">
                              <button
                                type="button"
                                className="btn btn-danger btn-sm w-50"
                                onClick={() => removePartItem(partIndex, itemIndex)}
                                disabled={part.items.length <= 1}
                                title={part.items.length <= 1 ? "Cannot remove the last item" : "Remove item"}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        ))}
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm"
                          onClick={() => addPartItem(partIndex)}
                        >
                          + Add Item
                        </button>
                      </div>
                    ))}

                    <button
                      type="button"
                      className="btn btn-primary mb-3"
                      onClick={addNewPart}
                    >
                      + Add New Part
                    </button>
                  </div>
                </div>
                {/* Add this section in the modal body after the parts section */}
                <div className="row">
                  <div className="col-12">
                    <h6>Discounts</h6>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Discount Label</th>
                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(editFormData.discounts || []).map((discount, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Discount description"
                                  value={discount.label}
                                  onChange={(e) => handleDiscountChange(index, 'label', e.target.value)}
                                />
                              </td>
                              <td>

                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Discount amount"
                                  value={discount.amount}
                                  onChange={(e) => handleDiscountChange(index, 'amount', e.target.value)}
                                  step="0.01"
                                />
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDeleteDiscount(index)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={handleAddDiscount}
                    >
                      + Add Discount
                    </button>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">CGST Rate (%)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="cgstRate"
                    value={editFormData.cgstRate}
                    onChange={handleInputChange}
                    step="0.01"
                    onInput={(e) => {
                      const val = e.target.value;
                      if (/^\d{0,2}(\.\d{0,2})?$/.test(val) || val === "") {
                        e.target.value = val;
                      } else {
                        e.target.value = cgstRate;
                      }
                    }}
                    inputMode="decimal"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">SGST Rate (%)</label>
                  <input
                    type="text"
                    className="form-control"
                    name="sgstRate"
                    value={editFormData.sgstRate}
                    onChange={handleInputChange}
                    step="0.01"
                    onInput={(e) => {
                      const val = e.target.value;
                      if (/^\d{0,2}(\.\d{0,2})?$/.test(val) || val === "") {
                        e.target.value = val;
                      } else {
                        e.target.value = sgstRate;
                      }
                    }}
                    inputMode="decimal"
                  />
                </div>                    <div className="mb-3">
                  <label className="form-label">Total Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    name="total"
                    value={editFormData.total}
                    onChange={handleInputChange}
                    step="0.01"

                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Balance Due</label>
                  <input
                    type="text"
                    className="form-control"
                    name="balanceDue"
                    value={editFormData.balanceDue}
                    onChange={handleInputChange}
                    step="0.01"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Total In Words</label>
                  <input
                    type="text"
                    className="form-control"
                    name="totalInWords"
                    value={editFormData.totalInWords}
                    onChange={handleInputChange}
                  />
                </div>
                {/* Additional Fields */}
                <div className="row">
                  <div className="col-12">
                    <h6>Additional Information</h6>
                    <div className="mb-3">
                      <label className="form-label">Thank You Message</label>
                      <textarea
                        className="form-control"
                        name="thankYouMessage"
                        value={editFormData.thankYouMessage}
                        onChange={handleInputChange}
                        rows="3"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Terms & Conditions</label>
                      <textarea
                        className="form-control"
                        name="termsAndConditions"
                        value={editFormData.termsAndConditions}
                        onChange={handleInputChange}
                        rows="4"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Bank Details</label>
                      <textarea
                        className="form-control"
                        name="bankDetails"
                        value={editFormData.bankDetails}
                        onChange={handleInputChange}
                        rows="6"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowEditModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleUpdateInvoice}
                  disabled={updating}
                >
                  {updating ? 'Updating...' : 'Update Invoice'}
                </button>
              </div>


            </div>
          </div>
        </div>
      )}
      {showCloneModal && (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Clone Invoice - {editFormData.invoiceNumber}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCloneModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>

                <div className="row">
                  {/* Basic Details */}

                  <h6>Invoice Details</h6>
                  <div className="mb-3 col-md-3">
                    <label className="form-label">Invoice Number</label>
                    <input
                      type="text"
                      className="form-control"
                      name="invoiceNumber"
                      value={editFormData.invoiceNumber}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="mb-3 col-md-3">
                    <label className="form-label">Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={editFormData.date}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3 col-md-3">
                    <label className="form-label">Terms</label>
                    <input
                      type="text"
                      className="form-control"
                      name="terms"
                      value={editFormData.terms}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="mb-3 col-md-3">
                    <label className="form-label">Due Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="dueDate"
                      value={editFormData.dueDate}
                      onChange={handleInputChange}
                    />
                  </div>
                  {/* <div className="mb-3">
                      <label className="form-label">Balance Due</label>
                      <input
                        type="number"
                        className="form-control"
                        name="balanceDue"
                        value={editFormData.balanceDue}
                        onChange={handleInputChange}
                      />
                    </div> */}



                  {/* Billing & Shipping */}
                  <div className='row'>
                    <div className="col-md-6">
                      <h6>Bill To</h6>
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billToName"
                          value={editFormData.billToName}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billtocompanyname"
                          value={editFormData.billtocompanyname}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billToAddress"
                          value={editFormData.billToAddress}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Phone</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billTophone"
                          value={editFormData.billTophone}
                          onChange={handleInputChange}
                          maxLength={13}
                          style={{
                            borderColor: editFormData.billTophone && !validatePhone(editFormData.billTophone) ? 'red' : ''
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billToemail"
                          value={editFormData.billToemail}
                          onChange={handleInputChange}
                          style={{
                            borderColor: editFormData.billToemail && !validateEmail(editFormData.billToemail) ? 'red' : ''
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">GSTIN</label>
                        <input
                          type="text"
                          className="form-control"
                          name="billTogstin"
                          value={editFormData.billTogstin}
                          onChange={handleInputChange}
                          maxLength={15}
                          style={{
                            borderColor: editFormData.billTogstin && !validateGST(editFormData.billTogstin) ? 'red' : ''
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
                          <input type="checkbox" checked={sameAsBillTo} onChange={handleSameAsBillTo} />
                          Ship To same as Bill To
                        </label>
                      </div>
                      <h6>Ship To</h6>
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipToName"
                          value={editFormData.shipToName}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Company Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipTocompanyname"
                          value={editFormData.shipTocompanyname}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipToAddress"
                          value={editFormData.shipToAddress}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Phone</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipTophone"
                          value={editFormData.shipTophone}
                          onChange={handleInputChange}
                          maxLength={13}
                          style={{
                            borderColor: editFormData.shipTophone && !validatePhone(editFormData.shipTophone) ? 'red' : ''
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipToemail"
                          value={editFormData.shipToemail}
                          onChange={handleInputChange}
                          style={{
                            borderColor: editFormData.shipToemail && !validateEmail(editFormData.shipToemail) ? 'red' : ''
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">GSTIN</label>
                        <input
                          type="text"
                          className="form-control"
                          name="shipTogstin"
                          value={editFormData.shipTogstin}
                          onChange={handleInputChange}
                          maxLength={15}
                          style={{
                            borderColor: editFormData.shipTogstin && !validateGST(editFormData.shipTogstin) ? 'red' : ''
                          }}
                        />
                      </div>
                    </div>

                  </div>
                </div>

                {editFormData.parts.map((part, partIndex) => (
                  <div key={partIndex} className="border p-3 mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <input
                        type="text"
                        className="form-control me-2"
                        value={part.title}
                        onChange={(e) => handlePartTitleChange(partIndex, e.target.value)}
                      />
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => removePart(partIndex)}
                      >
                        Remove Part
                      </button>
                    </div>

                    {/* {part.items.map((item, itemIndex) => (
                          <div key={itemIndex} className="row mb-2">
                            <div className="col-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Description"
                                value={item.description}
                                onChange={(e) => handlePartItemChange(partIndex, itemIndex, 'description', e.target.value)}
                              />
                            </div>
                            <div className="col-3">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Amount"
                                value={item.amount}
                                onChange={(e) => handlePartItemChange(partIndex, itemIndex, 'amount', e.target.value)}
                                step="0.01"
                              />
                            </div>
                            <div className="col-1">
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => removePartItem(partIndex, itemIndex)}
                              >
                                ×
                              </button>
                            </div>
                          </div>
                        ))} */}
                    {part.items.map((item, itemIndex) => (
                      <div key={itemIndex} className="row mb-2 align-items-center">
                        <div className="col-7">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Description"
                            value={item.description}
                            onChange={(e) => handlePartItemChange(partIndex, itemIndex, 'description', e.target.value)}
                          />
                        </div>
                        <div className="col-3">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Amount"
                            value={item.amount}
                            onChange={(e) => handlePartItemChange(partIndex, itemIndex, 'amount', e.target.value)}
                            step="0.01"
                          />
                        </div>
                        <div className="col-2">
                          <button
                            type="button"
                            className="btn btn-danger btn-sm w-50"
                            onClick={() => removePartItem(partIndex, itemIndex)}
                            disabled={part.items.length <= 1}
                            title={part.items.length <= 1 ? "Cannot remove the last item" : "Remove item"}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    ))}
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => addPartItem(partIndex)}
                    >
                      + Add Item
                    </button>
                  </div>
                ))}

                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={addNewPart}
                >
                  + Add New Part
                </button>


                {/* Add this section in the modal body after the parts section */}
                <div className="row">
                  <div className="col-12">
                    <h6>Discounts</h6>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Discount Label</th>
                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(editFormData.discounts || []).map((discount, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Discount description"
                                  value={discount.label}
                                  onChange={(e) => handleDiscountChange(index, 'label', e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Discount amount"
                                  value={discount.amount}
                                  onChange={(e) => handleDiscountChange(index, 'amount', e.target.value)}
                                  step="0.01"
                                />
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDeleteDiscount(index)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={handleAddDiscount}
                    >
                      + Add Discount
                    </button>
                  </div>
                </div>
                {/* Parts and Items */}
                <div className="row">
                  <div className="col-12">
                    <h6>Invoice Items</h6>
                    <div className="mb-3">
                      <label className="form-label">CGST Rate (%)</label>
                      <input
                        type="text"
                        className="form-control"
                        name="cgstRate"
                        value={editFormData.cgstRate}
                        onChange={handleInputChange}
                        step="0.01"
                        onInput={(e) => {
                          const val = e.target.value;
                          if (/^\d{0,2}(\.\d{0,2})?$/.test(val) || val === "") {
                            e.target.value = val;
                          } else {
                            e.target.value = cgstRate;
                          }
                        }}
                        inputMode="decimal"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">SGST Rate (%)</label>
                      <input
                        type="text"
                        className="form-control"
                        name="sgstRate"
                        value={editFormData.sgstRate}
                        onChange={handleInputChange}
                        step="0.01"
                        onInput={(e) => {
                          const val = e.target.value;
                          if (/^\d{0,2}(\.\d{0,2})?$/.test(val) || val === "") {
                            e.target.value = val;
                          } else {
                            e.target.value = sgstRate;
                          }
                        }}
                        inputMode="decimal"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Total Amount</label>
                      <input
                        type="text"
                        className="form-control"
                        name="total"
                        value={editFormData.total}
                        onChange={handleInputChange}
                        step="0.01"

                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Balance Due</label>
                      <input
                        type="text"
                        className="form-control"
                        name="balanceDue"
                        value={editFormData.balanceDue}
                        onChange={handleInputChange}
                        step="0.01"
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Total In Words</label>
                      <input
                        type="text"
                        className="form-control"
                        name="totalInWords"
                        value={editFormData.totalInWords}
                        onChange={handleInputChange}
                      />
                    </div>
                    {/* Additional Fields */}
                    <div className="row">
                      <div className="col-12">
                        <h6>Additional Information</h6>
                        <div className="mb-3">
                          <label className="form-label">Thank You Message</label>
                          <textarea
                            className="form-control"
                            name="thankYouMessage"
                            value={editFormData.thankYouMessage}
                            onChange={handleInputChange}
                            rows="3"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Terms & Conditions</label>
                          <textarea
                            className="form-control"
                            name="termsAndConditions"
                            value={editFormData.termsAndConditions}
                            onChange={handleInputChange}
                            rows="4"
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">Bank Details</label>
                          <textarea
                            className="form-control"
                            name="bankDetails"
                            value={editFormData.bankDetails}
                            onChange={handleInputChange}
                            rows="6"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowCloneModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleSaveClone}
                    disabled={updating}
                  >
                    {updating ? 'Creating...' : 'Create Invoice'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Modal Backdrop */}
      {showEditModal && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default InvoiceList;
